import { defineComponent as H, computed as i, createElementBlock as t, openBlock as e, normalizeClass as r, createCommentVNode as u, renderSlot as xe, createElementVNode as l, toDisplayString as p, resolveComponent as ye, normalizeStyle as P, createBlock as W, withCtx as ce, createTextVNode as ie, createVNode as R, resolveDynamicComponent as te, Fragment as j, renderList as I, ref as J, onMounted as de, onUnmounted as ve, mergeProps as oe, unref as U, inject as ue, reactive as Ce, withModifiers as ke, withDirectives as le, vModelText as ae } from "vue";
import { useRouter as Z, useRoute as $e } from "vue-router";
const _e = ["src", "alt", "width", "height", "loading", "sizes"], Rm = /* @__PURE__ */ H({
  __name: "AssetImage",
  props: {
    src: {},
    alt: { default: "" },
    width: {},
    height: {},
    class: {},
    loading: { default: "lazy" },
    sizes: {}
  },
  setup(w) {
    const s = w, a = i(() => s.class), n = i(() => s.src ? (s.src.startsWith("http://") || s.src.startsWith("https://"), s.src) : "");
    return (b, v) => (e(), t("img", {
      src: n.value,
      alt: b.alt,
      width: b.width,
      height: b.height,
      class: r(a.value),
      loading: b.loading,
      sizes: b.sizes
    }, null, 10, _e));
  }
});
function Te() {
  const w = (m) => {
    if ("schemaVersion" in m)
      return m.schemaVersion;
    const o = m.__component.match(/-v(\d+)$/);
    return o ? `${o[1]}.0.0` : "1.0.0";
  }, s = (m) => {
    const {
      variant: d,
      size: o,
      density: f,
      textPosition: h,
      shortCTA: $,
      fullCTA: x,
      CTALink: _,
      buttonStyle: T,
      ...z
    } = m, N = a(d, o, f);
    return {
      ...z,
      style: N,
      cta: $ || x ? {
        text: $ || x,
        link: _,
        style: T || "primary"
      } : void 0,
      // Keep original props for fallback
      _originalVersion: "1.0.0"
    };
  }, a = (m, d, o, f) => m === "hero" ? d === "dramatic" || d === "extra-large" ? "hero-large" : "hero-medium" : m === "cta" ? o === "compact" ? "cta-compact" : "cta-standard" : m === "overlay-box-bottom" || m === "overlay-box-right" ? "overlay-positioned" : m === "announcement" ? "announcement" : "banner-simple";
  return {
    getComponentVersion: w,
    transformComponentProps: (m) => {
      const d = w(m);
      return m.__component === "cms.banner-section" && d === "1.0.0" ? {
        ...s(m),
        __component: m.__component,
        id: m.id
      } : m;
    },
    getVersionedComponentName: (m) => m.__component.replace(/-(v\d+)?$/, ""),
    isVersionSupported: (m) => {
      const d = w(m), [o] = d.split(".").map(Number);
      return o >= 1 && o <= 2;
    },
    getVersionWarnings: (m) => {
      const d = [], o = w(m), [f, h] = o.split(".").map(Number);
      return f > 2 && d.push(`Component version ${o} is newer than supported. Some features may not work correctly.`), f === 1 && h > 0 && d.push(`Using compatibility mode for v${o}. Consider updating to latest schema.`), d;
    },
    transformBannerV1ToV2: s,
    consolidateBannerStyle: a
  };
}
const Fm = {
  "cms.banner-section": ["1.0.0", "2.0.0"],
  "cms.banner-section-v2": ["2.0.0"],
  "cms.flex-section": ["1.0.0"],
  "cms.card-section": ["1.0.0"],
  "cms.text-section": ["1.0.0"],
  "cms.accordion-section": ["1.0.0"],
  "cms.contact-form": ["1.0.0"],
  "cms.image-gallery": ["1.0.0"],
  "cms.thank-you": ["1.0.0"],
  "cms.gallery-nav": ["1.0.0"]
}, Ym = {
  banner: "1.0.0",
  flex: "1.0.0",
  card: "1.0.0",
  "contact-form": "1.0.0",
  text: "1.0.0",
  "image-gallery": "1.0.0",
  "thank-you": "1.0.0",
  accordion: "1.0.0",
  "gallery-nav": "1.0.0"
}, ze = ["type", "disabled"], qe = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status"
}, je = { key: 2 }, O = /* @__PURE__ */ H({
  __name: "BootstrapButton",
  props: {
    label: {},
    icon: {},
    iconPos: { default: "left" },
    severity: { default: "primary" },
    outlined: { type: Boolean },
    text: { type: Boolean },
    rounded: { type: Boolean },
    size: {},
    disabled: { type: Boolean },
    loading: { type: Boolean },
    type: { default: "button" }
  },
  emits: ["click"],
  setup(w) {
    const s = w, a = i(() => {
      const v = ["btn"], c = s.severity || "primary";
      return s.text ? v.push("btn-link", `text-${c}`) : s.outlined ? v.push(`btn-outline-${c}`) : v.push(`btn-${c}`), s.size === "small" && v.push("btn-sm"), s.size === "large" && v.push("btn-lg"), s.rounded && v.push("rounded-pill"), v.join(" ");
    }), n = {
      "pi pi-arrow-right": "bi bi-arrow-right",
      "pi pi-arrow-left": "bi bi-arrow-left",
      "pi pi-times": "bi bi-x-lg",
      "pi pi-check": "bi bi-check-lg",
      "pi pi-home": "bi bi-house",
      "pi pi-bars": "bi bi-list",
      "pi pi-globe": "bi bi-globe",
      "pi pi-external-link": "bi bi-box-arrow-up-right",
      "pi pi-angle-down": "bi bi-chevron-down",
      "pi pi-angle-up": "bi bi-chevron-up",
      "pi pi-angle-right": "bi bi-chevron-right",
      "pi pi-angle-left": "bi bi-chevron-left",
      "pi pi-search": "bi bi-search",
      "pi pi-plus": "bi bi-plus-lg",
      "pi pi-minus": "bi bi-dash-lg",
      "pi pi-trash": "bi bi-trash",
      "pi pi-pencil": "bi bi-pencil",
      "pi pi-envelope": "bi bi-envelope",
      "pi pi-phone": "bi bi-telephone",
      "pi pi-send": "bi bi-send",
      "pi pi-eye": "bi bi-eye"
    }, b = i(() => s.icon ? n[s.icon] || s.icon : "");
    return (v, c) => (e(), t("button", {
      type: v.type,
      class: r(a.value),
      disabled: v.disabled || v.loading,
      onClick: c[0] || (c[0] = (m) => v.$emit("click", m))
    }, [
      v.loading ? (e(), t("span", qe, [...c[1] || (c[1] = [
        l("span", { class: "visually-hidden" }, "Loading...", -1)
      ])])) : u("", !0),
      v.icon && v.iconPos !== "right" ? (e(), t("i", {
        key: 1,
        class: r([b.value, v.label ? "me-2" : ""])
      }, null, 2)) : u("", !0),
      v.label ? (e(), t("span", je, p(v.label), 1)) : xe(v.$slots, "default", { key: 3 }),
      v.icon && v.iconPos === "right" ? (e(), t("i", {
        key: 4,
        class: r([b.value, "ms-2"])
      }, null, 2)) : u("", !0)
    ], 10, ze));
  }
}), Se = { class: "container d-flex align-items-center justify-content-center gap-3" }, Ae = { class: "container px-3" }, Ie = { class: "d-flex flex-column flex-md-row align-items-center justify-content-between gap-3" }, Me = { class: "text-center text-md-start" }, Le = { class: "fs-5 fw-bold mb-1" }, Be = {
  key: 0,
  class: "small opacity-75 mb-0"
}, He = {
  key: 1,
  class: "mt-5"
}, Pe = {
  key: 0,
  class: "position-absolute top-0 start-0 w-100 h-100"
}, Ne = ["src", "alt"], Ee = {
  class: "container px-3",
  style: { "max-width": "896px" }
}, Ue = {
  key: 1,
  class: "mt-5"
}, Ve = /* @__PURE__ */ H({
  __name: "BannerSection",
  props: {
    __component: {},
    id: {},
    title: {},
    displayTitle: {},
    description: {},
    subtitle: {},
    shortCTA: {},
    fullCTA: {},
    CTALink: {},
    variant: {},
    textPosition: {},
    size: {},
    density: {},
    backgroundType: {},
    backgroundColor: {},
    backgroundGradient: {},
    UUID: {},
    Image: {},
    overlayOpacity: {},
    buttonStyle: {}
  },
  setup(w) {
    const s = Z(), a = w, n = (g) => g || "", b = {
      small: "banner-py-small",
      medium: "banner-py-medium",
      large: "banner-py-large",
      "extra-large": "banner-py-xlarge",
      professional: "banner-py-professional",
      dramatic: "banner-py-dramatic"
    }, v = {
      compact: "d-flex flex-column gap-2",
      normal: "d-flex flex-column gap-3",
      loose: "d-flex flex-column gap-4"
    }, c = i(() => {
      const g = [];
      return a.variant === "cta" && g.push(b[a.size || "large"]), a.variant === "banner" && g.push("banner-py-banner"), a.backgroundType === "gradient" || !a.backgroundType && a.variant === "cta" ? g.push("bg-gradient-primary text-white") : !a.backgroundColor && a.variant !== "background-image" && a.variant !== "fullscreen-nav" && g.push("bg-surface-50"), g.join(" ");
    }), m = i(() => "bg-primary text-white"), d = i(() => {
      const g = {};
      return a.backgroundColor && (g.backgroundColor = a.backgroundColor), a.backgroundGradient && (g.background = a.backgroundGradient), g;
    }), o = i(() => a.variant === "fullscreen-nav" ? "banner-py-fullscreen" : b[a.size || "large"]), f = i(() => {
      const g = a.textPosition || "center", B = ["banner-max-w-4xl", v[a.density || "normal"]];
      switch (g) {
        case "left":
          return [...B, "me-auto text-start"].join(" ");
        case "right":
          return [...B, "ms-auto text-end"].join(" ");
        default:
          return [...B, "mx-auto text-center"].join(" ");
      }
    }), h = i(() => {
      const g = a.size || "large", y = ["fw-bold lh-sm", a.variant === "background-image" || a.variant === "fullscreen-nav" ? "text-white drop-shadow-lg" : "text-surface-900"], q = {
        small: "display-6",
        medium: "display-5",
        large: "display-4",
        "extra-large": "display-3",
        professional: "display-5",
        dramatic: "display-2"
      };
      return [...y, q[g]].join(" ");
    }), $ = i(() => {
      const g = a.variant === "background-image" || a.variant === "fullscreen-nav", B = a.size || "large", y = ["banner-max-w-3xl", g ? "text-white opacity-75 drop-shadow-md" : "text-surface-700"], q = {
        small: "fs-6",
        medium: "fs-5",
        large: "fs-4",
        "extra-large": "fs-3",
        professional: "fs-6",
        dramatic: "fs-3"
      };
      return [...y, q[B], a.textPosition === "center" ? "mx-auto" : ""].join(" ");
    }), x = i(() => a.variant === "overlay-box-bottom" ? "align-items-end justify-content-center pb-4 pb-md-5" : "align-items-center justify-content-end pe-4 pe-md-5"), _ = i(() => {
      const g = ["overlay-box rounded-3 shadow-lg p-4 p-md-5"];
      return a.variant === "overlay-box-right" && g.push("me-4"), g.join(" ");
    }), T = i(() => "display-6 fw-bold text-surface-900 mb-2"), z = i(() => "text-surface-700 lh-relaxed"), N = i(() => {
      const g = a.size || "large", B = ["fw-bold mb-3"], y = {
        small: "display-6",
        medium: "display-5",
        large: "display-4",
        "extra-large": "display-3",
        professional: "display-6",
        dramatic: "display-3"
      };
      return [...B, y[g]].join(" ");
    }), M = i(() => "fs-5 mx-auto opacity-75 banner-max-w-2xl"), k = () => ({
      small: "400px",
      medium: "500px",
      large: "600px",
      "extra-large": "700px",
      professional: "450px",
      dramatic: "800px"
    })[a.size || "large"], S = () => {
      const g = a.size || "large";
      return g === "large" || g === "extra-large" || g === "dramatic" ? a.fullCTA || a.shortCTA : a.shortCTA || a.fullCTA;
    }, D = () => {
      const g = a.size || "large";
      if (!(g === "small" || g === "professional"))
        return "large";
    }, A = () => {
      a.CTALink && (a.CTALink.startsWith("http") ? window.open(a.CTALink, "_blank") : s.push(a.CTALink));
    };
    return (g, B) => {
      var q, L, G;
      const y = ye("router-link");
      return g.variant === "announcement" ? (e(), t("section", {
        key: 0,
        class: r(["w-100 py-2 px-3 text-center small", m.value]),
        style: P(d.value)
      }, [
        l("div", Se, [
          l("span", null, p(g.title), 1),
          g.CTALink && g.shortCTA ? (e(), W(y, {
            key: 0,
            to: g.CTALink,
            class: "text-decoration-underline fw-semibold announcement-link"
          }, {
            default: ce(() => [
              ie(p(g.shortCTA), 1)
            ]),
            _: 1
          }, 8, ["to"])) : u("", !0)
        ])
      ], 6)) : g.variant === "banner" ? (e(), t("section", {
        key: 1,
        class: r([c.value, "w-100"]),
        style: P(d.value)
      }, [
        l("div", Ae, [
          l("div", Ie, [
            l("div", Me, [
              l("h3", Le, p(g.title), 1),
              g.description ? (e(), t("p", Be, p(g.description), 1)) : u("", !0)
            ]),
            g.CTALink && (g.shortCTA || g.fullCTA) ? (e(), W(O, {
              key: 0,
              label: g.shortCTA || g.fullCTA,
              onClick: A,
              severity: g.buttonStyle === "outline" ? "secondary" : void 0,
              outlined: g.buttonStyle === "outline",
              class: "text-nowrap"
            }, null, 8, ["label", "severity", "outlined"])) : u("", !0)
          ])
        ])
      ], 6)) : g.variant === "hero" || g.variant === "background-image" || g.variant === "fullscreen-nav" ? (e(), t("section", {
        key: 2,
        class: r([
          c.value,
          "position-relative w-100 overflow-hidden",
          g.variant === "fullscreen-nav" ? "min-vh-100" : ""
        ]),
        style: P(g.variant === "background-image" || g.variant === "fullscreen-nav" ? {
          backgroundImage: (q = g.Image) != null && q.url ? `url(${n(g.Image.url)})` : "none",
          backgroundSize: "cover",
          backgroundPosition: "center"
        } : d.value)
      }, [
        (g.variant === "background-image" || g.variant === "fullscreen-nav") && ((L = g.Image) != null && L.url) ? (e(), t("div", {
          key: 0,
          class: "position-absolute top-0 start-0 w-100 h-100 bg-dark",
          style: P({ opacity: g.overlayOpacity || 0.4 })
        }, null, 4)) : u("", !0),
        l("div", {
          class: r(["position-relative z-10 container px-3", o.value])
        }, [
          l("div", {
            class: r(f.value)
          }, [
            l("h1", {
              class: r(h.value)
            }, p(g.displayTitle || g.title), 3),
            g.subtitle || g.description ? (e(), t("p", {
              key: 0,
              class: r($.value)
            }, p(g.subtitle || g.description), 3)) : u("", !0),
            g.CTALink && (g.shortCTA || g.fullCTA) ? (e(), t("div", He, [
              R(O, {
                label: S(),
                onClick: A,
                size: D(),
                severity: g.buttonStyle === "secondary" ? "secondary" : void 0,
                outlined: g.buttonStyle === "outline",
                class: "fw-semibold hover-shadow-lg"
              }, null, 8, ["label", "size", "severity", "outlined"])
            ])) : u("", !0)
          ], 2)
        ], 2)
      ], 6)) : g.variant === "overlay-box-bottom" || g.variant === "overlay-box-right" ? (e(), t("section", {
        key: 3,
        class: "position-relative w-100 overflow-hidden",
        style: P({ minHeight: k() })
      }, [
        (G = g.Image) != null && G.url ? (e(), t("div", Pe, [
          l("img", {
            src: n(g.Image.url),
            alt: g.Image.alternativeText || g.title,
            class: "w-100 h-100 object-fit-cover"
          }, null, 8, Ne),
          B[0] || (B[0] = l("div", { class: "position-absolute top-0 start-0 w-100 h-100 overlay-gradient-up" }, null, -1))
        ])) : (e(), t("div", {
          key: 1,
          class: "position-absolute top-0 start-0 w-100 h-100",
          style: P(d.value)
        }, null, 4)),
        l("div", {
          class: r(["position-relative z-10 h-100 d-flex", x.value])
        }, [
          l("div", {
            class: r(_.value)
          }, [
            l("h2", {
              class: r(T.value)
            }, p(g.title), 3),
            g.description ? (e(), t("p", {
              key: 0,
              class: r(z.value)
            }, p(g.description), 3)) : u("", !0),
            g.CTALink && (g.shortCTA || g.fullCTA) ? (e(), W(O, {
              key: 1,
              label: g.shortCTA || g.fullCTA,
              onClick: A,
              severity: g.buttonStyle === "secondary" ? "secondary" : void 0,
              outlined: g.buttonStyle === "outline",
              class: "mt-3"
            }, null, 8, ["label", "severity", "outlined"])) : u("", !0)
          ], 2)
        ], 2)
      ], 4)) : (e(), t("section", {
        key: 4,
        class: r([c.value, "text-center"]),
        style: P(d.value)
      }, [
        l("div", Ee, [
          l("h2", {
            class: r(N.value)
          }, p(g.title), 3),
          g.description ? (e(), t("p", {
            key: 0,
            class: r(M.value)
          }, p(g.description), 3)) : u("", !0),
          g.CTALink && (g.shortCTA || g.fullCTA) ? (e(), t("div", Ue, [
            R(O, {
              label: g.shortCTA || g.fullCTA,
              onClick: A,
              size: D(),
              severity: g.buttonStyle === "secondary" ? "secondary" : void 0,
              outlined: g.buttonStyle === "outline",
              class: "fw-semibold"
            }, null, 8, ["label", "size", "severity", "outlined"])
          ])) : u("", !0)
        ])
      ], 6));
    };
  }
}), E = (w, s) => {
  const a = w.__vccOpts || w;
  for (const [n, b] of s)
    a[n] = b;
  return a;
}, Oe = /* @__PURE__ */ E(Ve, [["__scopeId", "data-v-e0f8ae41"]]);
function We(w, s) {
  var v, c;
  const a = [], n = /<(p|h[1-6]|ul|ol|blockquote|a)(\s[^>]*)?>[\s\S]*?<\/\1>|([^<]+)/gi;
  let b;
  for (; (b = n.exec(w)) !== null; ) {
    const m = b[0], d = (v = b[1]) == null ? void 0 : v.toLowerCase();
    if (!d) {
      const h = (c = b[3]) == null ? void 0 : c.trim();
      h && a.push({ type: "paragraph", content: h, props: { ...s } });
      continue;
    }
    const o = m.match(new RegExp(`^<${d}[^>]*>([\\s\\S]*)<\\/${d}>$`, "i")), f = o ? o[1] : "";
    switch (d) {
      case "p":
        a.push({ type: "paragraph", content: f, props: { ...s } });
        break;
      case "h1":
      case "h2":
      case "h3":
      case "h4":
      case "h5":
      case "h6":
        a.push({
          type: "heading",
          content: f,
          props: { level: parseInt(d.slice(1)), ...s }
        });
        break;
      case "ul":
      case "ol": {
        const h = [], $ = /<li[^>]*>([\s\S]*?)<\/li>/gi;
        let x;
        for (; (x = $.exec(f)) !== null; )
          h.push(x[1]);
        a.push({
          type: "list",
          props: { items: h, type: d, ...s }
        });
        break;
      }
      case "blockquote":
        a.push({ type: "blockquote", content: f, props: { ...s } });
        break;
      case "a": {
        const h = m.match(/href=["']([^"']*)["']/);
        a.push({
          type: "link",
          content: f,
          props: { href: h ? h[1] : "", ...s }
        });
        break;
      }
    }
  }
  return a;
}
function De() {
  function w(a, n) {
    if (typeof document > "u")
      return We(a, n);
    const b = [], v = document.createElement("div");
    v.innerHTML = a;
    const c = (m) => {
      var f;
      if (m.nodeType === Node.TEXT_NODE) {
        const h = (f = m.textContent) == null ? void 0 : f.trim();
        h && b.push({
          type: "paragraph",
          content: h,
          props: { ...n }
        });
        return;
      }
      if (m.nodeType !== Node.ELEMENT_NODE) return;
      const d = m, o = d.tagName.toLowerCase();
      switch (o) {
        case "p":
          b.push({
            type: "paragraph",
            content: d.innerHTML,
            props: { ...n }
          });
          break;
        case "h1":
        case "h2":
        case "h3":
        case "h4":
        case "h5":
        case "h6":
          b.push({
            type: "heading",
            content: d.innerHTML,
            props: {
              level: parseInt(o.slice(1)),
              ...n
            }
          });
          break;
        case "ul":
        case "ol":
          const h = Array.from(d.querySelectorAll("li")).map(($) => $.innerHTML);
          b.push({
            type: "list",
            props: {
              items: h,
              type: o,
              ...n
            }
          });
          break;
        case "blockquote":
          b.push({
            type: "blockquote",
            content: d.innerHTML,
            props: { ...n }
          });
          break;
        case "a":
          b.push({
            type: "link",
            content: d.innerHTML,
            props: {
              href: d.getAttribute("href") || "",
              ...n
            }
          });
          break;
        default:
          d.childNodes.forEach(c);
          break;
      }
    };
    return v.childNodes.forEach(c), b;
  }
  function s(a, n) {
    return a ? /<[a-z!/][\s\S]*?>/i.test(a) ? w(a, n) : a.replace(/\r\n/g, `
`).split(/\n{2,}/).map((v) => v.trim()).filter(Boolean).map((v) => ({ type: "paragraph", content: v.replace(/\n/g, "<br>"), props: { ...n } })) : [];
  }
  return {
    parseHtml: w,
    parseContent: s
  };
}
const Ge = ["innerHTML"], Re = /* @__PURE__ */ H({
  __name: "TextParagraph",
  props: {
    content: {},
    layout: {},
    density: {},
    emphasis: {},
    hierarchy: {}
  },
  setup(w) {
    const s = w, a = i(() => {
      const n = "text-surface-700", b = {
        flow: "lh-relaxed",
        highlight: "text-center fst-italic",
        structured: "lh-base",
        compact: "lh-tight"
      }, v = {
        tight: "mb-2",
        normal: "mb-3",
        loose: "mb-4"
      }, c = {
        subtle: "text-surface-600 fw-light",
        normal: "text-surface-700 fw-normal",
        strong: "text-surface-900 fw-medium"
      }, d = (s.layout === "highlight" ? {
        subtle: "text-surface-700 fw-light fs-5",
        normal: "text-surface-800 fw-normal fs-4",
        strong: "text-surface-900 fw-medium highlight-strong-text"
      } : {})[s.emphasis] || c[s.emphasis];
      return `${n} ${b[s.layout]} ${v[s.density]} ${d}`;
    });
    return (n, b) => (e(), t("p", {
      class: r(a.value),
      innerHTML: n.content
    }, null, 10, Ge));
  }
}), pe = /* @__PURE__ */ E(Re, [["__scopeId", "data-v-f96a245c"]]), Fe = /* @__PURE__ */ H({
  __name: "TextHeading",
  props: {
    content: {},
    level: {},
    layout: {},
    density: {},
    emphasis: {},
    hierarchy: {}
  },
  setup(w) {
    const s = w, a = i(() => `h${s.level}`), n = i(() => {
      const b = {
        1: "heading-h1",
        2: "heading-h2",
        3: "heading-h3",
        4: "heading-h4",
        5: "heading-h5",
        6: "heading-h6"
      }, v = {
        flat: { size: "", spacing: "" },
        structured: { size: "", spacing: "" },
        dramatic: {
          size: s.level <= 2 ? "heading-dramatic-top" : s.level <= 4 ? "heading-dramatic-mid" : "",
          spacing: ""
        }
      }, c = {
        flow: "",
        highlight: "text-center",
        structured: "",
        compact: ""
      }, m = {
        tight: {
          1: "mt-3 mb-2",
          2: "mt-3 mb-2",
          3: "mt-2 mb-2",
          4: "mt-2 mb-1",
          5: "mt-2 mb-1",
          6: "mt-2 mb-1"
        },
        normal: {
          1: "mt-4 mb-3",
          2: "mt-4 mb-3",
          3: "mt-4 mb-2",
          4: "mt-4 mb-2",
          5: "mt-3 mb-2",
          6: "mt-3 mb-2"
        },
        loose: {
          1: "mt-5 mb-4",
          2: "mt-5 mb-4",
          3: "mt-5 mb-3",
          4: "mt-4 mb-3",
          5: "mt-4 mb-2",
          6: "mt-4 mb-2"
        }
      }, d = {
        subtle: "fw-medium text-surface-700",
        normal: "fw-bold text-surface-900",
        strong: "fw-bolder text-surface-900"
      }, f = v[s.hierarchy].size || b[s.level], h = m[s.density] && m[s.density][s.level] ? m[s.density][s.level] : "mt-3 mb-2";
      return `${d[s.emphasis]} ${f} ${c[s.layout]} ${h}`;
    });
    return (b, v) => (e(), W(te(a.value), {
      class: r(n.value),
      innerHTML: b.content
    }, null, 8, ["class", "innerHTML"]));
  }
}), Ye = /* @__PURE__ */ E(Fe, [["__scopeId", "data-v-502002d1"]]), Ke = ["innerHTML"], Je = /* @__PURE__ */ H({
  __name: "TextList",
  props: {
    items: {},
    type: {},
    layout: {},
    density: {},
    emphasis: {},
    hierarchy: {}
  },
  setup(w) {
    const s = w, a = i(() => s.type), n = i(() => {
      const v = s.type === "ul" ? "list-disc" : "list-decimal", c = {
        flow: "ms-4",
        highlight: "ms-2 text-start",
        structured: "ms-4 list-spaced",
        compact: "ms-3"
      }, m = {
        tight: "mb-2",
        normal: "mb-3",
        loose: "mb-4"
      };
      return `${v} ${c[s.layout]} ${m[s.density]}`;
    }), b = i(() => {
      const v = "text-surface-700", c = {
        flow: "mb-2",
        highlight: "mb-1 fw-normal fs-5",
        structured: "mb-1 lh-relaxed",
        compact: "mb-1 fs-sm lh-tight"
      }, m = {
        subtle: "text-surface-600 fw-light",
        normal: "text-surface-700 fw-normal",
        strong: "text-surface-900 fw-medium"
      };
      return `${v} ${c[s.layout]} ${m[s.emphasis]}`;
    });
    return (v, c) => (e(), W(te(a.value), {
      class: r(n.value)
    }, {
      default: ce(() => [
        (e(!0), t(j, null, I(v.items, (m, d) => (e(), t("li", {
          key: d,
          class: r(b.value),
          innerHTML: m
        }, null, 10, Ke))), 128))
      ]),
      _: 1
    }, 8, ["class"]));
  }
}), Qe = /* @__PURE__ */ E(Je, [["__scopeId", "data-v-a35b640e"]]), Xe = ["innerHTML"], Ze = /* @__PURE__ */ H({
  __name: "TextBlockquote",
  props: {
    content: {},
    layout: {},
    density: {},
    emphasis: {},
    hierarchy: {}
  },
  setup(w) {
    const s = w, a = i(() => {
      const n = "border-start border-4 ps-3 fst-italic", b = {
        flow: "border-primary-500",
        highlight: "border-primary-300 bg-primary-50 py-2 rounded-end text-center",
        structured: "blockquote-surface bg-surface-50 py-2 rounded",
        compact: "border-primary-400 py-1"
      }, v = {
        tight: "my-2",
        normal: "my-4",
        loose: "my-4"
      }, c = {
        subtle: "text-surface-600 fw-light",
        normal: "text-surface-700 fw-normal",
        strong: "text-surface-900 fw-medium fs-5"
      };
      return `${n} ${b[s.layout]} ${v[s.density]} ${c[s.emphasis]}`;
    });
    return (n, b) => (e(), t("blockquote", {
      class: r(a.value),
      innerHTML: n.content
    }, null, 10, Xe));
  }
}), et = /* @__PURE__ */ E(Ze, [["__scopeId", "data-v-408055e6"]]), tt = ["href", "innerHTML"], st = /* @__PURE__ */ H({
  __name: "TextLink",
  props: {
    content: {},
    href: {},
    layout: {},
    density: {},
    emphasis: {},
    hierarchy: {}
  },
  setup(w) {
    const s = w, a = i(() => {
      const n = "text-primary-600 text-decoration-underline link-base", b = {
        flow: "",
        highlight: "fw-medium fs-5",
        structured: "text-decoration-none link-structured",
        compact: "fs-sm"
      }, v = {
        subtle: "link-subtle",
        normal: "link-normal",
        strong: "link-strong fw-semibold"
      };
      return `${n} ${b[s.layout]} ${v[s.emphasis]}`;
    });
    return (n, b) => (e(), t("a", {
      href: n.href,
      class: r(a.value),
      innerHTML: n.content
    }, null, 10, tt));
  }
}), lt = /* @__PURE__ */ E(st, [["__scopeId", "data-v-79912e48"]]), at = {
  key: 0,
  class: "row g-4 align-items-center"
}, ot = ["src", "alt"], it = {
  key: 0,
  class: "mb-4"
}, nt = ["src", "alt"], rt = /* @__PURE__ */ H({
  __name: "TextSection",
  props: {
    __component: {},
    id: {},
    title: {},
    subtitle: {},
    content: {},
    layout: {},
    density: {},
    spacing: {},
    emphasis: {},
    hierarchy: {},
    Image: {},
    imagePosition: {},
    imageSize: {},
    textAlign: {},
    showDivider: { type: Boolean },
    equalHeight: { type: Boolean }
  },
  setup(w) {
    const s = w, { parseContent: a } = De(), n = i(() => ({
      compact: "",
      normal: "",
      airy: "py-6 py-md-10",
      spacious: "py-10 py-md-16"
    })[s.spacing || "normal"]), b = i(() => s.layout || "flow"), v = i(() => s.density || "normal"), c = i(() => s.emphasis || "normal"), m = i(() => s.hierarchy || "structured"), d = i(() => s.imageSize || "medium"), o = i(() => s.textAlign || "left"), f = J(typeof window < "u" ? window.innerWidth : 1024);
    i(() => f.value < 768);
    const h = () => {
      f.value = window.innerWidth;
    };
    de(() => {
      f.value = window.innerWidth, window.addEventListener("resize", h);
    }), ve(() => {
      window.removeEventListener("resize", h);
    });
    const $ = (A) => A || "", x = i(() => {
      if (!s.content) return [];
      const A = {
        layout: b.value,
        density: v.value,
        emphasis: c.value,
        hierarchy: m.value
      };
      return a(s.content, A);
    }), _ = (A) => ({
      paragraph: pe,
      heading: Ye,
      list: Qe,
      blockquote: et,
      link: lt
    })[A] || pe, T = (A) => {
      const g = { ...A.props };
      return A.type !== "list" && A.content && (g.content = A.content), g;
    }, z = i(() => {
      const A = {
        flow: "",
        highlight: "text-center",
        structured: "",
        compact: ""
      }, g = {
        left: "text-start",
        center: "text-center",
        right: "text-end",
        justify: "text-justify"
      };
      return `${A[b.value]} ${g[o.value]}`;
    }), N = i(() => {
      const A = {
        flat: "title-flat",
        structured: "title-structured",
        dramatic: "title-dramatic"
      }, g = {
        subtle: "fw-medium text-surface-700",
        normal: "fw-bold text-surface-900",
        strong: "fw-bolder text-surface-900"
      }, B = {
        flow: "",
        highlight: "text-center",
        structured: "",
        compact: ""
      }, y = {
        tight: "mb-3",
        normal: "mb-4",
        loose: "mb-4"
      };
      return `${A[m.value]} ${g[c.value]} ${B[b.value]} ${y[v.value]} lh-tight`;
    }), M = i(() => {
      const A = "text-primary-600", g = {
        subtle: "fs-sm",
        normal: "",
        strong: "fs-5 fw-medium"
      }, B = {
        tight: "mb-2",
        normal: "mb-3",
        loose: "mb-4"
      };
      return `${A} ${g[c.value]} ${B[v.value]}`;
    }), k = i(() => ({
      flow: "divider-flow bg-primary-500 my-4",
      highlight: "divider-highlight bg-primary-500 mx-auto my-4 rounded-pill",
      structured: "divider-structured bg-surface-300 my-3",
      compact: "divider-compact bg-primary-400 my-2"
    })[b.value]), S = i(() => {
      const A = {
        small: "img-sm",
        medium: "img-md",
        large: "img-lg"
      }, g = {
        flow: "rounded-3 shadow-lg",
        highlight: "rounded-circle shadow-lg mx-auto",
        structured: "rounded shadow",
        compact: "rounded shadow-sm"
      };
      return `w-100 ${A[d.value]} object-fit-cover ${g[b.value]}`;
    }), D = i(() => ({
      left: "text-start",
      center: "text-center",
      right: "text-end",
      justify: "text-justify"
    })[o.value] || "text-start");
    return (A, g) => (e(), t("section", {
      class: r([n.value, "container"])
    }, [
      s.Image && s.imagePosition !== "top" ? (e(), t("div", at, [
        l("div", {
          class: r(["col-md-6", { "order-md-2": (s.imagePosition || "left") === "right" }])
        }, [
          s.title ? (e(), t("h2", {
            key: 0,
            class: r(N.value)
          }, p(s.title), 3)) : u("", !0),
          s.subtitle ? (e(), t("div", {
            key: 1,
            class: r(M.value)
          }, p(s.subtitle), 3)) : u("", !0),
          s.showDivider ? (e(), t("div", {
            key: 2,
            class: r(k.value)
          }, null, 2)) : u("", !0),
          l("div", {
            class: r(D.value)
          }, [
            (e(!0), t(j, null, I(x.value, (B, y) => (e(), W(te(_(B.type)), oe({ key: y }, { ref_for: !0 }, T(B)), null, 16))), 128))
          ], 2)
        ], 2),
        l("div", {
          class: r(["col-md-6", { "order-md-1": (s.imagePosition || "left") === "right" }])
        }, [
          l("img", {
            src: $(s.Image.url),
            alt: s.Image.alternativeText || s.title,
            class: r(S.value)
          }, null, 10, ot)
        ], 2)
      ])) : (e(), t("div", {
        key: 1,
        class: r(z.value)
      }, [
        s.Image && s.imagePosition === "top" ? (e(), t("div", it, [
          l("img", {
            src: $(s.Image.url),
            alt: s.Image.alternativeText || s.title,
            class: r(S.value)
          }, null, 10, nt)
        ])) : u("", !0),
        s.title ? (e(), t("h1", {
          key: 1,
          class: r(N.value)
        }, p(s.title), 3)) : u("", !0),
        s.subtitle ? (e(), t("div", {
          key: 2,
          class: r(M.value)
        }, p(s.subtitle), 3)) : u("", !0),
        s.showDivider ? (e(), t("div", {
          key: 3,
          class: r(k.value)
        }, null, 2)) : u("", !0),
        l("div", {
          class: r(D.value)
        }, [
          (e(!0), t(j, null, I(x.value, (B, y) => (e(), W(te(_(B.type)), oe({ key: y }, { ref_for: !0 }, T(B)), null, 16))), 128))
        ], 2)
      ], 2))
    ], 2));
  }
}), ct = /* @__PURE__ */ E(rt, [["__scopeId", "data-v-e59a0146"]]), dt = 61698, ut = 61705, pt = 61707, ft = 61709, mt = 61777, ht = 61778, bt = 61780, gt = 61781, yt = 61785, vt = 61817, kt = 61824, wt = 61826, xt = 61828, Ct = 61832, $t = 61834, _t = 61835, Tt = 61836, zt = 61837, qt = 61839, jt = 61844, St = 61858, At = 61860, It = 61861, Mt = 61864, Lt = 61876, Bt = 61896, Ht = 61897, Pt = 61898, Nt = 61900, Et = 61910, Ut = 61912, Vt = 61914, Ot = 61916, Wt = 61917, Dt = 61918, Gt = 61920, Rt = 61942, Ft = 61964, Yt = 61972, Kt = 61976, Jt = 61984, Qt = 61985, Xt = 61987, Zt = 62018, es = 62019, ts = 62020, ss = 62021, ls = 62023, as = 62024, os = 62056, is = 62062, ns = 62066, rs = 62090, cs = 62096, ds = 62099, us = 62145, ps = 62147, fs = 62149, ms = 62152, hs = 62156, bs = 62158, gs = 62159, ys = 62161, vs = 62163, ks = 62164, ws = 62166, xs = 62173, Cs = 62176, $s = 62179, _s = 62186, Ts = 62193, zs = 62207, qs = 62208, js = 62210, Ss = 62217, As = 62218, Is = 62221, Ms = 62222, Ls = 62224, Bs = 62227, Hs = 62229, Ps = 62255, Ns = 62257, Es = 62268, Us = 62269, Vs = 62273, Os = 62274, Ws = 62275, Ds = 62276, Gs = 62400, Rs = 62402, Fs = 62403, Ys = 62410, Ks = 62412, Js = 62413, Qs = 62414, Xs = 62415, Zs = 62423, el = 62425, tl = 62426, sl = 62428, ll = 62429, al = 62431, ol = 62433, il = 62437, nl = 62438, rl = 62442, cl = 62444, dl = 62445, ul = 62446, pl = 62447, fl = 62448, ml = 62460, hl = 62463, bl = 62473, gl = 62474, yl = 62482, vl = 62483, kl = 62484, wl = 62487, xl = 62490, Cl = 62493, $l = 62497, _l = 62501, Tl = 62502, zl = 62503, ql = 62506, jl = 62507, Sl = 62509, Al = 62511, Il = 62516, Ml = 62519, Ll = 62520, Bl = 62534, Hl = 62535, Pl = 62536, Nl = 62539, El = 62541, Ul = 62543, Vl = 62545, Ol = 62546, Wl = 62548, Dl = 62550, Gl = 62555, Rl = 62571, Fl = 62575, Yl = 62577, Kl = 62578, Jl = 62585, Ql = 62587, Xl = 62588, Zl = 62589, ea = 62591, ta = 62593, sa = 62594, la = 62596, aa = 62608, oa = 62610, ia = 62611, na = 62615, ra = 62617, ca = 62619, da = 62621, ua = 62627, pa = 62633, fa = 62636, ma = 62637, ha = 62638, ba = 62641, ga = 62642, ya = 62643, va = 62644, ka = 62660, wa = 62662, xa = 62664, Ca = 62667, $a = 62670, _a = 62672, Ta = 62673, za = 62689, qa = 62695, ja = 62701, Sa = 62703, Aa = 62709, Ia = 62711, Ma = 62718, La = 62719, Ba = 62721, Ha = 62723, Pa = 62732, Na = 62733, Ea = 62735, Ua = 62746, Va = 62748, Oa = 62752, Wa = 62754, Da = 62755, Ga = 62757, Ra = 62759, Fa = 62760, Ya = 62761, Ka = 62762, Ja = 62764, Qa = 62766, Xa = 62783, Za = 62785, eo = 62787, to = 62788, so = 62794, lo = 62796, ao = 62821, oo = 62826, io = 62827, no = 62828, ro = 62829, co = 62830, uo = 62831, po = 62844, fo = 62846, mo = 62847, ho = 62848, bo = 62849, go = 62852, yo = 62853, vo = 62856, ko = 62857, wo = 62859, xo = 62861, Co = 62867, $o = 62869, _o = 62871, To = 62872, zo = 62882, qo = 62883, jo = 62885, So = 62887, Ao = 62890, Io = 62894, Mo = 62896, Lo = 62898, Bo = 62899, Ho = 62913, Po = 62915, No = 62924, Eo = 62930, Uo = 62937, Vo = 62938, Oo = 62939, Wo = 62940, Do = 62942, Go = 62944, Ro = 62946, Fo = 62949, Yo = 62951, Ko = 62954, Jo = 62955, Qo = 62957, Xo = 62958, Zo = 62959, ei = 62967, ti = 62973, si = 62974, li = 62976, ai = 62978, oi = 62979, ii = 62984, ni = 62985, ri = 62994, ci = 62996, di = 62997, ui = 62998, pi = 62999, fi = 63e3, mi = 63004, hi = 63005, bi = 63008, gi = 63009, yi = 63018, vi = 63019, ki = 63022, wi = 63023, xi = 63028, Ci = 63047, $i = 63048, _i = 63055, Ti = 63056, zi = 63059, qi = 63062, ji = 63064, Si = 63066, Ai = 63067, Ii = 63069, Mi = 63070, Li = 63068, Bi = 63071, Hi = 63072, Pi = 63073, Ni = 63074, Ei = 63075, Ui = 63076, Vi = 63077, Oi = 63078, Wi = 63080, Di = 63081, Gi = 63082, Ri = 63083, Fi = 63085, Yi = 63087, Ki = 63088, Ji = 63089, Qi = 63092, Xi = 63093, Zi = 63099, en = 63101, tn = 63105, sn = 63106, ln = 63108, an = 63109, on = 63111, nn = 63113, rn = 63132, cn = 63133, dn = 63134, un = 63137, pn = 63144, fn = 63145, mn = 63148, hn = 63151, bn = 63152, gn = 63153, yn = 63168, vn = 63169, kn = 63179, wn = 63180, xn = 63188, Cn = 63189, $n = 63191, _n = 63198, Tn = 63201, zn = 63203, qn = 63205, jn = 63207, Sn = 63212, An = 63216, In = 63230, Mn = 63241, Ln = 63245, Bn = 63283, Hn = 63345, Pn = 63346, Nn = 63348, En = 63351, Un = 63353, Vn = 63357, On = 63361, Wn = 63365, Dn = 63369, Gn = 63371, Rn = 63372, Fn = 63373, Yn = 63437, Kn = 63438, Jn = 63439, Qn = 63440, Xn = 63441, Zn = 63455, er = 63459, tr = 63469, sr = 63478, lr = 63486, ar = 63488, or = 63497, ir = 63498, nr = 63499, rr = 63507, cr = 63513, dr = 63522, ur = 63523, pr = 63524, fr = 63527, mr = 63528, hr = 63529, br = 63530, gr = 63558, yr = 63559, vr = 63560, kr = 63561, wr = 63562, xr = 63565, Cr = 63613, $r = 63659, _r = 63662, Tr = 63684, zr = 63686, qr = 63687, jr = 63692, Sr = 63114, Ar = 63117, Ir = 63138, Mr = 63158, Lr = 63170, Br = 63200, Hr = 63213, Pr = 63214, Nr = 63321, Er = 63337, Ur = 63380, Vr = 63423, Or = 63428, Wr = 63448, Dr = 63460, Gr = 63461, Rr = 63480, Fr = 63500, Yr = 63501, Kr = 63695, Jr = 63702, Qr = 63703, Xr = 63705, Zr = 63706, ec = 63712, tc = 63714, sc = 63716, lc = 63718, ac = 63719, oc = 63723, ic = 63724, nc = 63726, rc = 63728, cc = 63733, dc = 63740, uc = 63744, pc = 63746, fc = 63747, mc = 63481, hc = 63748, bc = 63750, gc = 63754, yc = 63756, vc = 63760, kc = 63762, wc = 63764, xc = 63765, Cc = 63766, $c = 63767, _c = 63768, Tc = 63769, zc = {
  123: 63103,
  "alarm-fill": 61697,
  alarm: dt,
  "align-bottom": 61699,
  "align-center": 61700,
  "align-end": 61701,
  "align-middle": 61702,
  "align-start": 61703,
  "align-top": 61704,
  alt: ut,
  "app-indicator": 61706,
  app: pt,
  "archive-fill": 61708,
  archive: ft,
  "arrow-90deg-down": 61710,
  "arrow-90deg-left": 61711,
  "arrow-90deg-right": 61712,
  "arrow-90deg-up": 61713,
  "arrow-bar-down": 61714,
  "arrow-bar-left": 61715,
  "arrow-bar-right": 61716,
  "arrow-bar-up": 61717,
  "arrow-clockwise": 61718,
  "arrow-counterclockwise": 61719,
  "arrow-down-circle-fill": 61720,
  "arrow-down-circle": 61721,
  "arrow-down-left-circle-fill": 61722,
  "arrow-down-left-circle": 61723,
  "arrow-down-left-square-fill": 61724,
  "arrow-down-left-square": 61725,
  "arrow-down-left": 61726,
  "arrow-down-right-circle-fill": 61727,
  "arrow-down-right-circle": 61728,
  "arrow-down-right-square-fill": 61729,
  "arrow-down-right-square": 61730,
  "arrow-down-right": 61731,
  "arrow-down-short": 61732,
  "arrow-down-square-fill": 61733,
  "arrow-down-square": 61734,
  "arrow-down-up": 61735,
  "arrow-down": 61736,
  "arrow-left-circle-fill": 61737,
  "arrow-left-circle": 61738,
  "arrow-left-right": 61739,
  "arrow-left-short": 61740,
  "arrow-left-square-fill": 61741,
  "arrow-left-square": 61742,
  "arrow-left": 61743,
  "arrow-repeat": 61744,
  "arrow-return-left": 61745,
  "arrow-return-right": 61746,
  "arrow-right-circle-fill": 61747,
  "arrow-right-circle": 61748,
  "arrow-right-short": 61749,
  "arrow-right-square-fill": 61750,
  "arrow-right-square": 61751,
  "arrow-right": 61752,
  "arrow-up-circle-fill": 61753,
  "arrow-up-circle": 61754,
  "arrow-up-left-circle-fill": 61755,
  "arrow-up-left-circle": 61756,
  "arrow-up-left-square-fill": 61757,
  "arrow-up-left-square": 61758,
  "arrow-up-left": 61759,
  "arrow-up-right-circle-fill": 61760,
  "arrow-up-right-circle": 61761,
  "arrow-up-right-square-fill": 61762,
  "arrow-up-right-square": 61763,
  "arrow-up-right": 61764,
  "arrow-up-short": 61765,
  "arrow-up-square-fill": 61766,
  "arrow-up-square": 61767,
  "arrow-up": 61768,
  "arrows-angle-contract": 61769,
  "arrows-angle-expand": 61770,
  "arrows-collapse": 61771,
  "arrows-expand": 61772,
  "arrows-fullscreen": 61773,
  "arrows-move": 61774,
  "aspect-ratio-fill": 61775,
  "aspect-ratio": 61776,
  asterisk: mt,
  at: ht,
  "award-fill": 61779,
  award: bt,
  back: gt,
  "backspace-fill": 61782,
  "backspace-reverse-fill": 61783,
  "backspace-reverse": 61784,
  backspace: yt,
  "badge-3d-fill": 61786,
  "badge-3d": 61787,
  "badge-4k-fill": 61788,
  "badge-4k": 61789,
  "badge-8k-fill": 61790,
  "badge-8k": 61791,
  "badge-ad-fill": 61792,
  "badge-ad": 61793,
  "badge-ar-fill": 61794,
  "badge-ar": 61795,
  "badge-cc-fill": 61796,
  "badge-cc": 61797,
  "badge-hd-fill": 61798,
  "badge-hd": 61799,
  "badge-tm-fill": 61800,
  "badge-tm": 61801,
  "badge-vo-fill": 61802,
  "badge-vo": 61803,
  "badge-vr-fill": 61804,
  "badge-vr": 61805,
  "badge-wc-fill": 61806,
  "badge-wc": 61807,
  "bag-check-fill": 61808,
  "bag-check": 61809,
  "bag-dash-fill": 61810,
  "bag-dash": 61811,
  "bag-fill": 61812,
  "bag-plus-fill": 61813,
  "bag-plus": 61814,
  "bag-x-fill": 61815,
  "bag-x": 61816,
  bag: vt,
  "bar-chart-fill": 61818,
  "bar-chart-line-fill": 61819,
  "bar-chart-line": 61820,
  "bar-chart-steps": 61821,
  "bar-chart": 61822,
  "basket-fill": 61823,
  basket: kt,
  "basket2-fill": 61825,
  basket2: wt,
  "basket3-fill": 61827,
  basket3: xt,
  "battery-charging": 61829,
  "battery-full": 61830,
  "battery-half": 61831,
  battery: Ct,
  "bell-fill": 61833,
  bell: $t,
  bezier: _t,
  bezier2: Tt,
  bicycle: zt,
  "binoculars-fill": 61838,
  binoculars: qt,
  "blockquote-left": 61840,
  "blockquote-right": 61841,
  "book-fill": 61842,
  "book-half": 61843,
  book: jt,
  "bookmark-check-fill": 61845,
  "bookmark-check": 61846,
  "bookmark-dash-fill": 61847,
  "bookmark-dash": 61848,
  "bookmark-fill": 61849,
  "bookmark-heart-fill": 61850,
  "bookmark-heart": 61851,
  "bookmark-plus-fill": 61852,
  "bookmark-plus": 61853,
  "bookmark-star-fill": 61854,
  "bookmark-star": 61855,
  "bookmark-x-fill": 61856,
  "bookmark-x": 61857,
  bookmark: St,
  "bookmarks-fill": 61859,
  bookmarks: At,
  bookshelf: It,
  "bootstrap-fill": 61862,
  "bootstrap-reboot": 61863,
  bootstrap: Mt,
  "border-all": 61865,
  "border-bottom": 61866,
  "border-center": 61867,
  "border-inner": 61868,
  "border-left": 61869,
  "border-middle": 61870,
  "border-outer": 61871,
  "border-right": 61872,
  "border-style": 61873,
  "border-top": 61874,
  "border-width": 61875,
  border: Lt,
  "bounding-box-circles": 61877,
  "bounding-box": 61878,
  "box-arrow-down-left": 61879,
  "box-arrow-down-right": 61880,
  "box-arrow-down": 61881,
  "box-arrow-in-down-left": 61882,
  "box-arrow-in-down-right": 61883,
  "box-arrow-in-down": 61884,
  "box-arrow-in-left": 61885,
  "box-arrow-in-right": 61886,
  "box-arrow-in-up-left": 61887,
  "box-arrow-in-up-right": 61888,
  "box-arrow-in-up": 61889,
  "box-arrow-left": 61890,
  "box-arrow-right": 61891,
  "box-arrow-up-left": 61892,
  "box-arrow-up-right": 61893,
  "box-arrow-up": 61894,
  "box-seam": 61895,
  box: Bt,
  braces: Ht,
  bricks: Pt,
  "briefcase-fill": 61899,
  briefcase: Nt,
  "brightness-alt-high-fill": 61901,
  "brightness-alt-high": 61902,
  "brightness-alt-low-fill": 61903,
  "brightness-alt-low": 61904,
  "brightness-high-fill": 61905,
  "brightness-high": 61906,
  "brightness-low-fill": 61907,
  "brightness-low": 61908,
  "broadcast-pin": 61909,
  broadcast: Et,
  "brush-fill": 61911,
  brush: Ut,
  "bucket-fill": 61913,
  bucket: Vt,
  "bug-fill": 61915,
  bug: Ot,
  building: Wt,
  bullseye: Dt,
  "calculator-fill": 61919,
  calculator: Gt,
  "calendar-check-fill": 61921,
  "calendar-check": 61922,
  "calendar-date-fill": 61923,
  "calendar-date": 61924,
  "calendar-day-fill": 61925,
  "calendar-day": 61926,
  "calendar-event-fill": 61927,
  "calendar-event": 61928,
  "calendar-fill": 61929,
  "calendar-minus-fill": 61930,
  "calendar-minus": 61931,
  "calendar-month-fill": 61932,
  "calendar-month": 61933,
  "calendar-plus-fill": 61934,
  "calendar-plus": 61935,
  "calendar-range-fill": 61936,
  "calendar-range": 61937,
  "calendar-week-fill": 61938,
  "calendar-week": 61939,
  "calendar-x-fill": 61940,
  "calendar-x": 61941,
  calendar: Rt,
  "calendar2-check-fill": 61943,
  "calendar2-check": 61944,
  "calendar2-date-fill": 61945,
  "calendar2-date": 61946,
  "calendar2-day-fill": 61947,
  "calendar2-day": 61948,
  "calendar2-event-fill": 61949,
  "calendar2-event": 61950,
  "calendar2-fill": 61951,
  "calendar2-minus-fill": 61952,
  "calendar2-minus": 61953,
  "calendar2-month-fill": 61954,
  "calendar2-month": 61955,
  "calendar2-plus-fill": 61956,
  "calendar2-plus": 61957,
  "calendar2-range-fill": 61958,
  "calendar2-range": 61959,
  "calendar2-week-fill": 61960,
  "calendar2-week": 61961,
  "calendar2-x-fill": 61962,
  "calendar2-x": 61963,
  calendar2: Ft,
  "calendar3-event-fill": 61965,
  "calendar3-event": 61966,
  "calendar3-fill": 61967,
  "calendar3-range-fill": 61968,
  "calendar3-range": 61969,
  "calendar3-week-fill": 61970,
  "calendar3-week": 61971,
  calendar3: Yt,
  "calendar4-event": 61973,
  "calendar4-range": 61974,
  "calendar4-week": 61975,
  calendar4: Kt,
  "camera-fill": 61977,
  "camera-reels-fill": 61978,
  "camera-reels": 61979,
  "camera-video-fill": 61980,
  "camera-video-off-fill": 61981,
  "camera-video-off": 61982,
  "camera-video": 61983,
  camera: Jt,
  camera2: Qt,
  "capslock-fill": 61986,
  capslock: Xt,
  "card-checklist": 61988,
  "card-heading": 61989,
  "card-image": 61990,
  "card-list": 61991,
  "card-text": 61992,
  "caret-down-fill": 61993,
  "caret-down-square-fill": 61994,
  "caret-down-square": 61995,
  "caret-down": 61996,
  "caret-left-fill": 61997,
  "caret-left-square-fill": 61998,
  "caret-left-square": 61999,
  "caret-left": 62e3,
  "caret-right-fill": 62001,
  "caret-right-square-fill": 62002,
  "caret-right-square": 62003,
  "caret-right": 62004,
  "caret-up-fill": 62005,
  "caret-up-square-fill": 62006,
  "caret-up-square": 62007,
  "caret-up": 62008,
  "cart-check-fill": 62009,
  "cart-check": 62010,
  "cart-dash-fill": 62011,
  "cart-dash": 62012,
  "cart-fill": 62013,
  "cart-plus-fill": 62014,
  "cart-plus": 62015,
  "cart-x-fill": 62016,
  "cart-x": 62017,
  cart: Zt,
  cart2: es,
  cart3: ts,
  cart4: ss,
  "cash-stack": 62022,
  cash: ls,
  cast: as,
  "chat-dots-fill": 62025,
  "chat-dots": 62026,
  "chat-fill": 62027,
  "chat-left-dots-fill": 62028,
  "chat-left-dots": 62029,
  "chat-left-fill": 62030,
  "chat-left-quote-fill": 62031,
  "chat-left-quote": 62032,
  "chat-left-text-fill": 62033,
  "chat-left-text": 62034,
  "chat-left": 62035,
  "chat-quote-fill": 62036,
  "chat-quote": 62037,
  "chat-right-dots-fill": 62038,
  "chat-right-dots": 62039,
  "chat-right-fill": 62040,
  "chat-right-quote-fill": 62041,
  "chat-right-quote": 62042,
  "chat-right-text-fill": 62043,
  "chat-right-text": 62044,
  "chat-right": 62045,
  "chat-square-dots-fill": 62046,
  "chat-square-dots": 62047,
  "chat-square-fill": 62048,
  "chat-square-quote-fill": 62049,
  "chat-square-quote": 62050,
  "chat-square-text-fill": 62051,
  "chat-square-text": 62052,
  "chat-square": 62053,
  "chat-text-fill": 62054,
  "chat-text": 62055,
  chat: os,
  "check-all": 62057,
  "check-circle-fill": 62058,
  "check-circle": 62059,
  "check-square-fill": 62060,
  "check-square": 62061,
  check: is,
  "check2-all": 62063,
  "check2-circle": 62064,
  "check2-square": 62065,
  check2: ns,
  "chevron-bar-contract": 62067,
  "chevron-bar-down": 62068,
  "chevron-bar-expand": 62069,
  "chevron-bar-left": 62070,
  "chevron-bar-right": 62071,
  "chevron-bar-up": 62072,
  "chevron-compact-down": 62073,
  "chevron-compact-left": 62074,
  "chevron-compact-right": 62075,
  "chevron-compact-up": 62076,
  "chevron-contract": 62077,
  "chevron-double-down": 62078,
  "chevron-double-left": 62079,
  "chevron-double-right": 62080,
  "chevron-double-up": 62081,
  "chevron-down": 62082,
  "chevron-expand": 62083,
  "chevron-left": 62084,
  "chevron-right": 62085,
  "chevron-up": 62086,
  "circle-fill": 62087,
  "circle-half": 62088,
  "circle-square": 62089,
  circle: rs,
  "clipboard-check": 62091,
  "clipboard-data": 62092,
  "clipboard-minus": 62093,
  "clipboard-plus": 62094,
  "clipboard-x": 62095,
  clipboard: cs,
  "clock-fill": 62097,
  "clock-history": 62098,
  clock: ds,
  "cloud-arrow-down-fill": 62100,
  "cloud-arrow-down": 62101,
  "cloud-arrow-up-fill": 62102,
  "cloud-arrow-up": 62103,
  "cloud-check-fill": 62104,
  "cloud-check": 62105,
  "cloud-download-fill": 62106,
  "cloud-download": 62107,
  "cloud-drizzle-fill": 62108,
  "cloud-drizzle": 62109,
  "cloud-fill": 62110,
  "cloud-fog-fill": 62111,
  "cloud-fog": 62112,
  "cloud-fog2-fill": 62113,
  "cloud-fog2": 62114,
  "cloud-hail-fill": 62115,
  "cloud-hail": 62116,
  "cloud-haze-fill": 62118,
  "cloud-haze": 62119,
  "cloud-haze2-fill": 62120,
  "cloud-lightning-fill": 62121,
  "cloud-lightning-rain-fill": 62122,
  "cloud-lightning-rain": 62123,
  "cloud-lightning": 62124,
  "cloud-minus-fill": 62125,
  "cloud-minus": 62126,
  "cloud-moon-fill": 62127,
  "cloud-moon": 62128,
  "cloud-plus-fill": 62129,
  "cloud-plus": 62130,
  "cloud-rain-fill": 62131,
  "cloud-rain-heavy-fill": 62132,
  "cloud-rain-heavy": 62133,
  "cloud-rain": 62134,
  "cloud-slash-fill": 62135,
  "cloud-slash": 62136,
  "cloud-sleet-fill": 62137,
  "cloud-sleet": 62138,
  "cloud-snow-fill": 62139,
  "cloud-snow": 62140,
  "cloud-sun-fill": 62141,
  "cloud-sun": 62142,
  "cloud-upload-fill": 62143,
  "cloud-upload": 62144,
  cloud: us,
  "clouds-fill": 62146,
  clouds: ps,
  "cloudy-fill": 62148,
  cloudy: fs,
  "code-slash": 62150,
  "code-square": 62151,
  code: ms,
  "collection-fill": 62153,
  "collection-play-fill": 62154,
  "collection-play": 62155,
  collection: hs,
  "columns-gap": 62157,
  columns: bs,
  command: gs,
  "compass-fill": 62160,
  compass: ys,
  "cone-striped": 62162,
  cone: vs,
  controller: ks,
  "cpu-fill": 62165,
  cpu: ws,
  "credit-card-2-back-fill": 62167,
  "credit-card-2-back": 62168,
  "credit-card-2-front-fill": 62169,
  "credit-card-2-front": 62170,
  "credit-card-fill": 62171,
  "credit-card": 62172,
  crop: xs,
  "cup-fill": 62174,
  "cup-straw": 62175,
  cup: Cs,
  "cursor-fill": 62177,
  "cursor-text": 62178,
  cursor: $s,
  "dash-circle-dotted": 62180,
  "dash-circle-fill": 62181,
  "dash-circle": 62182,
  "dash-square-dotted": 62183,
  "dash-square-fill": 62184,
  "dash-square": 62185,
  dash: _s,
  "diagram-2-fill": 62187,
  "diagram-2": 62188,
  "diagram-3-fill": 62189,
  "diagram-3": 62190,
  "diamond-fill": 62191,
  "diamond-half": 62192,
  diamond: Ts,
  "dice-1-fill": 62194,
  "dice-1": 62195,
  "dice-2-fill": 62196,
  "dice-2": 62197,
  "dice-3-fill": 62198,
  "dice-3": 62199,
  "dice-4-fill": 62200,
  "dice-4": 62201,
  "dice-5-fill": 62202,
  "dice-5": 62203,
  "dice-6-fill": 62204,
  "dice-6": 62205,
  "disc-fill": 62206,
  disc: zs,
  discord: qs,
  "display-fill": 62209,
  display: js,
  "distribute-horizontal": 62211,
  "distribute-vertical": 62212,
  "door-closed-fill": 62213,
  "door-closed": 62214,
  "door-open-fill": 62215,
  "door-open": 62216,
  dot: Ss,
  download: As,
  "droplet-fill": 62219,
  "droplet-half": 62220,
  droplet: Is,
  earbuds: Ms,
  "easel-fill": 62223,
  easel: Ls,
  "egg-fill": 62225,
  "egg-fried": 62226,
  egg: Bs,
  "eject-fill": 62228,
  eject: Hs,
  "emoji-angry-fill": 62230,
  "emoji-angry": 62231,
  "emoji-dizzy-fill": 62232,
  "emoji-dizzy": 62233,
  "emoji-expressionless-fill": 62234,
  "emoji-expressionless": 62235,
  "emoji-frown-fill": 62236,
  "emoji-frown": 62237,
  "emoji-heart-eyes-fill": 62238,
  "emoji-heart-eyes": 62239,
  "emoji-laughing-fill": 62240,
  "emoji-laughing": 62241,
  "emoji-neutral-fill": 62242,
  "emoji-neutral": 62243,
  "emoji-smile-fill": 62244,
  "emoji-smile-upside-down-fill": 62245,
  "emoji-smile-upside-down": 62246,
  "emoji-smile": 62247,
  "emoji-sunglasses-fill": 62248,
  "emoji-sunglasses": 62249,
  "emoji-wink-fill": 62250,
  "emoji-wink": 62251,
  "envelope-fill": 62252,
  "envelope-open-fill": 62253,
  "envelope-open": 62254,
  envelope: Ps,
  "eraser-fill": 62256,
  eraser: Ns,
  "exclamation-circle-fill": 62258,
  "exclamation-circle": 62259,
  "exclamation-diamond-fill": 62260,
  "exclamation-diamond": 62261,
  "exclamation-octagon-fill": 62262,
  "exclamation-octagon": 62263,
  "exclamation-square-fill": 62264,
  "exclamation-square": 62265,
  "exclamation-triangle-fill": 62266,
  "exclamation-triangle": 62267,
  exclamation: Es,
  exclude: Us,
  "eye-fill": 62270,
  "eye-slash-fill": 62271,
  "eye-slash": 62272,
  eye: Vs,
  eyedropper: Os,
  eyeglasses: Ws,
  facebook: Ds,
  "file-arrow-down-fill": 62277,
  "file-arrow-down": 62278,
  "file-arrow-up-fill": 62279,
  "file-arrow-up": 62280,
  "file-bar-graph-fill": 62281,
  "file-bar-graph": 62282,
  "file-binary-fill": 62283,
  "file-binary": 62284,
  "file-break-fill": 62285,
  "file-break": 62286,
  "file-check-fill": 62287,
  "file-check": 62288,
  "file-code-fill": 62289,
  "file-code": 62290,
  "file-diff-fill": 62291,
  "file-diff": 62292,
  "file-earmark-arrow-down-fill": 62293,
  "file-earmark-arrow-down": 62294,
  "file-earmark-arrow-up-fill": 62295,
  "file-earmark-arrow-up": 62296,
  "file-earmark-bar-graph-fill": 62297,
  "file-earmark-bar-graph": 62298,
  "file-earmark-binary-fill": 62299,
  "file-earmark-binary": 62300,
  "file-earmark-break-fill": 62301,
  "file-earmark-break": 62302,
  "file-earmark-check-fill": 62303,
  "file-earmark-check": 62304,
  "file-earmark-code-fill": 62305,
  "file-earmark-code": 62306,
  "file-earmark-diff-fill": 62307,
  "file-earmark-diff": 62308,
  "file-earmark-easel-fill": 62309,
  "file-earmark-easel": 62310,
  "file-earmark-excel-fill": 62311,
  "file-earmark-excel": 62312,
  "file-earmark-fill": 62313,
  "file-earmark-font-fill": 62314,
  "file-earmark-font": 62315,
  "file-earmark-image-fill": 62316,
  "file-earmark-image": 62317,
  "file-earmark-lock-fill": 62318,
  "file-earmark-lock": 62319,
  "file-earmark-lock2-fill": 62320,
  "file-earmark-lock2": 62321,
  "file-earmark-medical-fill": 62322,
  "file-earmark-medical": 62323,
  "file-earmark-minus-fill": 62324,
  "file-earmark-minus": 62325,
  "file-earmark-music-fill": 62326,
  "file-earmark-music": 62327,
  "file-earmark-person-fill": 62328,
  "file-earmark-person": 62329,
  "file-earmark-play-fill": 62330,
  "file-earmark-play": 62331,
  "file-earmark-plus-fill": 62332,
  "file-earmark-plus": 62333,
  "file-earmark-post-fill": 62334,
  "file-earmark-post": 62335,
  "file-earmark-ppt-fill": 62336,
  "file-earmark-ppt": 62337,
  "file-earmark-richtext-fill": 62338,
  "file-earmark-richtext": 62339,
  "file-earmark-ruled-fill": 62340,
  "file-earmark-ruled": 62341,
  "file-earmark-slides-fill": 62342,
  "file-earmark-slides": 62343,
  "file-earmark-spreadsheet-fill": 62344,
  "file-earmark-spreadsheet": 62345,
  "file-earmark-text-fill": 62346,
  "file-earmark-text": 62347,
  "file-earmark-word-fill": 62348,
  "file-earmark-word": 62349,
  "file-earmark-x-fill": 62350,
  "file-earmark-x": 62351,
  "file-earmark-zip-fill": 62352,
  "file-earmark-zip": 62353,
  "file-earmark": 62354,
  "file-easel-fill": 62355,
  "file-easel": 62356,
  "file-excel-fill": 62357,
  "file-excel": 62358,
  "file-fill": 62359,
  "file-font-fill": 62360,
  "file-font": 62361,
  "file-image-fill": 62362,
  "file-image": 62363,
  "file-lock-fill": 62364,
  "file-lock": 62365,
  "file-lock2-fill": 62366,
  "file-lock2": 62367,
  "file-medical-fill": 62368,
  "file-medical": 62369,
  "file-minus-fill": 62370,
  "file-minus": 62371,
  "file-music-fill": 62372,
  "file-music": 62373,
  "file-person-fill": 62374,
  "file-person": 62375,
  "file-play-fill": 62376,
  "file-play": 62377,
  "file-plus-fill": 62378,
  "file-plus": 62379,
  "file-post-fill": 62380,
  "file-post": 62381,
  "file-ppt-fill": 62382,
  "file-ppt": 62383,
  "file-richtext-fill": 62384,
  "file-richtext": 62385,
  "file-ruled-fill": 62386,
  "file-ruled": 62387,
  "file-slides-fill": 62388,
  "file-slides": 62389,
  "file-spreadsheet-fill": 62390,
  "file-spreadsheet": 62391,
  "file-text-fill": 62392,
  "file-text": 62393,
  "file-word-fill": 62394,
  "file-word": 62395,
  "file-x-fill": 62396,
  "file-x": 62397,
  "file-zip-fill": 62398,
  "file-zip": 62399,
  file: Gs,
  "files-alt": 62401,
  files: Rs,
  film: Fs,
  "filter-circle-fill": 62404,
  "filter-circle": 62405,
  "filter-left": 62406,
  "filter-right": 62407,
  "filter-square-fill": 62408,
  "filter-square": 62409,
  filter: Ys,
  "flag-fill": 62411,
  flag: Ks,
  flower1: Js,
  flower2: Qs,
  flower3: Xs,
  "folder-check": 62416,
  "folder-fill": 62417,
  "folder-minus": 62418,
  "folder-plus": 62419,
  "folder-symlink-fill": 62420,
  "folder-symlink": 62421,
  "folder-x": 62422,
  folder: Zs,
  "folder2-open": 62424,
  folder2: el,
  fonts: tl,
  "forward-fill": 62427,
  forward: sl,
  front: ll,
  "fullscreen-exit": 62430,
  fullscreen: al,
  "funnel-fill": 62432,
  funnel: ol,
  "gear-fill": 62434,
  "gear-wide-connected": 62435,
  "gear-wide": 62436,
  gear: il,
  gem: nl,
  "geo-alt-fill": 62439,
  "geo-alt": 62440,
  "geo-fill": 62441,
  geo: rl,
  "gift-fill": 62443,
  gift: cl,
  github: dl,
  globe: ul,
  globe2: pl,
  google: fl,
  "graph-down": 62449,
  "graph-up": 62450,
  "grid-1x2-fill": 62451,
  "grid-1x2": 62452,
  "grid-3x2-gap-fill": 62453,
  "grid-3x2-gap": 62454,
  "grid-3x2": 62455,
  "grid-3x3-gap-fill": 62456,
  "grid-3x3-gap": 62457,
  "grid-3x3": 62458,
  "grid-fill": 62459,
  grid: ml,
  "grip-horizontal": 62461,
  "grip-vertical": 62462,
  hammer: hl,
  "hand-index-fill": 62464,
  "hand-index-thumb-fill": 62465,
  "hand-index-thumb": 62466,
  "hand-index": 62467,
  "hand-thumbs-down-fill": 62468,
  "hand-thumbs-down": 62469,
  "hand-thumbs-up-fill": 62470,
  "hand-thumbs-up": 62471,
  "handbag-fill": 62472,
  handbag: bl,
  hash: gl,
  "hdd-fill": 62475,
  "hdd-network-fill": 62476,
  "hdd-network": 62477,
  "hdd-rack-fill": 62478,
  "hdd-rack": 62479,
  "hdd-stack-fill": 62480,
  "hdd-stack": 62481,
  hdd: yl,
  headphones: vl,
  headset: kl,
  "heart-fill": 62485,
  "heart-half": 62486,
  heart: wl,
  "heptagon-fill": 62488,
  "heptagon-half": 62489,
  heptagon: xl,
  "hexagon-fill": 62491,
  "hexagon-half": 62492,
  hexagon: Cl,
  "hourglass-bottom": 62494,
  "hourglass-split": 62495,
  "hourglass-top": 62496,
  hourglass: $l,
  "house-door-fill": 62498,
  "house-door": 62499,
  "house-fill": 62500,
  house: _l,
  hr: Tl,
  hurricane: zl,
  "image-alt": 62504,
  "image-fill": 62505,
  image: ql,
  images: jl,
  "inbox-fill": 62508,
  inbox: Sl,
  "inboxes-fill": 62510,
  inboxes: Al,
  "info-circle-fill": 62512,
  "info-circle": 62513,
  "info-square-fill": 62514,
  "info-square": 62515,
  info: Il,
  "input-cursor-text": 62517,
  "input-cursor": 62518,
  instagram: Ml,
  intersect: Ll,
  "journal-album": 62521,
  "journal-arrow-down": 62522,
  "journal-arrow-up": 62523,
  "journal-bookmark-fill": 62524,
  "journal-bookmark": 62525,
  "journal-check": 62526,
  "journal-code": 62527,
  "journal-medical": 62528,
  "journal-minus": 62529,
  "journal-plus": 62530,
  "journal-richtext": 62531,
  "journal-text": 62532,
  "journal-x": 62533,
  journal: Bl,
  journals: Hl,
  joystick: Pl,
  "justify-left": 62537,
  "justify-right": 62538,
  justify: Nl,
  "kanban-fill": 62540,
  kanban: El,
  "key-fill": 62542,
  key: Ul,
  "keyboard-fill": 62544,
  keyboard: Vl,
  ladder: Ol,
  "lamp-fill": 62547,
  lamp: Wl,
  "laptop-fill": 62549,
  laptop: Dl,
  "layer-backward": 62551,
  "layer-forward": 62552,
  "layers-fill": 62553,
  "layers-half": 62554,
  layers: Gl,
  "layout-sidebar-inset-reverse": 62556,
  "layout-sidebar-inset": 62557,
  "layout-sidebar-reverse": 62558,
  "layout-sidebar": 62559,
  "layout-split": 62560,
  "layout-text-sidebar-reverse": 62561,
  "layout-text-sidebar": 62562,
  "layout-text-window-reverse": 62563,
  "layout-text-window": 62564,
  "layout-three-columns": 62565,
  "layout-wtf": 62566,
  "life-preserver": 62567,
  "lightbulb-fill": 62568,
  "lightbulb-off-fill": 62569,
  "lightbulb-off": 62570,
  lightbulb: Rl,
  "lightning-charge-fill": 62572,
  "lightning-charge": 62573,
  "lightning-fill": 62574,
  lightning: Fl,
  "link-45deg": 62576,
  link: Yl,
  linkedin: Kl,
  "list-check": 62579,
  "list-nested": 62580,
  "list-ol": 62581,
  "list-stars": 62582,
  "list-task": 62583,
  "list-ul": 62584,
  list: Jl,
  "lock-fill": 62586,
  lock: Ql,
  mailbox: Xl,
  mailbox2: Zl,
  "map-fill": 62590,
  map: ea,
  "markdown-fill": 62592,
  markdown: ta,
  mask: sa,
  "megaphone-fill": 62595,
  megaphone: la,
  "menu-app-fill": 62597,
  "menu-app": 62598,
  "menu-button-fill": 62599,
  "menu-button-wide-fill": 62600,
  "menu-button-wide": 62601,
  "menu-button": 62602,
  "menu-down": 62603,
  "menu-up": 62604,
  "mic-fill": 62605,
  "mic-mute-fill": 62606,
  "mic-mute": 62607,
  mic: aa,
  "minecart-loaded": 62609,
  minecart: oa,
  moisture: ia,
  "moon-fill": 62612,
  "moon-stars-fill": 62613,
  "moon-stars": 62614,
  moon: na,
  "mouse-fill": 62616,
  mouse: ra,
  "mouse2-fill": 62618,
  mouse2: ca,
  "mouse3-fill": 62620,
  mouse3: da,
  "music-note-beamed": 62622,
  "music-note-list": 62623,
  "music-note": 62624,
  "music-player-fill": 62625,
  "music-player": 62626,
  newspaper: ua,
  "node-minus-fill": 62628,
  "node-minus": 62629,
  "node-plus-fill": 62630,
  "node-plus": 62631,
  "nut-fill": 62632,
  nut: pa,
  "octagon-fill": 62634,
  "octagon-half": 62635,
  octagon: fa,
  option: ma,
  outlet: ha,
  "paint-bucket": 62639,
  "palette-fill": 62640,
  palette: ba,
  palette2: ga,
  paperclip: ya,
  paragraph: va,
  "patch-check-fill": 62645,
  "patch-check": 62646,
  "patch-exclamation-fill": 62647,
  "patch-exclamation": 62648,
  "patch-minus-fill": 62649,
  "patch-minus": 62650,
  "patch-plus-fill": 62651,
  "patch-plus": 62652,
  "patch-question-fill": 62653,
  "patch-question": 62654,
  "pause-btn-fill": 62655,
  "pause-btn": 62656,
  "pause-circle-fill": 62657,
  "pause-circle": 62658,
  "pause-fill": 62659,
  pause: ka,
  "peace-fill": 62661,
  peace: wa,
  "pen-fill": 62663,
  pen: xa,
  "pencil-fill": 62665,
  "pencil-square": 62666,
  pencil: Ca,
  "pentagon-fill": 62668,
  "pentagon-half": 62669,
  pentagon: $a,
  "people-fill": 62671,
  people: _a,
  percent: Ta,
  "person-badge-fill": 62674,
  "person-badge": 62675,
  "person-bounding-box": 62676,
  "person-check-fill": 62677,
  "person-check": 62678,
  "person-circle": 62679,
  "person-dash-fill": 62680,
  "person-dash": 62681,
  "person-fill": 62682,
  "person-lines-fill": 62683,
  "person-plus-fill": 62684,
  "person-plus": 62685,
  "person-square": 62686,
  "person-x-fill": 62687,
  "person-x": 62688,
  person: za,
  "phone-fill": 62690,
  "phone-landscape-fill": 62691,
  "phone-landscape": 62692,
  "phone-vibrate-fill": 62693,
  "phone-vibrate": 62694,
  phone: qa,
  "pie-chart-fill": 62696,
  "pie-chart": 62697,
  "pin-angle-fill": 62698,
  "pin-angle": 62699,
  "pin-fill": 62700,
  pin: ja,
  "pip-fill": 62702,
  pip: Sa,
  "play-btn-fill": 62704,
  "play-btn": 62705,
  "play-circle-fill": 62706,
  "play-circle": 62707,
  "play-fill": 62708,
  play: Aa,
  "plug-fill": 62710,
  plug: Ia,
  "plus-circle-dotted": 62712,
  "plus-circle-fill": 62713,
  "plus-circle": 62714,
  "plus-square-dotted": 62715,
  "plus-square-fill": 62716,
  "plus-square": 62717,
  plus: Ma,
  power: La,
  "printer-fill": 62720,
  printer: Ba,
  "puzzle-fill": 62722,
  puzzle: Ha,
  "question-circle-fill": 62724,
  "question-circle": 62725,
  "question-diamond-fill": 62726,
  "question-diamond": 62727,
  "question-octagon-fill": 62728,
  "question-octagon": 62729,
  "question-square-fill": 62730,
  "question-square": 62731,
  question: Pa,
  rainbow: Na,
  "receipt-cutoff": 62734,
  receipt: Ea,
  "reception-0": 62736,
  "reception-1": 62737,
  "reception-2": 62738,
  "reception-3": 62739,
  "reception-4": 62740,
  "record-btn-fill": 62741,
  "record-btn": 62742,
  "record-circle-fill": 62743,
  "record-circle": 62744,
  "record-fill": 62745,
  record: Ua,
  "record2-fill": 62747,
  record2: Va,
  "reply-all-fill": 62749,
  "reply-all": 62750,
  "reply-fill": 62751,
  reply: Oa,
  "rss-fill": 62753,
  rss: Wa,
  rulers: Da,
  "save-fill": 62756,
  save: Ga,
  "save2-fill": 62758,
  save2: Ra,
  scissors: Fa,
  screwdriver: Ya,
  search: Ka,
  "segmented-nav": 62763,
  server: Ja,
  "share-fill": 62765,
  share: Qa,
  "shield-check": 62767,
  "shield-exclamation": 62768,
  "shield-fill-check": 62769,
  "shield-fill-exclamation": 62770,
  "shield-fill-minus": 62771,
  "shield-fill-plus": 62772,
  "shield-fill-x": 62773,
  "shield-fill": 62774,
  "shield-lock-fill": 62775,
  "shield-lock": 62776,
  "shield-minus": 62777,
  "shield-plus": 62778,
  "shield-shaded": 62779,
  "shield-slash-fill": 62780,
  "shield-slash": 62781,
  "shield-x": 62782,
  shield: Xa,
  "shift-fill": 62784,
  shift: Za,
  "shop-window": 62786,
  shop: eo,
  shuffle: to,
  "signpost-2-fill": 62789,
  "signpost-2": 62790,
  "signpost-fill": 62791,
  "signpost-split-fill": 62792,
  "signpost-split": 62793,
  signpost: so,
  "sim-fill": 62795,
  sim: lo,
  "skip-backward-btn-fill": 62797,
  "skip-backward-btn": 62798,
  "skip-backward-circle-fill": 62799,
  "skip-backward-circle": 62800,
  "skip-backward-fill": 62801,
  "skip-backward": 62802,
  "skip-end-btn-fill": 62803,
  "skip-end-btn": 62804,
  "skip-end-circle-fill": 62805,
  "skip-end-circle": 62806,
  "skip-end-fill": 62807,
  "skip-end": 62808,
  "skip-forward-btn-fill": 62809,
  "skip-forward-btn": 62810,
  "skip-forward-circle-fill": 62811,
  "skip-forward-circle": 62812,
  "skip-forward-fill": 62813,
  "skip-forward": 62814,
  "skip-start-btn-fill": 62815,
  "skip-start-btn": 62816,
  "skip-start-circle-fill": 62817,
  "skip-start-circle": 62818,
  "skip-start-fill": 62819,
  "skip-start": 62820,
  slack: ao,
  "slash-circle-fill": 62822,
  "slash-circle": 62823,
  "slash-square-fill": 62824,
  "slash-square": 62825,
  slash: oo,
  sliders: io,
  smartwatch: no,
  snow: ro,
  snow2: co,
  snow3: uo,
  "sort-alpha-down-alt": 62832,
  "sort-alpha-down": 62833,
  "sort-alpha-up-alt": 62834,
  "sort-alpha-up": 62835,
  "sort-down-alt": 62836,
  "sort-down": 62837,
  "sort-numeric-down-alt": 62838,
  "sort-numeric-down": 62839,
  "sort-numeric-up-alt": 62840,
  "sort-numeric-up": 62841,
  "sort-up-alt": 62842,
  "sort-up": 62843,
  soundwave: po,
  "speaker-fill": 62845,
  speaker: fo,
  speedometer: mo,
  speedometer2: ho,
  spellcheck: bo,
  "square-fill": 62850,
  "square-half": 62851,
  square: go,
  stack: yo,
  "star-fill": 62854,
  "star-half": 62855,
  star: vo,
  stars: ko,
  "stickies-fill": 62858,
  stickies: wo,
  "sticky-fill": 62860,
  sticky: xo,
  "stop-btn-fill": 62862,
  "stop-btn": 62863,
  "stop-circle-fill": 62864,
  "stop-circle": 62865,
  "stop-fill": 62866,
  stop: Co,
  "stoplights-fill": 62868,
  stoplights: $o,
  "stopwatch-fill": 62870,
  stopwatch: _o,
  subtract: To,
  "suit-club-fill": 62873,
  "suit-club": 62874,
  "suit-diamond-fill": 62875,
  "suit-diamond": 62876,
  "suit-heart-fill": 62877,
  "suit-heart": 62878,
  "suit-spade-fill": 62879,
  "suit-spade": 62880,
  "sun-fill": 62881,
  sun: zo,
  sunglasses: qo,
  "sunrise-fill": 62884,
  sunrise: jo,
  "sunset-fill": 62886,
  sunset: So,
  "symmetry-horizontal": 62888,
  "symmetry-vertical": 62889,
  table: Ao,
  "tablet-fill": 62891,
  "tablet-landscape-fill": 62892,
  "tablet-landscape": 62893,
  tablet: Io,
  "tag-fill": 62895,
  tag: Mo,
  "tags-fill": 62897,
  tags: Lo,
  telegram: Bo,
  "telephone-fill": 62900,
  "telephone-forward-fill": 62901,
  "telephone-forward": 62902,
  "telephone-inbound-fill": 62903,
  "telephone-inbound": 62904,
  "telephone-minus-fill": 62905,
  "telephone-minus": 62906,
  "telephone-outbound-fill": 62907,
  "telephone-outbound": 62908,
  "telephone-plus-fill": 62909,
  "telephone-plus": 62910,
  "telephone-x-fill": 62911,
  "telephone-x": 62912,
  telephone: Ho,
  "terminal-fill": 62914,
  terminal: Po,
  "text-center": 62916,
  "text-indent-left": 62917,
  "text-indent-right": 62918,
  "text-left": 62919,
  "text-paragraph": 62920,
  "text-right": 62921,
  "textarea-resize": 62922,
  "textarea-t": 62923,
  textarea: No,
  "thermometer-half": 62925,
  "thermometer-high": 62926,
  "thermometer-low": 62927,
  "thermometer-snow": 62928,
  "thermometer-sun": 62929,
  thermometer: Eo,
  "three-dots-vertical": 62931,
  "three-dots": 62932,
  "toggle-off": 62933,
  "toggle-on": 62934,
  "toggle2-off": 62935,
  "toggle2-on": 62936,
  toggles: Uo,
  toggles2: Vo,
  tools: Oo,
  tornado: Wo,
  "trash-fill": 62941,
  trash: Do,
  "trash2-fill": 62943,
  trash2: Go,
  "tree-fill": 62945,
  tree: Ro,
  "triangle-fill": 62947,
  "triangle-half": 62948,
  triangle: Fo,
  "trophy-fill": 62950,
  trophy: Yo,
  "tropical-storm": 62952,
  "truck-flatbed": 62953,
  truck: Ko,
  tsunami: Jo,
  "tv-fill": 62956,
  tv: Qo,
  twitch: Xo,
  twitter: Zo,
  "type-bold": 62960,
  "type-h1": 62961,
  "type-h2": 62962,
  "type-h3": 62963,
  "type-italic": 62964,
  "type-strikethrough": 62965,
  "type-underline": 62966,
  type: ei,
  "ui-checks-grid": 62968,
  "ui-checks": 62969,
  "ui-radios-grid": 62970,
  "ui-radios": 62971,
  "umbrella-fill": 62972,
  umbrella: ti,
  union: si,
  "unlock-fill": 62975,
  unlock: li,
  "upc-scan": 62977,
  upc: ai,
  upload: oi,
  "vector-pen": 62980,
  "view-list": 62981,
  "view-stacked": 62982,
  "vinyl-fill": 62983,
  vinyl: ii,
  voicemail: ni,
  "volume-down-fill": 62986,
  "volume-down": 62987,
  "volume-mute-fill": 62988,
  "volume-mute": 62989,
  "volume-off-fill": 62990,
  "volume-off": 62991,
  "volume-up-fill": 62992,
  "volume-up": 62993,
  vr: ri,
  "wallet-fill": 62995,
  wallet: ci,
  wallet2: di,
  watch: ui,
  water: pi,
  whatsapp: fi,
  "wifi-1": 63001,
  "wifi-2": 63002,
  "wifi-off": 63003,
  wifi: mi,
  wind: hi,
  "window-dock": 63006,
  "window-sidebar": 63007,
  window: bi,
  wrench: gi,
  "x-circle-fill": 63010,
  "x-circle": 63011,
  "x-diamond-fill": 63012,
  "x-diamond": 63013,
  "x-octagon-fill": 63014,
  "x-octagon": 63015,
  "x-square-fill": 63016,
  "x-square": 63017,
  x: yi,
  youtube: vi,
  "zoom-in": 63020,
  "zoom-out": 63021,
  bank: ki,
  bank2: wi,
  "bell-slash-fill": 63024,
  "bell-slash": 63025,
  "cash-coin": 63026,
  "check-lg": 63027,
  coin: xi,
  "currency-bitcoin": 63029,
  "currency-dollar": 63030,
  "currency-euro": 63031,
  "currency-exchange": 63032,
  "currency-pound": 63033,
  "currency-yen": 63034,
  "dash-lg": 63035,
  "exclamation-lg": 63036,
  "file-earmark-pdf-fill": 63037,
  "file-earmark-pdf": 63038,
  "file-pdf-fill": 63039,
  "file-pdf": 63040,
  "gender-ambiguous": 63041,
  "gender-female": 63042,
  "gender-male": 63043,
  "gender-trans": 63044,
  "headset-vr": 63045,
  "info-lg": 63046,
  mastodon: Ci,
  messenger: $i,
  "piggy-bank-fill": 63049,
  "piggy-bank": 63050,
  "pin-map-fill": 63051,
  "pin-map": 63052,
  "plus-lg": 63053,
  "question-lg": 63054,
  recycle: _i,
  reddit: Ti,
  "safe-fill": 63057,
  "safe2-fill": 63058,
  safe2: zi,
  "sd-card-fill": 63060,
  "sd-card": 63061,
  skype: qi,
  "slash-lg": 63063,
  translate: ji,
  "x-lg": 63065,
  safe: Si,
  apple: Ai,
  microsoft: Ii,
  windows: Mi,
  behance: Li,
  dribbble: Bi,
  line: Hi,
  medium: Pi,
  paypal: Ni,
  pinterest: Ei,
  signal: Ui,
  snapchat: Vi,
  spotify: Oi,
  "stack-overflow": 63079,
  strava: Wi,
  wordpress: Di,
  vimeo: Gi,
  activity: Ri,
  "easel2-fill": 63084,
  easel2: Fi,
  "easel3-fill": 63086,
  easel3: Yi,
  fan: Ki,
  fingerprint: Ji,
  "graph-down-arrow": 63090,
  "graph-up-arrow": 63091,
  hypnotize: Qi,
  magic: Xi,
  "person-rolodex": 63094,
  "person-video": 63095,
  "person-video2": 63096,
  "person-video3": 63097,
  "person-workspace": 63098,
  radioactive: Zi,
  "webcam-fill": 63100,
  webcam: en,
  "yin-yang": 63102,
  "bandaid-fill": 63104,
  bandaid: tn,
  bluetooth: sn,
  "body-text": 63107,
  boombox: ln,
  boxes: an,
  "dpad-fill": 63110,
  dpad: on,
  "ear-fill": 63112,
  ear: nn,
  "envelope-check-fill": 63115,
  "envelope-check": 63116,
  "envelope-dash-fill": 63118,
  "envelope-dash": 63119,
  "envelope-exclamation-fill": 63121,
  "envelope-exclamation": 63122,
  "envelope-plus-fill": 63123,
  "envelope-plus": 63124,
  "envelope-slash-fill": 63126,
  "envelope-slash": 63127,
  "envelope-x-fill": 63129,
  "envelope-x": 63130,
  "explicit-fill": 63131,
  explicit: rn,
  git: cn,
  infinity: dn,
  "list-columns-reverse": 63135,
  "list-columns": 63136,
  meta: un,
  "nintendo-switch": 63140,
  "pc-display-horizontal": 63141,
  "pc-display": 63142,
  "pc-horizontal": 63143,
  pc: pn,
  playstation: fn,
  "plus-slash-minus": 63146,
  "projector-fill": 63147,
  projector: mn,
  "qr-code-scan": 63149,
  "qr-code": 63150,
  quora: hn,
  quote: bn,
  robot: gn,
  "send-check-fill": 63154,
  "send-check": 63155,
  "send-dash-fill": 63156,
  "send-dash": 63157,
  "send-exclamation-fill": 63159,
  "send-exclamation": 63160,
  "send-fill": 63161,
  "send-plus-fill": 63162,
  "send-plus": 63163,
  "send-slash-fill": 63164,
  "send-slash": 63165,
  "send-x-fill": 63166,
  "send-x": 63167,
  send: yn,
  steam: vn,
  "terminal-dash": 63171,
  "terminal-plus": 63172,
  "terminal-split": 63173,
  "ticket-detailed-fill": 63174,
  "ticket-detailed": 63175,
  "ticket-fill": 63176,
  "ticket-perforated-fill": 63177,
  "ticket-perforated": 63178,
  ticket: kn,
  tiktok: wn,
  "window-dash": 63181,
  "window-desktop": 63182,
  "window-fullscreen": 63183,
  "window-plus": 63184,
  "window-split": 63185,
  "window-stack": 63186,
  "window-x": 63187,
  xbox: xn,
  ethernet: Cn,
  "hdmi-fill": 63190,
  hdmi: $n,
  "usb-c-fill": 63192,
  "usb-c": 63193,
  "usb-fill": 63194,
  "usb-plug-fill": 63195,
  "usb-plug": 63196,
  "usb-symbol": 63197,
  usb: _n,
  "boombox-fill": 63199,
  displayport: Tn,
  "gpu-card": 63202,
  memory: zn,
  "modem-fill": 63204,
  modem: qn,
  "motherboard-fill": 63206,
  motherboard: jn,
  "optical-audio-fill": 63208,
  "optical-audio": 63209,
  "pci-card": 63210,
  "router-fill": 63211,
  router: Sn,
  "thunderbolt-fill": 63215,
  thunderbolt: An,
  "usb-drive-fill": 63217,
  "usb-drive": 63218,
  "usb-micro-fill": 63219,
  "usb-micro": 63220,
  "usb-mini-fill": 63221,
  "usb-mini": 63222,
  "cloud-haze2": 63223,
  "device-hdd-fill": 63224,
  "device-hdd": 63225,
  "device-ssd-fill": 63226,
  "device-ssd": 63227,
  "displayport-fill": 63228,
  "mortarboard-fill": 63229,
  mortarboard: In,
  "terminal-x": 63231,
  "arrow-through-heart-fill": 63232,
  "arrow-through-heart": 63233,
  "badge-sd-fill": 63234,
  "badge-sd": 63235,
  "bag-heart-fill": 63236,
  "bag-heart": 63237,
  "balloon-fill": 63238,
  "balloon-heart-fill": 63239,
  "balloon-heart": 63240,
  balloon: Mn,
  "box2-fill": 63242,
  "box2-heart-fill": 63243,
  "box2-heart": 63244,
  box2: Ln,
  "braces-asterisk": 63246,
  "calendar-heart-fill": 63247,
  "calendar-heart": 63248,
  "calendar2-heart-fill": 63249,
  "calendar2-heart": 63250,
  "chat-heart-fill": 63251,
  "chat-heart": 63252,
  "chat-left-heart-fill": 63253,
  "chat-left-heart": 63254,
  "chat-right-heart-fill": 63255,
  "chat-right-heart": 63256,
  "chat-square-heart-fill": 63257,
  "chat-square-heart": 63258,
  "clipboard-check-fill": 63259,
  "clipboard-data-fill": 63260,
  "clipboard-fill": 63261,
  "clipboard-heart-fill": 63262,
  "clipboard-heart": 63263,
  "clipboard-minus-fill": 63264,
  "clipboard-plus-fill": 63265,
  "clipboard-pulse": 63266,
  "clipboard-x-fill": 63267,
  "clipboard2-check-fill": 63268,
  "clipboard2-check": 63269,
  "clipboard2-data-fill": 63270,
  "clipboard2-data": 63271,
  "clipboard2-fill": 63272,
  "clipboard2-heart-fill": 63273,
  "clipboard2-heart": 63274,
  "clipboard2-minus-fill": 63275,
  "clipboard2-minus": 63276,
  "clipboard2-plus-fill": 63277,
  "clipboard2-plus": 63278,
  "clipboard2-pulse-fill": 63279,
  "clipboard2-pulse": 63280,
  "clipboard2-x-fill": 63281,
  "clipboard2-x": 63282,
  clipboard2: Bn,
  "emoji-kiss-fill": 63284,
  "emoji-kiss": 63285,
  "envelope-heart-fill": 63286,
  "envelope-heart": 63287,
  "envelope-open-heart-fill": 63288,
  "envelope-open-heart": 63289,
  "envelope-paper-fill": 63290,
  "envelope-paper-heart-fill": 63291,
  "envelope-paper-heart": 63292,
  "envelope-paper": 63293,
  "filetype-aac": 63294,
  "filetype-ai": 63295,
  "filetype-bmp": 63296,
  "filetype-cs": 63297,
  "filetype-css": 63298,
  "filetype-csv": 63299,
  "filetype-doc": 63300,
  "filetype-docx": 63301,
  "filetype-exe": 63302,
  "filetype-gif": 63303,
  "filetype-heic": 63304,
  "filetype-html": 63305,
  "filetype-java": 63306,
  "filetype-jpg": 63307,
  "filetype-js": 63308,
  "filetype-jsx": 63309,
  "filetype-key": 63310,
  "filetype-m4p": 63311,
  "filetype-md": 63312,
  "filetype-mdx": 63313,
  "filetype-mov": 63314,
  "filetype-mp3": 63315,
  "filetype-mp4": 63316,
  "filetype-otf": 63317,
  "filetype-pdf": 63318,
  "filetype-php": 63319,
  "filetype-png": 63320,
  "filetype-ppt": 63322,
  "filetype-psd": 63323,
  "filetype-py": 63324,
  "filetype-raw": 63325,
  "filetype-rb": 63326,
  "filetype-sass": 63327,
  "filetype-scss": 63328,
  "filetype-sh": 63329,
  "filetype-svg": 63330,
  "filetype-tiff": 63331,
  "filetype-tsx": 63332,
  "filetype-ttf": 63333,
  "filetype-txt": 63334,
  "filetype-wav": 63335,
  "filetype-woff": 63336,
  "filetype-xls": 63338,
  "filetype-xml": 63339,
  "filetype-yml": 63340,
  "heart-arrow": 63341,
  "heart-pulse-fill": 63342,
  "heart-pulse": 63343,
  "heartbreak-fill": 63344,
  heartbreak: Hn,
  hearts: Pn,
  "hospital-fill": 63347,
  hospital: Nn,
  "house-heart-fill": 63349,
  "house-heart": 63350,
  incognito: En,
  "magnet-fill": 63352,
  magnet: Un,
  "person-heart": 63354,
  "person-hearts": 63355,
  "phone-flip": 63356,
  plugin: Vn,
  "postage-fill": 63358,
  "postage-heart-fill": 63359,
  "postage-heart": 63360,
  postage: On,
  "postcard-fill": 63362,
  "postcard-heart-fill": 63363,
  "postcard-heart": 63364,
  postcard: Wn,
  "search-heart-fill": 63366,
  "search-heart": 63367,
  "sliders2-vertical": 63368,
  sliders2: Dn,
  "trash3-fill": 63370,
  trash3: Gn,
  valentine: Rn,
  valentine2: Fn,
  "wrench-adjustable-circle-fill": 63374,
  "wrench-adjustable-circle": 63375,
  "wrench-adjustable": 63376,
  "filetype-json": 63377,
  "filetype-pptx": 63378,
  "filetype-xlsx": 63379,
  "1-circle-fill": 63382,
  "1-circle": 63383,
  "1-square-fill": 63384,
  "1-square": 63385,
  "2-circle-fill": 63388,
  "2-circle": 63389,
  "2-square-fill": 63390,
  "2-square": 63391,
  "3-circle-fill": 63394,
  "3-circle": 63395,
  "3-square-fill": 63396,
  "3-square": 63397,
  "4-circle-fill": 63400,
  "4-circle": 63401,
  "4-square-fill": 63402,
  "4-square": 63403,
  "5-circle-fill": 63406,
  "5-circle": 63407,
  "5-square-fill": 63408,
  "5-square": 63409,
  "6-circle-fill": 63412,
  "6-circle": 63413,
  "6-square-fill": 63414,
  "6-square": 63415,
  "7-circle-fill": 63418,
  "7-circle": 63419,
  "7-square-fill": 63420,
  "7-square": 63421,
  "8-circle-fill": 63424,
  "8-circle": 63425,
  "8-square-fill": 63426,
  "8-square": 63427,
  "9-circle-fill": 63430,
  "9-circle": 63431,
  "9-square-fill": 63432,
  "9-square": 63433,
  "airplane-engines-fill": 63434,
  "airplane-engines": 63435,
  "airplane-fill": 63436,
  airplane: Yn,
  alexa: Kn,
  alipay: Jn,
  android: Qn,
  android2: Xn,
  "box-fill": 63442,
  "box-seam-fill": 63443,
  "browser-chrome": 63444,
  "browser-edge": 63445,
  "browser-firefox": 63446,
  "browser-safari": 63447,
  "c-circle-fill": 63450,
  "c-circle": 63451,
  "c-square-fill": 63452,
  "c-square": 63453,
  "capsule-pill": 63454,
  capsule: Zn,
  "car-front-fill": 63456,
  "car-front": 63457,
  "cassette-fill": 63458,
  cassette: er,
  "cc-circle-fill": 63462,
  "cc-circle": 63463,
  "cc-square-fill": 63464,
  "cc-square": 63465,
  "cup-hot-fill": 63466,
  "cup-hot": 63467,
  "currency-rupee": 63468,
  dropbox: tr,
  escape: 63470,
  "fast-forward-btn-fill": 63471,
  "fast-forward-btn": 63472,
  "fast-forward-circle-fill": 63473,
  "fast-forward-circle": 63474,
  "fast-forward-fill": 63475,
  "fast-forward": 63476,
  "filetype-sql": 63477,
  fire: sr,
  "google-play": 63479,
  "h-circle-fill": 63482,
  "h-circle": 63483,
  "h-square-fill": 63484,
  "h-square": 63485,
  indent: lr,
  "lungs-fill": 63487,
  lungs: ar,
  "microsoft-teams": 63489,
  "p-circle-fill": 63492,
  "p-circle": 63493,
  "p-square-fill": 63494,
  "p-square": 63495,
  "pass-fill": 63496,
  pass: or,
  prescription: ir,
  prescription2: nr,
  "r-circle-fill": 63502,
  "r-circle": 63503,
  "r-square-fill": 63504,
  "r-square": 63505,
  "repeat-1": 63506,
  repeat: rr,
  "rewind-btn-fill": 63508,
  "rewind-btn": 63509,
  "rewind-circle-fill": 63510,
  "rewind-circle": 63511,
  "rewind-fill": 63512,
  rewind: cr,
  "train-freight-front-fill": 63514,
  "train-freight-front": 63515,
  "train-front-fill": 63516,
  "train-front": 63517,
  "train-lightrail-front-fill": 63518,
  "train-lightrail-front": 63519,
  "truck-front-fill": 63520,
  "truck-front": 63521,
  ubuntu: dr,
  unindent: ur,
  unity: pr,
  "universal-access-circle": 63525,
  "universal-access": 63526,
  virus: fr,
  virus2: mr,
  wechat: hr,
  yelp: br,
  "sign-stop-fill": 63531,
  "sign-stop-lights-fill": 63532,
  "sign-stop-lights": 63533,
  "sign-stop": 63534,
  "sign-turn-left-fill": 63535,
  "sign-turn-left": 63536,
  "sign-turn-right-fill": 63537,
  "sign-turn-right": 63538,
  "sign-turn-slight-left-fill": 63539,
  "sign-turn-slight-left": 63540,
  "sign-turn-slight-right-fill": 63541,
  "sign-turn-slight-right": 63542,
  "sign-yield-fill": 63543,
  "sign-yield": 63544,
  "ev-station-fill": 63545,
  "ev-station": 63546,
  "fuel-pump-diesel-fill": 63547,
  "fuel-pump-diesel": 63548,
  "fuel-pump-fill": 63549,
  "fuel-pump": 63550,
  "0-circle-fill": 63551,
  "0-circle": 63552,
  "0-square-fill": 63553,
  "0-square": 63554,
  "rocket-fill": 63555,
  "rocket-takeoff-fill": 63556,
  "rocket-takeoff": 63557,
  rocket: gr,
  stripe: yr,
  subscript: vr,
  superscript: kr,
  trello: wr,
  "envelope-at-fill": 63563,
  "envelope-at": 63564,
  regex: xr,
  "text-wrap": 63566,
  "sign-dead-end-fill": 63567,
  "sign-dead-end": 63568,
  "sign-do-not-enter-fill": 63569,
  "sign-do-not-enter": 63570,
  "sign-intersection-fill": 63571,
  "sign-intersection-side-fill": 63572,
  "sign-intersection-side": 63573,
  "sign-intersection-t-fill": 63574,
  "sign-intersection-t": 63575,
  "sign-intersection-y-fill": 63576,
  "sign-intersection-y": 63577,
  "sign-intersection": 63578,
  "sign-merge-left-fill": 63579,
  "sign-merge-left": 63580,
  "sign-merge-right-fill": 63581,
  "sign-merge-right": 63582,
  "sign-no-left-turn-fill": 63583,
  "sign-no-left-turn": 63584,
  "sign-no-parking-fill": 63585,
  "sign-no-parking": 63586,
  "sign-no-right-turn-fill": 63587,
  "sign-no-right-turn": 63588,
  "sign-railroad-fill": 63589,
  "sign-railroad": 63590,
  "building-add": 63591,
  "building-check": 63592,
  "building-dash": 63593,
  "building-down": 63594,
  "building-exclamation": 63595,
  "building-fill-add": 63596,
  "building-fill-check": 63597,
  "building-fill-dash": 63598,
  "building-fill-down": 63599,
  "building-fill-exclamation": 63600,
  "building-fill-gear": 63601,
  "building-fill-lock": 63602,
  "building-fill-slash": 63603,
  "building-fill-up": 63604,
  "building-fill-x": 63605,
  "building-fill": 63606,
  "building-gear": 63607,
  "building-lock": 63608,
  "building-slash": 63609,
  "building-up": 63610,
  "building-x": 63611,
  "buildings-fill": 63612,
  buildings: Cr,
  "bus-front-fill": 63614,
  "bus-front": 63615,
  "ev-front-fill": 63616,
  "ev-front": 63617,
  "globe-americas": 63618,
  "globe-asia-australia": 63619,
  "globe-central-south-asia": 63620,
  "globe-europe-africa": 63621,
  "house-add-fill": 63622,
  "house-add": 63623,
  "house-check-fill": 63624,
  "house-check": 63625,
  "house-dash-fill": 63626,
  "house-dash": 63627,
  "house-down-fill": 63628,
  "house-down": 63629,
  "house-exclamation-fill": 63630,
  "house-exclamation": 63631,
  "house-gear-fill": 63632,
  "house-gear": 63633,
  "house-lock-fill": 63634,
  "house-lock": 63635,
  "house-slash-fill": 63636,
  "house-slash": 63637,
  "house-up-fill": 63638,
  "house-up": 63639,
  "house-x-fill": 63640,
  "house-x": 63641,
  "person-add": 63642,
  "person-down": 63643,
  "person-exclamation": 63644,
  "person-fill-add": 63645,
  "person-fill-check": 63646,
  "person-fill-dash": 63647,
  "person-fill-down": 63648,
  "person-fill-exclamation": 63649,
  "person-fill-gear": 63650,
  "person-fill-lock": 63651,
  "person-fill-slash": 63652,
  "person-fill-up": 63653,
  "person-fill-x": 63654,
  "person-gear": 63655,
  "person-lock": 63656,
  "person-slash": 63657,
  "person-up": 63658,
  scooter: $r,
  "taxi-front-fill": 63660,
  "taxi-front": 63661,
  amd: _r,
  "database-add": 63663,
  "database-check": 63664,
  "database-dash": 63665,
  "database-down": 63666,
  "database-exclamation": 63667,
  "database-fill-add": 63668,
  "database-fill-check": 63669,
  "database-fill-dash": 63670,
  "database-fill-down": 63671,
  "database-fill-exclamation": 63672,
  "database-fill-gear": 63673,
  "database-fill-lock": 63674,
  "database-fill-slash": 63675,
  "database-fill-up": 63676,
  "database-fill-x": 63677,
  "database-fill": 63678,
  "database-gear": 63679,
  "database-lock": 63680,
  "database-slash": 63681,
  "database-up": 63682,
  "database-x": 63683,
  database: Tr,
  "houses-fill": 63685,
  houses: zr,
  nvidia: qr,
  "person-vcard-fill": 63688,
  "person-vcard": 63689,
  "sina-weibo": 63690,
  "tencent-qq": 63691,
  wikipedia: jr,
  "alphabet-uppercase": 62117,
  alphabet: Sr,
  amazon: Ar,
  "arrows-collapse-vertical": 63120,
  "arrows-expand-vertical": 63125,
  "arrows-vertical": 63128,
  arrows: Ir,
  "ban-fill": 63139,
  ban: Mr,
  bing: Lr,
  cake: Br,
  cake2: Hr,
  cookie: Pr,
  copy: Nr,
  crosshair: Er,
  crosshair2: Ur,
  "emoji-astonished-fill": 63381,
  "emoji-astonished": 63386,
  "emoji-grimace-fill": 63387,
  "emoji-grimace": 63392,
  "emoji-grin-fill": 63393,
  "emoji-grin": 63398,
  "emoji-surprise-fill": 63399,
  "emoji-surprise": 63404,
  "emoji-tear-fill": 63405,
  "emoji-tear": 63410,
  "envelope-arrow-down-fill": 63411,
  "envelope-arrow-down": 63416,
  "envelope-arrow-up-fill": 63417,
  "envelope-arrow-up": 63422,
  feather: Vr,
  feather2: Or,
  "floppy-fill": 63429,
  floppy: Wr,
  "floppy2-fill": 63449,
  floppy2: Dr,
  gitlab: Gr,
  highlighter: Rr,
  "marker-tip": 63490,
  "nvme-fill": 63491,
  nvme: Fr,
  opencollective: Yr,
  "pci-card-network": 63693,
  "pci-card-sound": 63694,
  radar: Kr,
  "send-arrow-down-fill": 63696,
  "send-arrow-down": 63697,
  "send-arrow-up-fill": 63698,
  "send-arrow-up": 63699,
  "sim-slash-fill": 63700,
  "sim-slash": 63701,
  sourceforge: Jr,
  substack: Qr,
  "threads-fill": 63704,
  threads: Xr,
  transparency: Zr,
  "twitter-x": 63707,
  "type-h4": 63708,
  "type-h5": 63709,
  "type-h6": 63710,
  "backpack-fill": 63711,
  backpack: ec,
  "backpack2-fill": 63713,
  backpack2: tc,
  "backpack3-fill": 63715,
  backpack3: sc,
  "backpack4-fill": 63717,
  backpack4: lc,
  brilliance: ac,
  "cake-fill": 63720,
  "cake2-fill": 63721,
  "duffle-fill": 63722,
  duffle: oc,
  exposure: ic,
  "gender-neuter": 63725,
  highlights: nc,
  "luggage-fill": 63727,
  luggage: rc,
  "mailbox-flag": 63729,
  "mailbox2-flag": 63730,
  "noise-reduction": 63731,
  "passport-fill": 63732,
  passport: cc,
  "person-arms-up": 63734,
  "person-raised-hand": 63735,
  "person-standing-dress": 63736,
  "person-standing": 63737,
  "person-walking": 63738,
  "person-wheelchair": 63739,
  shadows: dc,
  "suitcase-fill": 63741,
  "suitcase-lg-fill": 63742,
  "suitcase-lg": 63743,
  suitcase: uc,
  "suitcase2-fill": 63745,
  suitcase2: pc,
  vignette: fc,
  bluesky: mc,
  tux: hc,
  "beaker-fill": 63749,
  beaker: bc,
  "flask-fill": 63751,
  "flask-florence-fill": 63752,
  "flask-florence": 63753,
  flask: gc,
  "leaf-fill": 63755,
  leaf: yc,
  "measuring-cup-fill": 63757,
  "measuring-cup": 63758,
  "unlock2-fill": 63759,
  unlock2: vc,
  "battery-low": 63761,
  anthropic: kc,
  "apple-music": 63763,
  claude: wc,
  openai: xc,
  perplexity: Cc,
  css: $c,
  javascript: _c,
  typescript: Tc,
  "fork-knife": 63770,
  "globe-americas-fill": 63771,
  "globe-asia-australia-fill": 63772,
  "globe-central-south-asia-fill": 63773,
  "globe-europe-africa-fill": 63774
}, fe = new Set(Object.keys(zc)), qc = {
  fire: "lightning",
  flame: "lightning",
  bolt: "lightning",
  flash: "lightning",
  "water-drop": "droplet",
  drop: "droplet",
  snow: "water",
  leaf: "tree",
  plant: "flower1",
  flower: "flower1",
  phone: "telephone",
  "phone-fill": "telephone-fill",
  call: "telephone",
  mail: "envelope",
  email: "envelope",
  settings: "gear",
  cog: "gear",
  home: "house",
  location: "geo-alt",
  "map-pin": "geo-alt",
  pin: "pin-map",
  spanner: "wrench",
  tool: "tools",
  toolbox: "tools",
  wallet2: "wallet",
  money: "cash-stack",
  cash: "cash-stack",
  euro: "currency-euro",
  dollar: "currency-dollar",
  shield: "shield-check",
  "shield-lock": "shield-check",
  medal: "award",
  certificate: "patch-check",
  verified: "patch-check",
  thumbs: "hand-thumbs-up",
  "thumbs-up": "hand-thumbs-up",
  smile: "emoji-smile",
  happy: "emoji-smile",
  idea: "lightbulb",
  bulb: "lightbulb",
  time: "clock",
  timer: "stopwatch",
  speed: "lightning",
  fast: "lightning",
  delivery: "truck",
  shipping: "truck",
  team: "people",
  group: "people",
  user: "person",
  customer: "person",
  quality: "patch-check",
  growth: "graph-up-arrow",
  chart: "bar-chart",
  paint: "paint-bucket",
  brush: "paint-bucket",
  build: "tools",
  construction: "bricks",
  ruler: "rulers",
  contact: "envelope",
  support: "chat-dots",
  help: "question-circle",
  info: "info-circle",
  warning: "exclamation-triangle"
}, jc = "check-circle";
function Sc(w) {
  return w.trim().toLowerCase().replace(/^bi\s+/, "").replace(/^bi-/, "");
}
function Ac(w) {
  const s = Sc(w);
  if (fe.has(s)) return s;
  const a = qc[s];
  return a && fe.has(a) ? a : jc;
}
function V(w) {
  return `bi bi-${Ac(w)}`;
}
const Ic = { class: "h-100 d-flex flex-column" }, Mc = {
  key: 0,
  class: "align-self-start d-inline-block px-2 py-1 small fw-semibold bg-primary-100 text-primary-700 rounded mb-2"
}, Lc = { class: "flex-grow-1 d-flex flex-column" }, Bc = ["innerHTML"], Hc = { class: "mt-auto pt-3" }, Pc = { class: "d-flex align-items-center justify-content-center gap-2 mb-2" }, Nc = ["src", "alt"], Ec = { class: "text-center" }, Uc = {
  key: 0,
  class: "text-surface-600 small mb-0"
}, Vc = {
  key: 0,
  class: "d-inline-flex align-items-center justify-content-center rounded-3 text-primary fs-4 mb-3 flex-shrink-0",
  style: { width: "3rem", height: "3rem", "background-color": "var(--bs-primary-100, #e0e7ff)" }
}, Oc = {
  key: 1,
  class: "text-surface-600 mb-2"
}, Wc = ["innerHTML"], Dc = /* @__PURE__ */ H({
  __name: "CardContent",
  props: {
    item: {},
    size: { default: "medium" },
    showButton: { type: Boolean, default: !0 },
    buttonText: {},
    buttonStyle: { default: "text" }
  },
  setup(w) {
    const s = w, a = Z(), n = i(() => `${{
      small: "fs-5",
      medium: "fs-4",
      large: "fs-3",
      "extra-large": "fs-2",
      professional: "fs-5",
      dramatic: "fs-3"
    }[s.size] || "fs-5"} fw-semibold text-surface-900 mb-2`), b = (c) => {
      c.startsWith("http") || c.startsWith("mailto:") || c.startsWith("tel:") ? window.open(c, "_blank") : a.push(c);
    }, v = (c) => (c.startsWith("http"), c);
    return (c, m) => {
      var d;
      return e(), t("div", Ic, [
        c.item && c.item.badge ? (e(), t("span", Mc, p(c.item.badge), 1)) : u("", !0),
        c.item && c.item.image ? (e(), t(j, { key: 1 }, [
          l("div", Lc, [
            c.item.description ? (e(), t("div", {
              key: 0,
              class: "text-surface-700 lh-relaxed mb-3 flex-grow-1",
              innerHTML: c.item.description
            }, null, 8, Bc)) : u("", !0)
          ]),
          l("div", Hc, [
            l("div", Pc, [
              l("img", {
                src: v(c.item.image.url),
                alt: c.item.image.alternativeText || c.item.title || "",
                class: "rounded-circle object-fit-cover",
                style: { width: "3rem", height: "3rem" }
              }, null, 8, Nc),
              l("div", Ec, [
                l("h3", {
                  class: r(n.value)
                }, p(c.item.title), 3),
                c.item.subtitle ? (e(), t("p", Uc, p(c.item.subtitle), 1)) : u("", !0)
              ])
            ])
          ])
        ], 64)) : c.item ? (e(), t(j, { key: 2 }, [
          c.item.icon ? (e(), t("div", Vc, [
            l("i", {
              class: r(U(V)(c.item.icon))
            }, null, 2)
          ])) : u("", !0),
          l("h3", {
            class: r(n.value)
          }, p(c.item.title), 3),
          c.item.subtitle ? (e(), t("p", Oc, p(c.item.subtitle), 1)) : u("", !0),
          c.item.description ? (e(), t("div", {
            key: 2,
            class: "text-surface-700 lh-relaxed mb-3 flex-grow-1",
            innerHTML: c.item.description
          }, null, 8, Wc)) : u("", !0)
        ], 64)) : u("", !0),
        c.showButton && ((d = c.item) != null && d.link) ? (e(), W(O, {
          key: 3,
          label: c.buttonText || "Learn More",
          onClick: m[0] || (m[0] = () => {
            var o;
            return b(((o = c.item) == null ? void 0 : o.link) || "");
          }),
          severity: c.buttonStyle === "text" ? void 0 : c.buttonStyle,
          outlined: c.buttonStyle === "outline",
          text: c.buttonStyle === "text",
          icon: "bi bi-arrow-right",
          iconPos: "right",
          class: "align-self-start mt-auto"
        }, null, 8, ["label", "severity", "outlined", "text"])) : u("", !0)
      ]);
    };
  }
}), ne = /* @__PURE__ */ E(Dc, [["__scopeId", "data-v-da1aace3"]]), Gc = {
  key: 0,
  class: "h-100"
}, Rc = ["src", "alt"], Fc = {
  key: 1,
  class: "d-flex gap-3 flex-grow-1"
}, Yc = ["src", "alt"], Kc = { class: "flex-grow-1" }, Jc = { class: "p-4 h-100 d-flex flex-column" }, Qc = {
  key: 2,
  class: "d-flex gap-3 flex-grow-1"
}, Xc = { class: "flex-grow-1" }, Zc = { class: "p-4 h-100 d-flex flex-column" }, ed = ["src", "alt"], td = {
  key: 3,
  class: "flex-grow-1 d-flex flex-column"
}, sd = { class: "p-4 flex-grow-1 d-flex flex-column" }, ld = {
  key: 1,
  class: "h-100"
}, ad = {
  key: 0,
  class: "d-inline-flex align-items-center justify-content-center rounded-3 text-primary fs-4 flex-shrink-0",
  style: { width: "3rem", height: "3rem", "background-color": "var(--bs-primary-100, #e0e7ff)" }
}, od = { class: "flex-grow-1 min-w-0" }, id = {
  key: 2,
  class: "h-100"
}, nd = {
  key: 3,
  class: "h-100"
}, rd = ["src", "alt"], cd = {
  key: 1,
  class: "w-100 h-100 bg-gradient-primary-overlay"
}, dd = { class: "position-absolute top-0 start-0 w-100 h-100 overlay-hover-gradient" }, ud = { class: "position-absolute bottom-0 start-0 end-0 p-4 text-white overlay-hover-content" }, pd = {
  key: 1,
  class: "fs-3 fw-bold mb-2"
}, fd = {
  key: 2,
  class: "text-white opacity-75 mb-3"
}, md = /* @__PURE__ */ H({
  __name: "CardSection",
  props: {
    __component: {},
    id: {},
    title: {},
    layout: {},
    emphasis: { default: "normal" },
    alignment: { default: "left" },
    cardStyle: { default: "elevated" },
    size: { default: "medium" },
    imagePosition: { default: "top" },
    imageAspectRatio: { default: "landscape" },
    showButtons: { type: Boolean, default: !0 },
    buttonText: {},
    buttonStyle: { default: "text" },
    equalHeight: { type: Boolean },
    item: {}
  },
  setup(w) {
    const s = w, a = Z(), n = i(() => {
      var k, S;
      return s.layout ? s.layout : (k = s.item) != null && k.icon && !((S = s.item) != null && S.image) ? "compact" : "standard";
    }), b = (k) => k || "", v = i(() => ({
      elevated: "bg-white shadow-lg card-hover-shadow",
      outlined: "bg-white border border-2 border-surface-200 card-hover-border",
      flat: "bg-surface-50",
      gradient: "bg-gradient-primary-light"
    })[s.cardStyle || "elevated"]), c = i(() => `overflow-hidden ${{
      square: "ratio ratio-1x1",
      landscape: "ratio ratio-16x9",
      portrait: "card-aspect-portrait",
      auto: ""
    }[s.imageAspectRatio || "landscape"]}`), m = i(() => "w-100 h-100 object-fit-cover card-img-hover");
    i(() => `${{
      small: "fs-5",
      medium: "fs-3",
      large: "fs-2",
      "extra-large": "fs-1",
      professional: "fs-5",
      dramatic: "fs-2"
    }[s.size || "medium"]} text-primary flex-shrink-0`);
    const d = i(() => "d-flex align-items-start gap-3 p-3 bg-white rounded-3 border border-surface-200 card-hover-border"), o = i(() => "fs-5 fw-semibold text-surface-900 mb-1"), f = i(() => "text-surface-600 small lh-relaxed"), h = i(() => {
      const k = {
        elevated: "bg-primary text-white shadow-lg rounded-3",
        outlined: "border border-2 border-primary text-primary rounded-3",
        flat: "bg-primary-light text-primary rounded-3",
        gradient: "bg-gradient-primary text-white rounded-3"
      }, S = {
        small: "p-3",
        medium: "p-4",
        large: "p-5",
        "extra-large": "p-5",
        professional: "p-3",
        dramatic: "p-5"
      };
      return `${k[s.cardStyle || "elevated"]} ${S[s.size || "medium"]} text-center card-hover-lift`;
    }), $ = i(() => `${{
      small: "fs-3 mb-2",
      medium: "fs-1 mb-2",
      large: "display-5 mb-3",
      "extra-large": "display-4 mb-3",
      professional: "fs-2 mb-2",
      dramatic: "display-5 mb-3"
    }[s.size || "medium"]} opacity-75`), x = i(() => `${{
      small: "fs-2",
      medium: "fs-1",
      large: "display-5",
      "extra-large": "display-4",
      professional: "fs-2",
      dramatic: "display-5"
    }[s.size || "medium"]} fw-bold mb-2 lh-1`), _ = i(() => `${{
      small: "small",
      medium: "fs-6",
      large: "fs-5",
      "extra-large": "fs-4",
      professional: "small",
      dramatic: "fs-5"
    }[s.size || "medium"]} fw-semibold text-uppercase letter-spacing-wide opacity-75`), T = i(() => "small opacity-75 lh-relaxed mt-2"), z = i(() => "card-overlay-group position-relative overflow-hidden rounded-4 shadow-lg card-hover-shadow-xl"), N = i(() => `${{
      square: "ratio ratio-1x1",
      landscape: "ratio ratio-16x9",
      portrait: "card-aspect-portrait",
      auto: "ratio ratio-1x1"
    }[s.imageAspectRatio || "square"]} overflow-hidden`), M = (k) => {
      k && (k.startsWith("http") || k.startsWith("mailto:") || k.startsWith("tel:") ? window.open(k, "_blank") : a.push(k));
    };
    return (k, S) => {
      var D, A, g, B, y, q, L, G, F, C, Y, Q, K;
      return n.value === "standard" ? (e(), t("div", Gc, [
        l("div", {
          class: r([v.value, "rounded-3 overflow-hidden h-100 d-flex flex-column"])
        }, [
          k.item && k.item.image && k.imagePosition === "top" ? (e(), t("div", {
            key: 0,
            class: r(c.value)
          }, [
            l("img", {
              src: b(k.item.image.url),
              alt: ((A = (D = k.item) == null ? void 0 : D.image) == null ? void 0 : A.alternativeText) || ((g = k.item) == null ? void 0 : g.title) || "",
              class: r(m.value)
            }, null, 10, Rc)
          ], 2)) : u("", !0),
          k.item && k.item.image && k.imagePosition === "left" ? (e(), t("div", Fc, [
            l("img", {
              src: b(k.item.image.url),
              alt: ((y = (B = k.item) == null ? void 0 : B.image) == null ? void 0 : y.alternativeText) || ((q = k.item) == null ? void 0 : q.title) || "",
              class: "card-side-img object-fit-cover rounded-3 flex-shrink-0"
            }, null, 8, Yc),
            l("div", Kc, [
              l("div", Jc, [
                R(ne, {
                  item: k.item,
                  size: k.size,
                  "show-button": k.showButtons,
                  "button-text": k.buttonText,
                  "button-style": k.buttonStyle
                }, null, 8, ["item", "size", "show-button", "button-text", "button-style"])
              ])
            ])
          ])) : k.item && k.item.image && k.imagePosition === "right" ? (e(), t("div", Qc, [
            l("div", Xc, [
              l("div", Zc, [
                R(ne, {
                  item: k.item,
                  size: k.size,
                  "show-button": k.showButtons,
                  "button-text": k.buttonText,
                  "button-style": k.buttonStyle
                }, null, 8, ["item", "size", "show-button", "button-text", "button-style"])
              ])
            ]),
            l("img", {
              src: b(k.item.image.url),
              alt: ((G = (L = k.item) == null ? void 0 : L.image) == null ? void 0 : G.alternativeText) || ((F = k.item) == null ? void 0 : F.title) || "",
              class: "card-side-img object-fit-cover rounded-3 flex-shrink-0"
            }, null, 8, ed)
          ])) : (e(), t("div", td, [
            l("div", sd, [
              R(ne, {
                item: k.item,
                size: k.size,
                "show-button": k.showButtons,
                "button-text": k.buttonText,
                "button-style": k.buttonStyle
              }, null, 8, ["item", "size", "show-button", "button-text", "button-style"])
            ])
          ]))
        ], 2)
      ])) : n.value === "compact" ? (e(), t("div", ld, [
        l("div", {
          class: r([d.value, "h-100"])
        }, [
          k.item && k.item.icon ? (e(), t("div", ad, [
            l("i", {
              class: r(U(V)(k.item.icon))
            }, null, 2)
          ])) : u("", !0),
          l("div", od, [
            k.item ? (e(), t("h3", {
              key: 0,
              class: r(o.value)
            }, p(k.item.title), 3)) : u("", !0),
            k.item && k.item.subtitle ? (e(), t("p", {
              key: 1,
              class: r(f.value)
            }, p(k.item.subtitle), 3)) : u("", !0),
            k.item && k.item.description ? (e(), t("p", {
              key: 2,
              class: r(f.value)
            }, p(k.item.description), 3)) : u("", !0),
            k.showButtons && k.item && k.item.link ? (e(), W(O, {
              key: 3,
              label: k.buttonText || "Learn More",
              onClick: S[0] || (S[0] = () => M(k.item.link)),
              severity: k.buttonStyle === "text" ? void 0 : k.buttonStyle,
              text: "",
              size: "small",
              class: "mt-2 p-0"
            }, null, 8, ["label", "severity"])) : u("", !0)
          ])
        ], 2)
      ])) : n.value === "stats" ? (e(), t("div", id, [
        l("div", {
          class: r([h.value, "h-100 d-flex flex-column"])
        }, [
          k.item && k.item.icon ? (e(), t("i", {
            key: 0,
            class: r([U(V)(k.item.icon), $.value])
          }, null, 2)) : u("", !0),
          k.item && k.item.stats ? (e(), t("div", {
            key: 1,
            class: r(x.value)
          }, p(k.item.stats.value), 3)) : k.item ? (e(), t("div", {
            key: 2,
            class: r(x.value)
          }, p(k.item.title), 3)) : u("", !0),
          k.item ? (e(), t("div", {
            key: 3,
            class: r(_.value)
          }, p(((C = k.item.stats) == null ? void 0 : C.label) || k.item.subtitle), 3)) : u("", !0),
          k.item && k.item.description ? (e(), t("p", {
            key: 4,
            class: r(T.value)
          }, p(k.item.description), 3)) : u("", !0)
        ], 2)
      ])) : n.value === "overlay" ? (e(), t("div", nd, [
        l("div", {
          class: r([z.value, "h-100"])
        }, [
          l("div", {
            class: r(N.value)
          }, [
            k.item && k.item.image ? (e(), t("img", {
              key: 0,
              src: b(k.item.image.url),
              alt: ((Q = (Y = k.item) == null ? void 0 : Y.image) == null ? void 0 : Q.alternativeText) || ((K = k.item) == null ? void 0 : K.title) || "",
              class: "w-100 h-100 object-fit-cover overlay-img-zoom"
            }, null, 8, rd)) : (e(), t("div", cd))
          ], 2),
          l("div", dd, [
            l("div", ud, [
              k.item && k.item.icon ? (e(), t("i", {
                key: 0,
                class: r([U(V)(k.item.icon), "fs-3 mb-2"])
              }, null, 2)) : u("", !0),
              k.item ? (e(), t("h3", pd, p(k.item.title), 1)) : u("", !0),
              k.item && k.item.subtitle ? (e(), t("p", fd, p(k.item.subtitle), 1)) : u("", !0),
              k.showButtons && k.item && k.item.link ? (e(), W(O, {
                key: 3,
                label: k.buttonText || "Explore",
                onClick: S[1] || (S[1] = () => M(k.item.link)),
                severity: "secondary",
                class: "overlay-btn"
              }, null, 8, ["label"])) : u("", !0)
            ])
          ])
        ], 2)
      ])) : u("", !0);
    };
  }
}), hd = /* @__PURE__ */ E(md, [["__scopeId", "data-v-0f95e98b"]]), bd = ["id"], gd = { class: "accordion-header" }, yd = ["data-bs-target"], vd = { class: "d-flex align-items-center gap-2 w-100" }, kd = ["id", "data-bs-parent"], wd = { class: "accordion-body" }, xd = ["innerHTML"], Cd = /* @__PURE__ */ H({
  __name: "AccordionSection",
  props: {
    Items: {},
    title: {},
    subtitle: {},
    variant: { default: "default" },
    size: { default: "medium" },
    density: { default: "normal" },
    allowMultiple: { type: Boolean, default: !0 }
  },
  setup(w) {
    const s = w, a = J("accordion-" + Math.random().toString(36).substr(2, 9)), n = i(() => s.density !== "normal" ? s.density : {
      small: "compact",
      medium: "normal",
      large: "loose",
      "extra-large": "loose",
      professional: "compact",
      // Business-focused, tighter spacing
      dramatic: "loose"
      // Creative, generous spacing
    }[s.size] || "normal"), b = i(() => `bg-surface-0 ${{
      compact: "py-5",
      normal: "py-8",
      loose: "py-8 py-md-10"
    }[n.value] || "py-8"}`), v = i(() => ({
      compact: "text-center mb-4",
      normal: "text-center mb-5",
      loose: "text-center mb-7"
    })[n.value] || "text-center mb-5"), c = i(() => ({
      small: "fs-2 fw-bold text-surface-900 mb-2",
      medium: "display-6 fw-bold text-surface-900 mb-3",
      large: "display-5 fw-bold text-surface-900 mb-4",
      "extra-large": "display-4 fw-bold text-surface-900 mb-5",
      professional: "fs-2 fw-bold text-surface-900 mb-2",
      // Efficient sizing
      dramatic: "display-5 fw-bold text-surface-900 mb-4"
      // Large, impactful
    })[s.size]), m = i(() => ({
      small: "text-surface-600",
      medium: "fs-5 text-surface-600",
      large: "fs-4 text-surface-600",
      "extra-large": "fs-3 text-surface-600",
      professional: "text-surface-600",
      dramatic: "fs-4 text-surface-600"
    })[s.size]);
    i(() => ({
      compact: "d-flex flex-column gap-2",
      normal: "d-flex flex-column gap-3",
      loose: "d-flex flex-column gap-4"
    })[n.value] || "d-flex flex-column gap-3");
    const d = i(() => ({
      small: "",
      medium: "fs-5",
      large: "fs-4",
      "extra-large": "fs-3",
      professional: "",
      // Professional sizing
      dramatic: "fs-4"
      // Larger, impactful
    })[s.size]), o = i(() => ({
      small: "fs-5",
      medium: "fs-4",
      large: "fs-3",
      "extra-large": "display-6",
      professional: "fs-5",
      // Modest size
      dramatic: "fs-3"
      // Larger, impactful
    })[s.size]), f = i(() => ({
      small: "fs-sm text-surface-600 lh-relaxed",
      medium: "text-surface-600 lh-relaxed",
      large: "fs-5 text-surface-600 lh-relaxed",
      "extra-large": "fs-4 text-surface-600 lh-relaxed",
      professional: "fs-sm text-surface-600 lh-relaxed",
      // Compact text
      dramatic: "fs-5 text-surface-600 lh-relaxed"
      // Larger, more readable
    })[s.size]);
    return (h, $) => (e(), t("div", {
      class: r(b.value)
    }, [
      h.title || h.subtitle ? (e(), t("div", {
        key: 0,
        class: r(v.value)
      }, [
        h.title ? (e(), t("h2", {
          key: 0,
          class: r(c.value)
        }, p(h.title), 3)) : u("", !0),
        h.subtitle ? (e(), t("p", {
          key: 1,
          class: r(m.value)
        }, p(h.subtitle), 3)) : u("", !0)
      ], 2)) : u("", !0),
      l("div", {
        class: "accordion",
        id: a.value
      }, [
        (e(!0), t(j, null, I(h.Items, (x) => (e(), t("div", {
          key: x.id,
          class: "accordion-item"
        }, [
          l("h2", gd, [
            l("button", {
              class: "accordion-button collapsed",
              type: "button",
              "data-bs-toggle": "collapse",
              "data-bs-target": `#collapse-${a.value}-${x.id}`
            }, [
              l("div", vd, [
                x.icon ? (e(), t("div", {
                  key: 0,
                  class: r([o.value, "text-surface-600"])
                }, p(x.icon), 3)) : u("", !0),
                l("span", {
                  class: r([d.value, "text-surface-900"])
                }, p(x.title), 3)
              ])
            ], 8, yd)
          ]),
          l("div", {
            id: `collapse-${a.value}-${x.id}`,
            class: "accordion-collapse collapse",
            "data-bs-parent": s.allowMultiple ? void 0 : `#${a.value}`
          }, [
            l("div", wd, [
              l("div", {
                class: r(f.value),
                innerHTML: x.content
              }, null, 10, xd)
            ])
          ], 8, kd)
        ]))), 128))
      ], 8, bd)
    ], 2));
  }
}), $d = ["id"], _d = { class: "accordion-header" }, Td = ["data-bs-target"], zd = { class: "d-flex align-items-center gap-2 w-100" }, qd = ["id", "data-bs-parent"], jd = { class: "accordion-body" }, Sd = ["innerHTML"], Ad = /* @__PURE__ */ H({
  __name: "AccordionV2Section",
  props: {
    Items: {},
    title: {},
    subtitle: {},
    style: { default: "default" },
    allowMultiple: { type: Boolean, default: !0 }
  },
  setup(w) {
    const s = w, a = J("accordion-" + Math.random().toString(36).substr(2, 9)), n = i(() => s.style === "compact" ? "accordion-flush" : ""), b = {
      default: "py-8 bg-surface-0",
      // Comfortable spacing
      compact: "py-5 bg-surface-0"
      // Tighter spacing
    }, v = {
      default: "text-center mb-5",
      compact: "text-center mb-4"
    }, c = {
      default: "display-6 fw-bold text-surface-900 mb-3",
      compact: "fs-2 fw-bold text-surface-900 mb-2"
    }, m = {
      default: "fs-5 text-surface-600",
      compact: "text-surface-600"
    }, d = {
      default: "fs-5",
      compact: ""
    }, o = {
      default: "fs-4",
      compact: "fs-5"
    }, f = {
      default: "text-surface-600 lh-relaxed",
      compact: "fs-sm text-surface-600 lh-relaxed"
    }, h = i(() => b[s.style]), $ = i(() => v[s.style]), x = i(() => c[s.style]), _ = i(() => m[s.style]), T = i(() => d[s.style]), z = i(() => o[s.style]), N = i(() => f[s.style]);
    return (M, k) => (e(), t("div", {
      class: r(h.value)
    }, [
      M.title || M.subtitle ? (e(), t("div", {
        key: 0,
        class: r($.value)
      }, [
        M.title ? (e(), t("h2", {
          key: 0,
          class: r(x.value)
        }, p(M.title), 3)) : u("", !0),
        M.subtitle ? (e(), t("p", {
          key: 1,
          class: r(_.value)
        }, p(M.subtitle), 3)) : u("", !0)
      ], 2)) : u("", !0),
      l("div", {
        class: r(["accordion", [n.value]]),
        id: a.value
      }, [
        (e(!0), t(j, null, I(M.Items, (S) => (e(), t("div", {
          key: S.id,
          class: "accordion-item"
        }, [
          l("h2", _d, [
            l("button", {
              class: "accordion-button collapsed",
              type: "button",
              "data-bs-toggle": "collapse",
              "data-bs-target": `#collapse-${a.value}-${S.id}`
            }, [
              l("div", zd, [
                S.icon ? (e(), t("div", {
                  key: 0,
                  class: r([z.value, "text-surface-600"])
                }, p(S.icon), 3)) : u("", !0),
                l("span", {
                  class: r([T.value, "text-surface-900"])
                }, p(S.title), 3)
              ])
            ], 8, Td)
          ]),
          l("div", {
            id: `collapse-${a.value}-${S.id}`,
            class: "accordion-collapse collapse",
            "data-bs-parent": s.allowMultiple ? void 0 : `#${a.value}`
          }, [
            l("div", jd, [
              l("div", {
                class: r(N.value),
                innerHTML: S.content
              }, null, 10, Sd)
            ])
          ], 8, qd)
        ]))), 128))
      ], 10, $d)
    ], 2));
  }
}), Id = ["id"], Md = { class: "accordion-header" }, Ld = ["data-bs-target"], Bd = { class: "d-flex align-items-center gap-2 w-100" }, Hd = ["id", "data-bs-parent"], Pd = { class: "accordion-body" }, Nd = ["innerHTML"], Ed = /* @__PURE__ */ H({
  __name: "AccordionV3",
  props: {
    title: {},
    subtitle: {},
    style: { default: "default" },
    allowMultiple: { type: Boolean, default: !0 },
    Items: {}
  },
  setup(w) {
    const s = w, a = J("accordion-" + Math.random().toString(36).substr(2, 9)), n = i(() => s.style === "compact" ? "accordion-flush" : ""), b = {
      default: "py-8 bg-surface-0",
      // Comfortable spacing
      compact: "py-5 bg-surface-0"
      // Tighter spacing
    }, v = {
      default: "text-center mb-5",
      compact: "text-center mb-4"
    }, c = {
      default: "display-6 fw-bold text-surface-900 mb-3",
      compact: "fs-2 fw-bold text-surface-900 mb-2"
    }, m = {
      default: "fs-5 text-surface-600",
      compact: "text-surface-600"
    }, d = {
      default: "fs-5",
      compact: ""
    }, o = {
      default: "fs-4",
      compact: "fs-5"
    }, f = {
      default: "text-surface-600 lh-relaxed",
      compact: "fs-sm text-surface-600 lh-relaxed"
    }, h = i(() => b[s.style]), $ = i(() => v[s.style]), x = i(() => c[s.style]), _ = i(() => m[s.style]), T = i(() => d[s.style]), z = i(() => o[s.style]), N = i(() => f[s.style]);
    return (M, k) => (e(), t("div", {
      class: r(h.value)
    }, [
      M.title || M.subtitle ? (e(), t("div", {
        key: 0,
        class: r($.value)
      }, [
        M.title ? (e(), t("h2", {
          key: 0,
          class: r(x.value)
        }, p(M.title), 3)) : u("", !0),
        M.subtitle ? (e(), t("p", {
          key: 1,
          class: r(_.value)
        }, p(M.subtitle), 3)) : u("", !0)
      ], 2)) : u("", !0),
      l("div", {
        class: r(["accordion", [n.value]]),
        id: a.value
      }, [
        (e(!0), t(j, null, I(M.Items, (S) => (e(), t("div", {
          key: S.id,
          class: "accordion-item"
        }, [
          l("h2", Md, [
            l("button", {
              class: "accordion-button collapsed",
              type: "button",
              "data-bs-toggle": "collapse",
              "data-bs-target": `#collapse-${a.value}-${S.id}`
            }, [
              l("div", Bd, [
                S.icon ? (e(), t("i", {
                  key: 0,
                  class: r([U(V)(S.icon), z.value, "text-surface-600"])
                }, null, 2)) : u("", !0),
                l("span", {
                  class: r([T.value, "text-surface-900"])
                }, p(S.title), 3)
              ])
            ], 8, Ld)
          ]),
          l("div", {
            id: `collapse-${a.value}-${S.id}`,
            class: "accordion-collapse collapse",
            "data-bs-parent": s.allowMultiple ? void 0 : `#${a.value}`
          }, [
            l("div", Pd, [
              l("div", {
                class: r(N.value),
                innerHTML: S.content
              }, null, 10, Nd)
            ])
          ], 8, Hd)
        ]))), 128))
      ], 10, Id)
    ], 2));
  }
}), we = Symbol("site-config");
function Km() {
  const w = ue(we), s = i(() => w == null ? void 0 : w.value), a = i(() => {
    var d;
    return (d = s.value) == null ? void 0 : d.customColors;
  }), n = i(() => {
    var d;
    return ((d = a.value) == null ? void 0 : d.primary) || {};
  }), b = (d = 500) => n.value[d] || `var(--bs-primary-${d})`, v = i(() => {
    if (!n.value || Object.keys(n.value).length === 0)
      return {};
    const d = {};
    return Object.entries(n.value).forEach(([o, f]) => {
      d[`--bs-primary-${o}`] = f, d[`--site-primary-${o}`] = f;
    }), n.value[500] && (d["--bs-primary"] = n.value[500]), d;
  }), c = i(() => a.value && Object.keys(a.value).length > 0), m = i(() => {
    var d;
    return ((d = s.value) == null ? void 0 : d.defaultTheme) || "default";
  });
  return {
    siteConfig: s,
    customColors: a,
    primaryColors: n,
    getPrimaryColor: b,
    primaryColorVars: v,
    hasCustomColors: c,
    currentTheme: m
  };
}
const Ud = { class: "card-body" }, Vd = { class: "card-title mb-3" }, Od = {
  key: 0,
  class: "text-surface-600 mb-3"
}, Wd = {
  for: "name",
  class: "form-label small fw-medium"
}, Dd = ["placeholder"], Gd = {
  key: 0,
  class: "invalid-feedback"
}, Rd = {
  for: "email",
  class: "form-label small fw-medium"
}, Fd = ["placeholder"], Yd = {
  key: 0,
  class: "invalid-feedback"
}, Kd = {
  for: "message",
  class: "form-label small fw-medium"
}, Jd = ["placeholder"], Qd = {
  key: 0,
  class: "invalid-feedback"
}, Xd = {
  class: "contact-hp",
  "aria-hidden": "true"
}, Zd = ["disabled", "data-label"], eu = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}, tu = {
  key: 0,
  class: "small text-muted mb-0 text-center"
}, su = { class: "d-flex justify-content-between align-items-center" }, lu = /* @__PURE__ */ H({
  __name: "ContactForm",
  props: {
    title: { default: "Contact Us" },
    description: {},
    submitText: { default: "Send Message" },
    successMessage: { default: "Message sent successfully!" },
    nameLabel: { default: "Name" },
    emailLabel: { default: "Email" },
    messageLabel: { default: "Message" },
    namePlaceholder: { default: "Your name" },
    emailPlaceholder: { default: "your@email.com" },
    messagePlaceholder: { default: "Your message..." },
    size: { default: "medium" },
    variant: { default: "default" },
    density: { default: "normal" }
  },
  setup(w) {
    const s = w, a = ue(we, null), n = i(() => {
      var _;
      return ((_ = a == null ? void 0 : a.value) == null ? void 0 : _.slug) || "";
    }), b = i(() => {
      var _;
      return ((_ = a == null ? void 0 : a.value) == null ? void 0 : _.apiBaseUrl) || "";
    }), v = i(() => !!n.value), c = Ce({
      name: "",
      email: "",
      message: "",
      company: ""
    }), m = J(!1), d = J({}), o = J(null), f = i(() => {
      const _ = {
        small: "card mx-auto p-3",
        medium: "card mx-auto p-4",
        large: "card mx-auto p-5",
        "extra-large": "card mx-auto p-5",
        professional: "card mx-auto p-4",
        dramatic: "card mx-auto p-6"
      }, T = {
        default: "",
        compact: "shadow-sm",
        wide: "w-100",
        minimal: "shadow-none border"
      };
      return `${_[s.size]} ${T[s.variant]}`;
    }), h = i(() => ({
      compact: "d-flex flex-column gap-2",
      normal: "d-flex flex-column gap-3",
      loose: "d-flex flex-column gap-4"
    })[s.density]), $ = () => (d.value = {}, c.name.trim() || (d.value.name = "Name is required"), c.email.trim() ? /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(c.email) || (d.value.email = "Please enter a valid email") : d.value.email = "Email is required", c.message.trim() ? c.message.trim().length < 10 && (d.value.message = "Message must be at least 10 characters") : d.value.message = "Message is required", Object.keys(d.value).length === 0), x = async () => {
      if (!(!v.value || !$())) {
        m.value = !0, o.value = null;
        try {
          const _ = await fetch(`${b.value}/api/contact`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              slug: n.value,
              name: c.name,
              email: c.email,
              message: c.message,
              company: c.company,
              pageUrl: typeof window < "u" ? window.location.href : void 0
            })
          }), T = await _.json().catch(() => ({}));
          _.ok && T.success ? (o.value = { success: !0, message: s.successMessage }, c.name = "", c.email = "", c.message = "") : o.value = {
            success: !1,
            message: T.message || "Something went wrong. Please try again."
          };
        } catch {
          o.value = {
            success: !1,
            message: "Network error. Please try again."
          };
        } finally {
          m.value = !1;
        }
      }
    };
    return (_, T) => (e(), t("div", {
      class: r(f.value)
    }, [
      l("div", Ud, [
        l("h5", Vd, p(_.title || "Contact Us"), 1),
        _.description ? (e(), t("p", Od, p(_.description), 1)) : u("", !0),
        l("form", {
          onSubmit: ke(x, ["prevent"]),
          class: r(h.value)
        }, [
          l("div", null, [
            l("label", Wd, p(_.nameLabel || "Name"), 1),
            le(l("input", {
              id: "name",
              "onUpdate:modelValue": T[0] || (T[0] = (z) => c.name = z),
              class: r(["form-control", { "is-invalid": d.value.name }]),
              placeholder: _.namePlaceholder || "Your name",
              required: ""
            }, null, 10, Dd), [
              [ae, c.name]
            ]),
            d.value.name ? (e(), t("div", Gd, p(d.value.name), 1)) : u("", !0)
          ]),
          l("div", null, [
            l("label", Rd, p(_.emailLabel || "Email"), 1),
            le(l("input", {
              id: "email",
              "onUpdate:modelValue": T[1] || (T[1] = (z) => c.email = z),
              type: "email",
              class: r(["form-control", { "is-invalid": d.value.email }]),
              placeholder: _.emailPlaceholder || "your@email.com",
              required: ""
            }, null, 10, Fd), [
              [ae, c.email]
            ]),
            d.value.email ? (e(), t("div", Yd, p(d.value.email), 1)) : u("", !0)
          ]),
          l("div", null, [
            l("label", Kd, p(_.messageLabel || "Message"), 1),
            le(l("textarea", {
              id: "message",
              "onUpdate:modelValue": T[2] || (T[2] = (z) => c.message = z),
              class: r(["form-control", { "is-invalid": d.value.message }]),
              placeholder: _.messagePlaceholder || "Your message...",
              rows: "4",
              required: ""
            }, null, 10, Jd), [
              [ae, c.message]
            ]),
            d.value.message ? (e(), t("div", Qd, p(d.value.message), 1)) : u("", !0)
          ]),
          l("div", Xd, [
            T[5] || (T[5] = l("label", { for: "contact-company" }, "Company", -1)),
            le(l("input", {
              id: "contact-company",
              "onUpdate:modelValue": T[3] || (T[3] = (z) => c.company = z),
              type: "text",
              name: "company",
              tabindex: "-1",
              autocomplete: "off"
            }, null, 512), [
              [ae, c.company]
            ])
          ]),
          l("button", {
            type: "submit",
            class: "btn btn-primary w-100 rounded-3",
            disabled: m.value || !v.value,
            "data-label": _.submitText || "Send Message"
          }, [
            m.value ? (e(), t("span", eu)) : u("", !0),
            ie(" " + p(_.submitText || "Send Message"), 1)
          ], 8, Zd),
          v.value ? u("", !0) : (e(), t("p", tu, " Preview only: the form can be submitted on the published site. "))
        ], 34),
        o.value ? (e(), t("div", {
          key: 1,
          class: r(["alert mt-3", o.value.success ? "alert-success" : "alert-danger"]),
          role: "alert"
        }, [
          l("div", su, [
            l("span", null, p(o.value.message), 1),
            l("button", {
              type: "button",
              class: "btn-close",
              onClick: T[4] || (T[4] = (z) => o.value = null)
            })
          ])
        ], 2)) : u("", !0)
      ])
    ], 2));
  }
}), au = /* @__PURE__ */ E(lu, [["__scopeId", "data-v-1f6a215f"]]), ou = ["id"], iu = { key: 1 }, nu = ["id"], ru = { class: "carousel-inner" }, cu = ["src", "alt"], du = {
  key: 0,
  class: "carousel-caption"
}, uu = ["data-bs-target"], pu = ["data-bs-target"], fu = { class: "d-flex gap-2 mt-3 overflow-auto" }, mu = ["src", "alt", "data-bs-target", "data-bs-slide-to"], hu = ["id", "data-bs-interval"], bu = { class: "carousel-indicators" }, gu = ["data-bs-target", "data-bs-slide-to"], yu = { class: "carousel-inner" }, vu = { class: "d-flex gap-2 justify-content-center" }, ku = ["src", "alt", "onClick", "data-title", "data-caption"], wu = {
  key: 0,
  class: "carousel-caption-overlay"
}, xu = { class: "fw-medium" }, Cu = ["data-bs-target"], $u = ["data-bs-target"], _u = {
  key: 3,
  class: "d-flex flex-column gap-3"
}, Tu = ["src", "alt", "onClick", "data-title", "data-caption"], zu = {
  key: 0,
  class: "mt-2 small text-secondary"
}, qu = {
  key: 0,
  class: "modal d-block",
  tabindex: "-1",
  style: { "background-color": "rgba(0,0,0,0.9)" }
}, ju = { class: "modal-dialog modal-fullscreen" }, Su = { class: "modal-content bg-transparent border-0" }, Au = ["src", "alt"], Iu = {
  key: 1,
  class: "position-absolute bottom-0 start-0 end-0 mx-auto rounded-4 p-4 mb-4",
  style: { "max-width": "32rem", background: "rgba(0,0,0,0.75)", "backdrop-filter": "blur(20px)", border: "1px solid rgba(255,255,255,0.1)" }
}, Mu = { class: "d-flex flex-column flex-md-row align-items-md-start justify-content-md-between gap-2 mb-2" }, Lu = { class: "fw-semibold text-white mb-0" }, Bu = {
  key: 0,
  class: "badge rounded-pill text-uppercase small",
  style: { background: "rgba(255,255,255,0.15)", "letter-spacing": "0.05em" }
}, Hu = {
  key: 0,
  class: "text-white-50 small lh-relaxed mb-0"
}, Pu = /* @__PURE__ */ H({
  __name: "ImageGallery",
  props: {
    title: {},
    images: {},
    id: {},
    variant: { default: "carousel" },
    showCaptions: { type: Boolean, default: !1 },
    enableLightbox: { type: Boolean, default: !0 },
    numVisible: { default: 3 },
    numScroll: { default: 1 },
    autoPlay: { type: Boolean, default: !1 },
    autoPlayInterval: { default: 3e3 }
  },
  setup(w) {
    const s = w, a = J(!1), n = J(null), b = i(() => `carousel-${Math.random().toString(36).substr(2, 9)}`), v = i(() => `lightbox-carousel-${Math.random().toString(36).substr(2, 9)}`), c = i(() => {
      const x = [];
      for (let _ = 0; _ < s.images.length; _ += s.numVisible)
        x.push(s.images.slice(_, _ + s.numVisible));
      return x;
    }), m = i(() => "py-5"), d = i(() => "container"), o = i(() => "text-center mb-5 display-6 fw-bold text-surface-900"), f = (x) => {
      n.value = x, a.value = !0;
    }, h = () => {
      a.value = !1, n.value = null;
    }, $ = (x) => {
      x.key === "Escape" && a.value && h();
    };
    return de(() => {
      document.addEventListener("keydown", $);
    }), ve(() => {
      document.removeEventListener("keydown", $);
    }), (x, _) => (e(), t("section", {
      class: r(m.value),
      id: x.id
    }, [
      l("div", {
        class: r(d.value)
      }, [
        x.title ? (e(), t("h2", {
          key: 0,
          class: r(o.value)
        }, p(x.title), 3)) : u("", !0),
        x.variant === "lightbox" ? (e(), t("div", iu, [
          l("div", {
            id: v.value,
            class: "carousel slide",
            "data-bs-ride": "false"
          }, [
            l("div", ru, [
              (e(!0), t(j, null, I(x.images, (T, z) => (e(), t("div", {
                key: T.url,
                class: r(["carousel-item", { active: z === 0 }])
              }, [
                l("img", {
                  src: T.url,
                  alt: T.title,
                  class: "d-block w-100 rounded-3",
                  style: { height: "500px", "object-fit": "cover" }
                }, null, 8, cu),
                x.showCaptions && T.caption ? (e(), t("div", du, [
                  l("h5", null, p(T.title), 1),
                  l("p", null, p(T.caption), 1)
                ])) : u("", !0)
              ], 2))), 128))
            ]),
            l("button", {
              class: "carousel-control-prev",
              type: "button",
              "data-bs-target": `#${v.value}`,
              "data-bs-slide": "prev"
            }, [..._[1] || (_[1] = [
              l("span", { class: "carousel-control-prev-icon" }, null, -1)
            ])], 8, uu),
            l("button", {
              class: "carousel-control-next",
              type: "button",
              "data-bs-target": `#${v.value}`,
              "data-bs-slide": "next"
            }, [..._[2] || (_[2] = [
              l("span", { class: "carousel-control-next-icon" }, null, -1)
            ])], 8, pu)
          ], 8, nu),
          l("div", fu, [
            (e(!0), t(j, null, I(x.images, (T, z) => (e(), t("img", {
              key: T.url,
              src: T.url,
              alt: T.title,
              class: "rounded-2 cursor-pointer",
              style: { width: "100px", height: "60px", "object-fit": "cover" },
              "data-bs-target": `#${v.value}`,
              "data-bs-slide-to": z
            }, null, 8, mu))), 128))
          ])
        ])) : x.variant === "carousel" ? (e(), t("div", {
          key: 2,
          id: b.value,
          class: "carousel slide",
          "data-bs-ride": "carousel",
          "data-bs-interval": x.autoPlay ? x.autoPlayInterval : "false"
        }, [
          l("div", bu, [
            (e(!0), t(j, null, I(c.value, (T, z) => (e(), t("button", {
              key: z,
              type: "button",
              "data-bs-target": `#${b.value}`,
              "data-bs-slide-to": z,
              class: r({ active: z === 0 })
            }, null, 10, gu))), 128))
          ]),
          l("div", yu, [
            (e(!0), t(j, null, I(c.value, (T, z) => (e(), t("div", {
              key: z,
              class: r(["carousel-item", { active: z === 0 }])
            }, [
              l("div", vu, [
                (e(!0), t(j, null, I(T, (N) => (e(), t("div", {
                  key: N.url,
                  class: "carousel-img-wrapper"
                }, [
                  l("img", {
                    src: N.url,
                    alt: N.title,
                    class: "d-block w-100 rounded-3 object-fit-cover",
                    loading: "lazy",
                    style: { cursor: "pointer" },
                    onClick: (M) => x.enableLightbox && f(N),
                    "data-lightbox-trigger": "",
                    "data-title": N.title,
                    "data-caption": N.caption
                  }, null, 8, ku),
                  x.showCaptions ? (e(), t("div", wu, [
                    l("span", xu, p(N.title), 1)
                  ])) : u("", !0)
                ]))), 128))
              ])
            ], 2))), 128))
          ]),
          l("button", {
            class: "carousel-control-prev",
            type: "button",
            "data-bs-target": `#${b.value}`,
            "data-bs-slide": "prev"
          }, [..._[3] || (_[3] = [
            l("span", { class: "carousel-control-prev-icon" }, null, -1)
          ])], 8, Cu),
          l("button", {
            class: "carousel-control-next",
            type: "button",
            "data-bs-target": `#${b.value}`,
            "data-bs-slide": "next"
          }, [..._[4] || (_[4] = [
            l("span", { class: "carousel-control-next-icon" }, null, -1)
          ])], 8, $u)
        ], 8, hu)) : (e(), t("div", _u, [
          (e(!0), t(j, null, I(x.images, (T) => (e(), t("div", {
            key: T.id || T.url,
            class: "position-relative"
          }, [
            l("img", {
              src: T.url,
              alt: T.title,
              loading: "lazy",
              class: "w-100 h-auto object-fit-cover rounded-3 cursor-pointer",
              onClick: (z) => x.enableLightbox && f(T),
              "data-lightbox-trigger": "",
              "data-title": T.title,
              "data-caption": T.caption
            }, null, 8, Tu),
            x.showCaptions && T.caption ? (e(), t("div", zu, p(T.caption), 1)) : u("", !0)
          ]))), 128))
        ]))
      ], 2),
      a.value ? (e(), t("div", qu, [
        l("div", ju, [
          l("div", Su, [
            l("div", {
              class: "modal-body d-flex align-items-center justify-content-center p-0 position-relative",
              onClick: h
            }, [
              l("div", {
                class: "position-relative d-flex flex-column align-items-center justify-content-center w-100 h-100",
                onClick: _[0] || (_[0] = ke(() => {
                }, ["stop"]))
              }, [
                n.value ? (e(), t("img", {
                  key: 0,
                  src: n.value.url,
                  alt: n.value.title,
                  class: "rounded-4 shadow-lg",
                  style: { "max-width": "90vw", "max-height": "85vh", "object-fit": "contain" }
                }, null, 8, Au)) : u("", !0),
                n.value && (n.value.title || n.value.caption) ? (e(), t("div", Iu, [
                  l("div", Mu, [
                    l("h5", Lu, p(n.value.title), 1),
                    n.value.category ? (e(), t("span", Bu, p(n.value.category), 1)) : u("", !0)
                  ]),
                  n.value.caption ? (e(), t("p", Hu, p(n.value.caption), 1)) : u("", !0)
                ])) : u("", !0),
                l("button", {
                  type: "button",
                  class: "btn-close btn-close-white position-absolute top-0 end-0 m-4",
                  style: { "z-index": "50" },
                  onClick: h,
                  "aria-label": "Close"
                })
              ])
            ])
          ])
        ])
      ])) : u("", !0)
    ], 10, ou));
  }
}), Nu = /* @__PURE__ */ E(Pu, [["__scopeId", "data-v-c4086fab"]]), Eu = ["id"], Uu = ["data-category"], Vu = {
  key: 0,
  class: "badge-count"
}, Ou = /* @__PURE__ */ H({
  __name: "GalleryNav",
  props: {
    categories: { default: () => [] },
    id: {},
    variant: { default: "default" },
    layout: { default: "center" },
    size: { default: "md" },
    showCount: { type: Boolean, default: !1 },
    allText: { default: "Alle" }
  },
  setup(w) {
    const s = w, a = i(
      () => s.categories.includes(s.allText) ? s.categories : [s.allText, ...s.categories]
    ), n = J("all"), b = (o) => {
      const h = o.currentTarget.dataset.category || "";
      n.value = h, document.querySelectorAll(".gallery-item").forEach((x) => {
        var T;
        const _ = (T = x.dataset.category) == null ? void 0 : T.toLowerCase();
        h === "all" || _ === h ? (x.style.display = "block", x.classList.remove("d-none")) : (x.style.display = "none", x.classList.add("d-none"));
      }), v();
    }, v = () => {
      if (!s.showCount) return;
      const o = document.querySelector(`#${s.id || "gallery-nav"}`);
      if (!o) return;
      o.querySelectorAll("button[data-category]").forEach((h) => {
        const $ = h.dataset.category, x = h.querySelector("span");
        if (x && $) {
          const _ = document.querySelectorAll(".gallery-item");
          let T = 0;
          $ === "all" ? T = _.length : _.forEach((z) => {
            var M;
            ((M = z.dataset.category) == null ? void 0 : M.toLowerCase()) === $ && T++;
          }), x.textContent = `(${T})`;
        }
      });
    };
    de(() => {
      v();
    });
    const c = i(() => {
      switch (s.layout) {
        case "center":
          return "justify-content-center";
        case "left":
          return "justify-content-start";
        case "right":
          return "justify-content-end";
        case "spread":
          return "justify-content-between";
        default:
          return "justify-content-center";
      }
    }), m = i(() => {
      const o = "gallery-nav-btn cursor-pointer fw-medium d-flex align-items-center gap-1", f = {
        sm: "gallery-nav-btn-sm px-2 py-1 small",
        md: "gallery-nav-btn-md px-3 py-2",
        lg: "gallery-nav-btn-lg px-4 py-2 fs-5"
      }, h = {
        default: "gallery-nav-default border-2 bg-white rounded-2",
        pills: "gallery-nav-pills rounded-pill border-0 bg-light text-secondary",
        tabs: "gallery-nav-tabs rounded-top-2 border-bottom-0 bg-light",
        minimal: "gallery-nav-minimal border-0 bg-transparent text-secondary py-2 border-bottom border-2 border-transparent rounded-0",
        cards: "gallery-nav-cards bg-white border rounded-3 shadow-sm"
      };
      return `${o} ${f[s.size]} ${h[s.variant]}`;
    }), d = i(() => ({
      default: "gallery-nav-default-active",
      pills: "gallery-nav-pills-active",
      tabs: "gallery-nav-tabs-active",
      minimal: "gallery-nav-minimal-active",
      cards: "gallery-nav-cards-active"
    })[s.variant]);
    return (o, f) => (e(), t("nav", {
      class: "mb-5",
      id: o.id
    }, [
      l("div", {
        class: r(["d-flex gap-2 flex-wrap", c.value])
      }, [
        (e(!0), t(j, null, I(a.value, (h, $) => (e(), t("button", {
          key: h,
          type: "button",
          class: r([
            m.value,
            $ === 0 && n.value === "all" || n.value === h.toLowerCase() || n.value === "all" && h === o.allText ? d.value : ""
          ]),
          "data-category": h.toLowerCase() === o.allText.toLowerCase() ? "all" : h.toLowerCase(),
          onClick: b
        }, [
          ie(p(h) + " ", 1),
          o.showCount ? (e(), t("span", Vu, "(0)")) : u("", !0)
        ], 10, Uu))), 128))
      ], 2)
    ], 8, Eu));
  }
}), Wu = /* @__PURE__ */ E(Ou, [["__scopeId", "data-v-e6ef82d3"]]), Du = { class: "container py-8" }, Gu = {
  key: 2,
  class: "mt-5 text-start"
}, Ru = { class: "d-flex flex-column gap-4" }, Fu = { class: "step-number bg-primary text-white rounded-circle d-flex align-items-center justify-content-center fw-bold flex-shrink-0" }, Yu = {
  key: 0,
  class: "fs-3 flex-shrink-0"
}, Ku = { class: "fw-semibold mb-1" }, Ju = { class: "opacity-75 small" }, Qu = {
  key: 3,
  class: "mt-5 p-4 contact-card rounded-3 border border-dark border-opacity-10"
}, Xu = { class: "mb-3 opacity-75" }, Zu = { class: "d-flex justify-content-center gap-3 flex-wrap" }, e6 = ["href"], t6 = ["href"], s6 = /* @__PURE__ */ H({
  __name: "ThankYouSection",
  props: {
    id: {},
    Title: { default: "Bedankt!" },
    Message: { default: "Uw bericht is succesvol verzonden." },
    CTAText: {},
    CTALink: {},
    UUID: {},
    variant: { default: "default" },
    size: { default: "medium" },
    showIcon: { type: Boolean, default: !0 },
    backgroundColor: {},
    textColor: {},
    nextSteps: { default: () => [] },
    contactInfo: {}
  },
  setup(w) {
    const s = w, a = i(() => `min-vh-100 d-flex align-items-center justify-content-center text-center ${{
      default: "variant-default",
      success: "variant-success",
      celebration: "variant-celebration",
      minimal: "variant-minimal",
      detailed: "variant-detailed"
    }[s.variant]}`), n = i(() => {
      const o = {
        small: "mx-auto p-3 rounded-3",
        medium: "mx-auto p-5 rounded-4",
        large: "mx-auto p-6 rounded-5",
        "extra-large": "mx-auto p-8 rounded-5",
        professional: "mx-auto p-4 rounded-3",
        dramatic: "mx-auto p-6 rounded-5"
      }, f = {
        default: "content-default backdrop-blur",
        success: "content-glass backdrop-blur",
        celebration: "content-glass backdrop-blur",
        minimal: "bg-transparent border-0",
        detailed: "bg-white shadow-lg border"
      };
      return `${o[s.size]} text-center ${f[s.variant]}`;
    }), b = i(() => {
      const f = {
        small: "display-5 mb-3",
        medium: "display-3 mb-4",
        large: "display-1 mb-5",
        "extra-large": "fs-9xl mb-5",
        professional: "display-4 mb-3",
        dramatic: "display-1 mb-5"
      }[s.size];
      return s.variant === "celebration" ? `${f} celebration-icon` : `${f} animate-bounce`;
    }), v = i(() => {
      const o = {
        small: "fs-3 fw-bold mb-3",
        medium: "display-5 fw-bold mb-3",
        large: "display-4 fw-bold mb-4",
        "extra-large": "display-3 fw-bold mb-5",
        professional: "display-6 fw-bold mb-3",
        dramatic: "display-4 fw-bold mb-4"
      }, f = {
        default: "text-title-success",
        success: "text-white",
        celebration: "text-white",
        minimal: "text-body-secondary",
        detailed: "text-primary"
      };
      return `${o[s.size]} ${f[s.variant]}`;
    }), c = i(() => {
      const o = {
        small: "mb-4 opacity-75",
        medium: "fs-5 mb-5 opacity-75",
        large: "fs-4 mb-5 opacity-75",
        "extra-large": "fs-3 mb-6 opacity-75",
        professional: "mb-4 opacity-75",
        dramatic: "fs-4 mb-5 opacity-75"
      }, f = {
        default: "text-message-success",
        success: "text-white",
        celebration: "text-white",
        minimal: "text-body-secondary",
        detailed: "text-body-secondary"
      };
      return `${o[s.size]} ${f[s.variant]}`;
    }), m = i(() => {
      const o = {
        small: "d-inline-block px-4 py-2 rounded-3 fw-semibold text-decoration-none mt-2 small hover-lift hover-shadow",
        medium: "d-inline-block px-5 py-3 rounded-3 fw-semibold text-decoration-none mt-3 hover-lift hover-shadow",
        large: "d-inline-block px-5 py-3 rounded-4 fw-semibold text-decoration-none mt-4 fs-5 hover-lift hover-shadow",
        "extra-large": "d-inline-block px-6 py-4 rounded-5 fw-semibold text-decoration-none mt-5 fs-4 hover-lift hover-shadow",
        professional: "d-inline-block px-4 py-2 rounded-3 fw-semibold text-decoration-none mt-3 small hover-lift hover-shadow",
        dramatic: "d-inline-block px-5 py-3 rounded-4 fw-semibold text-decoration-none mt-4 fs-5 hover-lift hover-shadow"
      }, f = {
        default: "cta-success",
        success: "cta-glass-success",
        celebration: "cta-glass-celebration",
        minimal: "cta-primary",
        detailed: "cta-primary-dark"
      };
      return `${o[s.size]} ${f[s.variant]}`;
    }), d = (o) => ({
      default: "✅",
      success: "🎉",
      celebration: "🎊",
      minimal: "✓",
      detailed: "📧",
      // NGO/Activism specific
      petition: "📝",
      solidarity: "✊",
      support: "🤝",
      action: "💪",
      volunteer: "🙋‍♀️",
      donation: "💝",
      awareness: "💡"
    })[o] || "✅";
    return (o, f) => {
      var $;
      const h = ye("router-link");
      return e(), t("section", {
        class: r(a.value),
        style: P(o.backgroundColor ? `background-color: ${o.backgroundColor}; color: ${o.textColor || "inherit"};` : "")
      }, [
        l("div", Du, [
          l("div", {
            class: r(n.value)
          }, [
            o.showIcon ? (e(), t("div", {
              key: 0,
              class: r(b.value)
            }, p(d(o.variant)), 3)) : u("", !0),
            l("h1", {
              class: r(v.value)
            }, p(o.Title), 3),
            o.Message ? (e(), t("p", {
              key: 1,
              class: r(c.value)
            }, p(o.Message), 3)) : u("", !0),
            o.nextSteps.length > 0 ? (e(), t("div", Gu, [
              f[0] || (f[0] = l("h3", { class: "fs-3 fw-bold mb-4 text-center" }, "Wat gebeurt er nu?", -1)),
              l("div", Ru, [
                (e(!0), t(j, null, I(o.nextSteps, (x, _) => (e(), t("div", {
                  key: _,
                  class: "d-flex align-items-start gap-3 p-3 step-card rounded-3 border border-dark border-opacity-10"
                }, [
                  l("div", Fu, p(_ + 1), 1),
                  x.icon ? (e(), t("div", Yu, p(x.icon), 1)) : u("", !0),
                  l("div", null, [
                    l("h4", Ku, p(x.title), 1),
                    l("p", Ju, p(x.description), 1)
                  ])
                ]))), 128))
              ])
            ])) : u("", !0),
            ($ = o.contactInfo) != null && $.show ? (e(), t("div", Qu, [
              f[1] || (f[1] = l("h3", { class: "fs-4 fw-bold mb-2" }, "Vragen?", -1)),
              l("p", Xu, p(o.contactInfo.message || "Neem gerust contact met ons op voor vragen."), 1),
              l("div", Zu, [
                o.contactInfo.phone ? (e(), t("a", {
                  key: 0,
                  href: `tel:${o.contactInfo.phone}`,
                  class: "contact-link d-flex align-items-center gap-2 px-3 py-2 border border-dark border-opacity-10 rounded-2 text-decoration-none"
                }, p(o.contactInfo.phone), 9, e6)) : u("", !0),
                o.contactInfo.email ? (e(), t("a", {
                  key: 1,
                  href: `mailto:${o.contactInfo.email}`,
                  class: "contact-link d-flex align-items-center gap-2 px-3 py-2 border border-dark border-opacity-10 rounded-2 text-decoration-none"
                }, p(o.contactInfo.email), 9, t6)) : u("", !0)
              ])
            ])) : u("", !0),
            o.CTAText && o.CTALink ? (e(), W(h, {
              key: 4,
              to: o.CTALink,
              class: r(m.value)
            }, {
              default: ce(() => [
                ie(p(o.CTAText), 1)
              ]),
              _: 1
            }, 8, ["to", "class"])) : u("", !0)
          ], 2)
        ])
      ], 6);
    };
  }
}), l6 = /* @__PURE__ */ E(s6, [["__scopeId", "data-v-cb31b655"]]), a6 = { class: "container d-flex align-items-center justify-content-center gap-3" }, o6 = ["href", "target", "rel"], i6 = /* @__PURE__ */ H({
  __name: "AnnouncementBanner",
  props: {
    __component: {},
    id: {},
    title: {},
    linkText: {},
    link: {},
    backgroundColor: {},
    textColor: {}
  },
  setup(w) {
    const s = w, a = i(() => {
      var b;
      return ((b = s.link) == null ? void 0 : b.startsWith("http")) || !1;
    }), n = i(() => ({
      backgroundColor: s.backgroundColor || "#ef4444",
      color: s.textColor || "#ffffff"
    }));
    return (b, v) => (e(), t("section", {
      class: "w-100 py-2 px-3 text-center small",
      style: P(n.value)
    }, [
      l("div", a6, [
        l("span", null, p(b.title), 1),
        b.link && b.linkText ? (e(), t("a", {
          key: 0,
          href: b.link,
          class: "announcement-link text-decoration-underline fw-semibold",
          target: a.value ? "_blank" : void 0,
          rel: a.value ? "noopener noreferrer" : void 0
        }, p(b.linkText), 9, o6)) : u("", !0)
      ])
    ], 4));
  }
}), n6 = /* @__PURE__ */ E(i6, [["__scopeId", "data-v-4496648e"]]), r6 = { class: "container px-3" }, c6 = { class: "d-flex flex-column flex-md-row align-items-center justify-content-between gap-3" }, d6 = { class: "text-center text-md-start" }, u6 = { class: "fs-5 fw-bold mb-1" }, p6 = {
  key: 0,
  class: "small opacity-75 mb-0"
}, f6 = {
  key: 1,
  class: "mt-5"
}, m6 = {
  key: 0,
  class: "position-absolute top-0 start-0 w-100 h-100"
}, h6 = ["src", "alt"], b6 = {
  class: "container px-3",
  style: { "max-width": "896px" }
}, g6 = {
  key: 1,
  class: "mt-5"
}, y6 = /* @__PURE__ */ H({
  __name: "BannerSectionV2",
  props: {
    __component: {},
    id: {},
    title: {},
    displayTitle: {},
    description: {},
    subtitle: {},
    shortCTA: {},
    fullCTA: {},
    CTALink: {},
    variant: {},
    textPosition: {},
    size: {},
    density: {},
    backgroundType: {},
    backgroundColor: {},
    backgroundGradient: {},
    UUID: {},
    Image: {},
    overlayOpacity: {},
    buttonStyle: {},
    overlayBox: {}
  },
  setup(w) {
    const s = Z(), a = w, n = (y) => y || "", b = {
      small: "banner-py-small",
      medium: "banner-py-medium",
      large: "banner-py-large",
      "extra-large": "banner-py-xlarge",
      professional: "banner-py-professional",
      dramatic: "banner-py-dramatic"
    }, v = {
      compact: "d-flex flex-column gap-2",
      normal: "d-flex flex-column gap-3",
      loose: "d-flex flex-column gap-4"
    }, c = i(() => {
      const y = [];
      return a.variant !== "banner" ? y.push(b[a.size || "large"]) : y.push("banner-py-banner"), a.variant === "cta" && a.backgroundType === "gradient" ? y.push("bg-gradient-primary text-white") : !a.backgroundColor && a.variant !== "hero" && a.variant !== "overlay" && y.push("bg-surface-50"), y.join(" ");
    }), m = i(() => {
      const y = {};
      return a.backgroundColor && (y.backgroundColor = a.backgroundColor), a.backgroundGradient && (y.background = a.backgroundGradient), y;
    }), d = i(() => {
      var y;
      return !!((y = a.Image) != null && y.url);
    }), o = i(() => {
      const y = { ...m.value };
      return d.value && (y.backgroundImage = `url(${n(a.Image.url)})`, y.backgroundSize = "cover", y.backgroundPosition = "center"), y;
    }), f = i(() => b[a.size || "large"]), h = i(() => {
      const y = a.textPosition || "center", q = ["banner-max-w-4xl", v[a.density || "normal"]];
      switch (y) {
        case "left":
          return [...q, "me-auto text-start"].join(" ");
        case "right":
          return [...q, "ms-auto text-end"].join(" ");
        default:
          return [...q, "mx-auto text-center"].join(" ");
      }
    }), $ = i(() => {
      const y = a.size || "large", L = ["fw-bold lh-sm", a.variant === "hero" && d.value ? "text-white drop-shadow-lg" : "text-surface-900"], G = {
        small: "display-6",
        medium: "display-5",
        large: "display-4",
        "extra-large": "display-3",
        professional: "display-5",
        dramatic: "display-2"
      };
      return [...L, G[y]].join(" ");
    }), x = i(() => {
      const y = a.variant === "hero" && d.value, q = a.size || "large", L = ["banner-max-w-3xl", y ? "text-white opacity-75 drop-shadow-md" : "text-surface-700"], G = {
        small: "fs-6",
        medium: "fs-5",
        large: "fs-4",
        "extra-large": "fs-3",
        professional: "fs-6",
        dramatic: "fs-3"
      };
      return [...L, G[q], a.textPosition === "center" ? "mx-auto" : ""].join(" ");
    }), _ = i(() => {
      if (!a.overlayBox) return {};
      const { x: y, y: q } = a.overlayBox, L = {};
      return y === "left" ? L.justifyItems = "start" : y === "center" ? L.justifyItems = "center" : y === "right" && (L.justifyItems = "end"), q === "top" ? L.alignItems = "start" : q === "center" ? L.alignItems = "center" : q === "bottom" && (L.alignItems = "end"), L;
    }), T = i(() => {
      const y = ["overlay-box rounded-3 shadow-lg p-4 p-md-5"];
      if (a.overlayBox) {
        const { x: q, y: L } = a.overlayBox;
        typeof q == "string" && !["left", "center", "right"].includes(q) && y.push("me-4"), typeof L == "string" && !["top", "center", "bottom"].includes(L) && y.push("mb-4");
      } else {
        const q = a.textPosition || "center";
        q === "right" ? y.push("me-4") : q === "left" && y.push("ms-4");
      }
      return y.join(" ");
    }), z = i(() => {
      if (!a.overlayBox) return {};
      const { x: y, y: q, width: L, height: G } = a.overlayBox, F = {};
      return typeof y == "string" && !["left", "center", "right"].includes(y) && (F.marginLeft = y), typeof q == "string" && !["top", "center", "bottom"].includes(q) && (F.marginTop = q), L && (F.width = L), G && (F.height = G), F;
    }), N = i(() => "display-6 fw-bold text-surface-900 mb-2"), M = i(() => "text-surface-700 lh-relaxed"), k = i(() => {
      const y = a.size || "large", q = ["fw-bold mb-3"], L = {
        small: "display-6",
        medium: "display-5",
        large: "display-4",
        "extra-large": "display-3",
        professional: "display-6",
        dramatic: "display-3"
      };
      return [...q, L[y]].join(" ");
    }), S = i(() => "fs-5 mx-auto opacity-75 banner-max-w-2xl"), D = () => ({
      small: "400px",
      medium: "500px",
      large: "600px",
      "extra-large": "700px",
      professional: "450px",
      dramatic: "800px"
    })[a.size || "large"], A = () => {
      const y = a.size || "large";
      return y === "large" || y === "extra-large" || y === "dramatic" ? a.fullCTA || a.shortCTA : a.shortCTA || a.fullCTA;
    }, g = () => {
      const y = a.size || "large";
      if (!(y === "small" || y === "professional"))
        return "large";
    }, B = () => {
      a.CTALink && (a.CTALink.startsWith("http") ? window.open(a.CTALink, "_blank") : s.push(a.CTALink));
    };
    return (y, q) => {
      var L;
      return y.variant === "banner" ? (e(), t("section", {
        key: 0,
        class: r([c.value, "w-100"]),
        style: P(m.value)
      }, [
        l("div", r6, [
          l("div", c6, [
            l("div", d6, [
              l("h3", u6, p(y.title), 1),
              y.description ? (e(), t("p", p6, p(y.description), 1)) : u("", !0)
            ]),
            y.CTALink && (y.shortCTA || y.fullCTA) ? (e(), W(O, {
              key: 0,
              label: y.shortCTA || y.fullCTA,
              onClick: B,
              severity: y.buttonStyle === "outline" ? "secondary" : void 0,
              outlined: y.buttonStyle === "outline",
              class: "text-nowrap"
            }, null, 8, ["label", "severity", "outlined"])) : u("", !0)
          ])
        ])
      ], 6)) : y.variant === "hero" ? (e(), t("section", {
        key: 1,
        class: r([c.value, "position-relative w-100 overflow-hidden"]),
        style: P(o.value)
      }, [
        d.value ? (e(), t("div", {
          key: 0,
          class: "position-absolute top-0 start-0 w-100 h-100 bg-dark",
          style: P({ opacity: y.overlayOpacity || 0.4 })
        }, null, 4)) : u("", !0),
        l("div", {
          class: r(["position-relative z-10 container px-3", f.value])
        }, [
          l("div", {
            class: r(h.value)
          }, [
            l("h1", {
              class: r($.value)
            }, p(y.displayTitle || y.title), 3),
            y.subtitle || y.description ? (e(), t("p", {
              key: 0,
              class: r(x.value)
            }, p(y.subtitle || y.description), 3)) : u("", !0),
            y.CTALink && (y.shortCTA || y.fullCTA) ? (e(), t("div", f6, [
              R(O, {
                label: A(),
                onClick: B,
                size: g(),
                severity: y.buttonStyle === "secondary" ? "secondary" : void 0,
                outlined: y.buttonStyle === "outline",
                class: "fw-semibold hover-shadow-lg"
              }, null, 8, ["label", "size", "severity", "outlined"])
            ])) : u("", !0)
          ], 2)
        ], 2)
      ], 6)) : y.variant === "overlay" ? (e(), t("section", {
        key: 2,
        class: "position-relative w-100 overflow-hidden",
        style: P({ minHeight: D() })
      }, [
        (L = y.Image) != null && L.url ? (e(), t("div", m6, [
          l("img", {
            src: n(y.Image.url),
            alt: y.Image.alternativeText || y.title,
            class: "w-100 h-100 object-fit-cover"
          }, null, 8, h6),
          q[0] || (q[0] = l("div", { class: "position-absolute top-0 start-0 w-100 h-100 overlay-gradient-up" }, null, -1))
        ])) : (e(), t("div", {
          key: 1,
          class: "position-absolute top-0 start-0 w-100 h-100",
          style: P(m.value)
        }, null, 4)),
        l("div", {
          class: "position-absolute top-0 start-0 w-100 h-100 overlay-grid",
          style: P(_.value)
        }, [
          l("div", {
            class: r(T.value),
            style: P(z.value)
          }, [
            l("h2", {
              class: r(N.value)
            }, p(y.title), 3),
            y.description ? (e(), t("p", {
              key: 0,
              class: r(M.value)
            }, p(y.description), 3)) : u("", !0),
            y.CTALink && (y.shortCTA || y.fullCTA) ? (e(), W(O, {
              key: 1,
              label: y.shortCTA || y.fullCTA,
              onClick: B,
              severity: y.buttonStyle === "secondary" ? "secondary" : void 0,
              outlined: y.buttonStyle === "outline",
              class: "mt-3"
            }, null, 8, ["label", "severity", "outlined"])) : u("", !0)
          ], 6)
        ], 4)
      ], 4)) : (e(), t("section", {
        key: 3,
        class: r([c.value, "text-center"]),
        style: P(m.value)
      }, [
        l("div", b6, [
          l("h2", {
            class: r(k.value)
          }, p(y.title), 3),
          y.description ? (e(), t("p", {
            key: 0,
            class: r(S.value)
          }, p(y.description), 3)) : u("", !0),
          y.CTALink && (y.shortCTA || y.fullCTA) ? (e(), t("div", g6, [
            R(O, {
              label: y.shortCTA || y.fullCTA,
              onClick: B,
              size: g(),
              severity: y.buttonStyle === "secondary" ? "secondary" : void 0,
              outlined: y.buttonStyle === "outline",
              class: "fw-semibold"
            }, null, 8, ["label", "size", "severity", "outlined"])
          ])) : u("", !0)
        ])
      ], 6));
    };
  }
}), v6 = /* @__PURE__ */ E(y6, [["__scopeId", "data-v-3ba44568"]]);
function me(w) {
  return w ? w.match(/#[0-9a-fA-F]{3}(?:[0-9a-fA-F]{3})?\b/g) || [] : [];
}
function k6(w) {
  const s = w.replace("#", ""), a = s.length === 3 ? s.split("").map((m) => m + m).join("") : s, n = parseInt(a.slice(0, 2), 16) / 255, b = parseInt(a.slice(2, 4), 16) / 255, v = parseInt(a.slice(4, 6), 16) / 255, c = (m) => m <= 0.03928 ? m / 12.92 : Math.pow((m + 0.055) / 1.055, 2.4);
  return 0.2126 * c(n) + 0.7152 * c(b) + 0.0722 * c(v);
}
function he(w, s) {
  const [a, n] = w >= s ? [w, s] : [s, w];
  return (a + 0.05) / (n + 0.05);
}
const w6 = 1, x6 = 0, be = 3;
function C6(w) {
  const s = w.map((b) => {
    try {
      return k6(b);
    } catch {
      return null;
    }
  }).filter((b) => b !== null);
  return s.length === 0 || s.every((b) => he(b, w6) >= be) ? "light" : s.every((b) => he(b, x6) >= be) ? "dark" : "scrim";
}
const $6 = {
  key: 1,
  class: "mt-4 mt-lg-5"
}, _6 = { class: "container position-relative" }, T6 = { class: "row align-items-center justify-content-between g-3" }, z6 = { class: "col-12 col-md-auto text-center text-md-start" }, q6 = { class: "h5 mb-1 fw-bold" }, j6 = { class: "col-12 col-md-auto text-center text-md-end" }, S6 = {
  key: 2,
  class: "w-100 position-relative overflow-hidden"
}, A6 = { class: "px-4 py-5 px-md-5 split-text-inner" }, I6 = { key: 1 }, M6 = { class: "col-12 col-lg-6 split-image-pane" }, L6 = ["src", "alt"], B6 = {
  class: "container position-relative",
  style: { "max-width": "896px" }
}, H6 = {
  key: 0,
  class: "lead opacity-75 mb-4"
}, P6 = { key: 1 }, N6 = /* @__PURE__ */ H({
  __name: "BannerV4",
  props: {
    __component: {},
    id: {},
    title: {},
    displayTitle: {},
    description: {},
    subtitle: {},
    shortCTA: {},
    fullCTA: {},
    CTALink: {},
    size: { default: "large" },
    variant: { default: "hero" },
    textPosition: { default: "center" },
    imagePosition: {},
    backgroundType: {},
    backgroundColor: {},
    backgroundGradient: {},
    Image: {},
    overlayOpacity: {},
    textColor: {},
    buttonStyle: { default: "primary" }
  },
  setup(w) {
    const s = Z(), a = $e(), n = w, b = i(
      () => n.backgroundType === "solid" && !!n.backgroundColor || n.backgroundType === "gradient" && !!n.backgroundGradient
    ), v = i(() => {
      const C = x.value ? "#1a1a1a" : "#fff";
      return n.backgroundType === "gradient" && n.backgroundGradient ? { background: n.backgroundGradient, color: C } : n.backgroundType === "solid" && n.backgroundColor ? { backgroundColor: n.backgroundColor, color: C } : {};
    }), c = i(
      () => `display-5 fw-bold mb-3 ${b.value && !x.value ? "text-white" : "text-body-emphasis"}`
    ), m = {
      small: {
        paddingClass: "banner-py-small",
        minHeight: "300px",
        titleClass: "display-6",
        // ~2.5rem
        subtitleClass: "fs-5",
        // 1.25rem
        ctaTitleClass: "display-6"
      },
      medium: {
        paddingClass: "banner-py-medium",
        minHeight: "400px",
        titleClass: "display-5",
        // ~3rem
        subtitleClass: "fs-4",
        // 1.5rem
        ctaTitleClass: "display-5"
      },
      large: {
        paddingClass: "banner-py-large",
        minHeight: "500px",
        titleClass: "display-4",
        // ~3.5rem
        subtitleClass: "fs-3",
        // 1.75rem
        ctaTitleClass: "display-4"
      },
      dramatic: {
        paddingClass: "banner-py-dramatic",
        minHeight: "600px",
        titleClass: "display-3",
        // ~4.5rem
        subtitleClass: "fs-2",
        // 2rem
        ctaTitleClass: "display-3"
      }
    }, d = i(() => m[n.size]), o = i(() => {
      var C;
      return !!((C = n.Image) != null && C.url);
    }), f = i(
      () => !!(o.value || n.backgroundColor || n.backgroundGradient || n.backgroundType === "gradient")
    ), h = i(() => n.backgroundGradient ? me(n.backgroundGradient) : n.backgroundColor ? me(n.backgroundColor) : []), $ = i(
      () => h.value.length === 0 ? "light" : C6(h.value)
    ), x = i(() => $.value === "dark"), _ = i(() => $.value === "scrim"), T = i(() => ({ background: "rgba(0, 0, 0, 0.4)" })), z = i(() => f.value ? x.value ? "text-surface-900" : "text-white" : "text-surface-900"), N = i(() => {
      const C = Math.max(n.overlayOpacity ?? 0.55, 0.4), Y = n.textColor === "dark" ? "255,255,255" : "0,0,0", Q = `rgba(${Y},${Math.min(C + 0.1, 0.85)})`, K = `rgba(${Y},${Math.max(C - 0.15, 0.15)})`, se = `rgba(${Y},0)`;
      let ee;
      switch (n.textPosition) {
        case "left":
          ee = `linear-gradient(90deg, ${Q} 0%, ${K} 45%, ${se} 85%)`;
          break;
        case "right":
          ee = `linear-gradient(270deg, ${Q} 0%, ${K} 45%, ${se} 85%)`;
          break;
        case "top":
          ee = `linear-gradient(180deg, ${Q} 0%, ${K} 40%, ${se} 80%)`;
          break;
        case "bottom":
          ee = `linear-gradient(0deg, ${Q} 0%, ${K} 40%, ${se} 80%)`;
          break;
        default:
          ee = `linear-gradient(180deg, ${K} 0%, ${Q} 100%)`;
      }
      return { background: ee };
    }), M = i(() => {
      switch (n.textPosition) {
        case "top":
          return "align-items-start";
        case "bottom":
          return "align-items-end";
        default:
          return "align-items-center";
      }
    }), k = i(() => {
      switch (n.textPosition) {
        case "top":
          return "center top";
        case "bottom":
          return "center bottom";
        case "left":
          return "left center";
        case "right":
          return "right center";
        default:
          return "center";
      }
    }), S = i(() => {
      const C = ["position-relative", "w-100", "overflow-hidden"];
      return C.push(d.value.paddingClass), n.backgroundType === "gradient" || n.backgroundColor ? C.push(x.value ? "text-surface-900" : "text-white") : o.value || C.push("bg-surface-50"), C.join(" ");
    }), D = i(() => {
      const C = {};
      return n.variant === "hero" && (C.minHeight = d.value.minHeight), o.value ? (C.backgroundImage = `url(${n.Image.url})`, C.backgroundSize = "cover", C.backgroundPosition = k.value) : n.backgroundColor ? C.backgroundColor = n.backgroundColor : n.backgroundGradient && (C.background = n.backgroundGradient), C;
    }), A = i(() => {
      const C = ["mx-auto"];
      switch (n.textPosition) {
        case "left":
          return [...C, "text-start", "me-auto", "ms-0"].join(" ");
        case "right":
          return [...C, "text-end", "ms-auto", "me-0"].join(" ");
        default:
          return [...C, "text-center"].join(" ");
      }
    }), g = i(() => o.value ? n.textColor !== "dark" : n.backgroundType === "gradient"), B = i(() => [
      d.value.titleClass,
      "fw-bold",
      "lh-sm",
      "mb-3",
      g.value ? "text-white drop-shadow-lg" : "text-surface-900"
    ].join(" ")), y = i(() => [
      d.value.subtitleClass,
      "mb-0",
      g.value ? "text-white opacity-90 drop-shadow-md" : "text-surface-900 opacity-75"
    ].join(" ")), q = i(() => {
      const C = !x.value && (n.backgroundType === "gradient" || !!n.backgroundColor);
      return [
        d.value.ctaTitleClass,
        "fw-bold",
        "mb-3",
        C ? "text-white" : "text-surface-900"
      ].join(" ");
    }), L = i(() => n.size === "dramatic" || n.size === "large" ? "large" : void 0), G = () => n.size === "large" || n.size === "dramatic" ? n.fullCTA || n.shortCTA : n.shortCTA || n.fullCTA, F = () => {
      const C = n.CTALink;
      if (!C) return;
      if (/^(https?:|tel:|mailto:)/.test(C)) {
        C.startsWith("http") ? window.open(C, "_blank") : window.location.href = C;
        return;
      }
      let Y = C.startsWith("/") ? C : `/${C}`;
      const Q = /^\/[a-z]{2}(\/|$)/.test(Y), K = a.params.locale || a.path.split("/").filter(Boolean)[0];
      !Q && K && (Y = `/${K}${Y}`), s.push(Y);
    };
    return (C, Y) => C.variant === "hero" ? (e(), t("section", {
      key: 0,
      class: r(S.value),
      style: P(D.value)
    }, [
      o.value ? (e(), t("div", {
        key: 0,
        class: "position-absolute top-0 start-0 w-100 h-100",
        style: P(N.value)
      }, null, 4)) : u("", !0),
      l("div", {
        class: r(["container position-relative z-10 d-flex", M.value]),
        style: { minHeight: "inherit" }
      }, [
        l("div", {
          class: r(A.value),
          style: { "max-width": "760px" }
        }, [
          l("h1", {
            class: r(B.value)
          }, p(C.displayTitle || C.title), 3),
          C.subtitle || C.description ? (e(), t("p", {
            key: 0,
            class: r(y.value)
          }, p(C.subtitle || C.description), 3)) : u("", !0),
          C.CTALink && (C.shortCTA || C.fullCTA) ? (e(), t("div", $6, [
            R(O, {
              label: G(),
              onClick: F,
              size: L.value,
              severity: C.buttonStyle === "secondary" ? "secondary" : void 0,
              outlined: C.buttonStyle === "outline",
              class: "fw-semibold"
            }, null, 8, ["label", "size", "severity", "outlined"])
          ])) : u("", !0)
        ], 2)
      ], 2)
    ], 6)) : C.variant === "banner" ? (e(), t("section", {
      key: 1,
      class: r(["w-100 py-3 py-md-4 position-relative overflow-hidden", z.value]),
      style: P(D.value)
    }, [
      _.value ? (e(), t("div", {
        key: 0,
        class: "position-absolute top-0 start-0 w-100 h-100",
        style: P(T.value)
      }, null, 4)) : u("", !0),
      l("div", _6, [
        l("div", T6, [
          l("div", z6, [
            l("h3", q6, p(C.title), 1),
            C.description ? (e(), t("p", {
              key: 0,
              class: r(["mb-0 small", f.value ? "opacity-90" : "opacity-75"])
            }, p(C.description), 3)) : u("", !0)
          ]),
          l("div", j6, [
            C.CTALink && (C.shortCTA || C.fullCTA) ? (e(), W(O, {
              key: 0,
              label: C.shortCTA || C.fullCTA,
              onClick: F,
              severity: C.buttonStyle === "outline" ? "secondary" : void 0,
              outlined: C.buttonStyle === "outline"
            }, null, 8, ["label", "severity", "outlined"])) : u("", !0)
          ])
        ])
      ])
    ], 6)) : C.variant === "split" ? (e(), t("section", S6, [
      l("div", {
        class: r(["row g-0 align-items-stretch", { "flex-row-reverse": C.imagePosition === "left" }])
      }, [
        l("div", {
          class: "col-12 col-lg-6 d-flex align-items-center",
          style: P(v.value)
        }, [
          l("div", A6, [
            l("h1", {
              class: r(c.value)
            }, p(C.displayTitle || C.title), 3),
            C.subtitle || C.description ? (e(), t("p", {
              key: 0,
              class: r(["fs-5 mb-4", b.value ? "opacity-90" : "text-body-secondary"])
            }, p(C.subtitle || C.description), 3)) : u("", !0),
            C.CTALink && (C.shortCTA || C.fullCTA) ? (e(), t("div", I6, [
              R(O, {
                label: G(),
                onClick: F,
                size: L.value,
                severity: C.buttonStyle === "secondary" ? "secondary" : void 0,
                outlined: C.buttonStyle === "outline",
                class: "fw-semibold"
              }, null, 8, ["label", "size", "severity", "outlined"])
            ])) : u("", !0)
          ])
        ], 4),
        l("div", M6, [
          C.Image && C.Image.url ? (e(), t("img", {
            key: 0,
            src: C.Image.url,
            alt: C.Image.alternativeText || C.title,
            class: "w-100 h-100 object-fit-cover"
          }, null, 8, L6)) : (e(), t("div", {
            key: 1,
            class: "w-100 h-100",
            style: P(D.value)
          }, null, 4))
        ])
      ], 2)
    ])) : (e(), t("section", {
      key: 3,
      class: r([S.value, "text-center"]),
      style: P(D.value)
    }, [
      _.value ? (e(), t("div", {
        key: 0,
        class: "position-absolute top-0 start-0 w-100 h-100",
        style: P(T.value)
      }, null, 4)) : u("", !0),
      l("div", B6, [
        l("h2", {
          class: r(q.value)
        }, p(C.title), 3),
        C.description ? (e(), t("p", H6, p(C.description), 1)) : u("", !0),
        C.CTALink && (C.shortCTA || C.fullCTA) ? (e(), t("div", P6, [
          R(O, {
            label: C.shortCTA || C.fullCTA,
            onClick: F,
            size: L.value,
            severity: C.buttonStyle === "secondary" ? "secondary" : void 0,
            outlined: C.buttonStyle === "outline",
            class: "fw-semibold"
          }, null, 8, ["label", "size", "severity", "outlined"])
        ])) : u("", !0)
      ])
    ], 6));
  }
}), E6 = /* @__PURE__ */ E(N6, [["__scopeId", "data-v-f857533b"]]), U6 = {
  key: 0,
  class: "display-6 fw-bold text-center mb-4 mb-lg-5 text-surface-900"
}, V6 = /* @__PURE__ */ H({
  __name: "LayoutGrid",
  props: {
    __component: {},
    id: {},
    title: {},
    layout: { default: "3-col" },
    gap: { default: "medium" },
    containerWidth: { default: "contained" },
    equalHeight: { type: Boolean, default: !1 },
    spacing: { default: "normal" },
    Items: {}
  },
  setup(w) {
    const s = w, a = {
      compact: "py-2 py-md-3",
      normal: "py-4 py-md-5",
      airy: "py-8 py-md-10",
      spacious: "py-12 py-md-16"
    }, n = {
      "2-col": {
        defaultCols: "col-12 col-md-6"
      },
      "3-col": {
        defaultCols: "col-12 col-md-6 col-lg-4"
      },
      "4-col": {
        defaultCols: "col-12 col-sm-6 col-lg-3"
      },
      "2-col-sidebar": {
        defaultCols: "col-12 col-md-8",
        sidebarCols: "col-12 col-md-4"
      },
      masonry: {
        defaultCols: "col-12 col-md-6 col-lg-4"
      }
    }, b = {
      none: "g-0",
      small: "g-2 g-md-3",
      medium: "g-3 g-md-4",
      large: "g-4 g-md-5"
    }, v = {
      none: "gap-0",
      small: "gap-2",
      medium: "gap-3",
      large: "gap-4"
    }, c = i(() => {
      const h = {
        contained: "container",
        wide: "container-xl",
        full: "container-fluid"
      }, $ = a[s.spacing || "normal"];
      return `${h[s.containerWidth]} ${$}`;
    }), m = i(() => {
      const h = ["row"];
      return h.push(b[s.gap || "medium"]), s.equalHeight && h.push("align-items-stretch"), h.join(" ");
    }), d = i(() => `d-flex flex-column ${v[s.gap || "medium"]}`), o = i(() => `d-flex overflow-auto scrollbar-hide ${v[s.gap || "medium"]}`), f = (h, $) => {
      var x;
      return h.colSpan ? `col-12 col-md-${h.colSpan}` : s.layout === "2-col-sidebar" && $ !== void 0 ? $ === 0 ? n[s.layout].defaultCols : n[s.layout].sidebarCols || n[s.layout].defaultCols : ((x = n[s.layout]) == null ? void 0 : x.defaultCols) || "col-12 col-md-6 col-lg-4";
    };
    return (h, $) => (e(), t("section", {
      class: r(c.value)
    }, [
      h.title ? (e(), t("h2", U6, p(h.title), 1)) : u("", !0),
      h.layout === "list" ? (e(), t("div", {
        key: 1,
        class: r(d.value)
      }, [
        (e(!0), t(j, null, I(h.Items, (x) => (e(), t("div", {
          key: x.id,
          style: P(x.order ? { order: x.order } : {})
        }, [
          R(re, {
            sections: [x.content]
          }, null, 8, ["sections"])
        ], 4))), 128))
      ], 2)) : h.layout === "gallery-strip" ? (e(), t("div", {
        key: 2,
        class: r(o.value)
      }, [
        (e(!0), t(j, null, I(h.Items, (x) => (e(), t("div", {
          key: x.id,
          class: "gallery-strip-item flex-shrink-0",
          style: P(x.order ? { order: x.order } : {})
        }, [
          R(re, {
            sections: [x.content]
          }, null, 8, ["sections"])
        ], 4))), 128))
      ], 2)) : (e(), t("div", {
        key: 3,
        class: r(m.value)
      }, [
        (e(!0), t(j, null, I(h.Items, (x, _) => (e(), t("div", {
          key: x.id,
          class: r(f(x, _)),
          style: P(x.order ? { order: x.order } : {})
        }, [
          l("div", {
            class: r({ "h-100": h.equalHeight })
          }, [
            R(re, {
              sections: [x.content]
            }, null, 8, ["sections"])
          ], 2)
        ], 6))), 128))
      ], 2))
    ], 2));
  }
}), ge = /* @__PURE__ */ E(V6, [["__scopeId", "data-v-cce9b605"]]), O6 = { class: "card m-3" }, W6 = { class: "card-header" }, D6 = { class: "card-body" }, G6 = { class: "text-surface-600" }, R6 = ["id"], F6 = { class: "accordion-item" }, Y6 = { class: "accordion-header" }, K6 = ["data-bs-target"], J6 = ["id", "data-bs-parent"], Q6 = { class: "accordion-body" }, X6 = { class: "fs-xs bg-surface-100 p-2 rounded overflow-auto" }, Z6 = /* @__PURE__ */ H({
  __name: "UnknownSection",
  props: {
    componentType: {}
  },
  setup(w) {
    const s = w, a = J("accordion-" + Math.random().toString(36).substr(2, 9)), n = i(() => s.componentType || "unknown"), b = i(() => {
      const { componentType: v, ...c } = s;
      return JSON.stringify(c, null, 2);
    });
    return (v, c) => (e(), t("div", O6, [
      l("div", W6, " Unknown Section Type: " + p(n.value), 1),
      l("div", D6, [
        c[0] || (c[0] = l("div", { class: "alert alert-warning w-100 mb-3" }, " This section type is not implemented yet. ", -1)),
        l("div", G6, [
          l("div", {
            class: "accordion",
            id: a.value
          }, [
            l("div", F6, [
              l("h2", Y6, [
                l("button", {
                  class: "accordion-button collapsed",
                  type: "button",
                  "data-bs-toggle": "collapse",
                  "data-bs-target": `#collapse-${a.value}-data`
                }, " View section data ", 8, K6)
              ]),
              l("div", {
                id: `collapse-${a.value}-data`,
                class: "accordion-collapse collapse",
                "data-bs-parent": `#${a.value}`
              }, [
                l("div", Q6, [
                  l("pre", X6, p(b.value), 1)
                ])
              ], 8, J6)
            ])
          ], 8, R6)
        ])
      ])
    ]));
  }
}), ep = { class: "container" }, tp = {
  key: 0,
  class: "text-center mb-5 mx-auto",
  style: { "max-width": "720px" }
}, sp = {
  key: 0,
  class: "text-body-emphasis fw-bold mb-2"
}, lp = {
  key: 1,
  class: "lead text-body-secondary mb-0"
}, ap = { class: "process-step text-center h-100 d-flex flex-column align-items-center" }, op = { class: "process-badge-wrap position-relative mb-3" }, ip = {
  key: 0,
  class: "process-badge d-inline-flex align-items-center justify-content-center rounded-circle bg-primary text-white shadow-lg"
}, np = {
  key: 1,
  class: "fw-bold"
}, rp = {
  key: 1,
  class: "process-dot d-inline-flex align-items-center justify-content-center rounded-circle bg-body-tertiary border border text-primary"
}, cp = {
  key: 1,
  class: "process-dot-mark rounded-circle bg-primary"
}, dp = { class: "h5 fw-semibold text-body-emphasis mb-2" }, up = {
  key: 0,
  class: "text-body-secondary mb-0"
}, pp = {
  key: 2,
  class: "process-vertical mx-auto",
  style: { "max-width": "760px" }
}, fp = { class: "process-rail d-flex flex-column align-items-center flex-shrink-0" }, mp = {
  key: 0,
  class: "process-badge d-inline-flex align-items-center justify-content-center rounded-circle bg-primary text-white shadow-lg"
}, hp = {
  key: 1,
  class: "fw-bold"
}, bp = {
  key: 1,
  class: "process-dot d-inline-flex align-items-center justify-content-center rounded-circle bg-body-tertiary border border text-primary"
}, gp = {
  key: 1,
  class: "process-dot-mark rounded-circle bg-primary"
}, yp = {
  key: 2,
  class: "process-line flex-grow-1"
}, vp = { class: "pb-4 flex-grow-1" }, kp = { class: "h5 fw-semibold text-body-emphasis mb-2" }, wp = {
  key: 0,
  class: "text-body-secondary mb-0"
}, xp = /* @__PURE__ */ H({
  __name: "ProcessSteps",
  props: {
    __component: {},
    id: {},
    title: {},
    subtitle: {},
    orientation: { default: "horizontal" },
    style: { default: "numbered" },
    spacing: { default: "normal" },
    Items: {}
  },
  setup(w) {
    const s = w, a = {
      compact: "py-2 py-md-3",
      normal: "py-4 py-md-5",
      airy: "py-8 py-md-10",
      spacious: "py-12 py-md-16"
    }, n = i(() => a[s.spacing || "normal"]), b = i(() => s.Items || []), v = i(() => s.style === "plain"), c = i(() => s.style === "connected"), m = i(() => {
      const d = b.value.length;
      return d <= 1 || d === 2 ? "col-md-6" : d === 3 ? "col-md-4" : "col-md-3";
    });
    return (d, o) => (e(), t("section", {
      class: r(n.value)
    }, [
      l("div", ep, [
        d.title || d.subtitle ? (e(), t("div", tp, [
          d.title ? (e(), t("h2", sp, p(d.title), 1)) : u("", !0),
          d.subtitle ? (e(), t("p", lp, p(d.subtitle), 1)) : u("", !0)
        ])) : u("", !0),
        d.orientation === "horizontal" ? (e(), t("div", {
          key: 1,
          class: r(["row g-4 justify-content-center", { "process-connected-h": c.value }])
        }, [
          (e(!0), t(j, null, I(b.value, (f, h) => (e(), t("div", {
            key: f.id,
            class: r(["col-12", m.value])
          }, [
            l("div", ap, [
              l("div", op, [
                v.value ? (e(), t("div", rp, [
                  f.icon ? (e(), t("i", {
                    key: 0,
                    class: r(U(V)(f.icon))
                  }, null, 2)) : (e(), t("span", cp))
                ])) : (e(), t("div", ip, [
                  f.icon ? (e(), t("i", {
                    key: 0,
                    class: r(U(V)(f.icon))
                  }, null, 2)) : (e(), t("span", np, p(h + 1), 1))
                ]))
              ]),
              l("h3", dp, p(f.title), 1),
              f.description ? (e(), t("p", up, p(f.description), 1)) : u("", !0)
            ])
          ], 2))), 128))
        ], 2)) : (e(), t("div", pp, [
          (e(!0), t(j, null, I(b.value, (f, h) => (e(), t("div", {
            key: f.id,
            class: r(["process-step-v d-flex gap-3 gap-md-4", { "process-connected-v": c.value, "is-last": h === b.value.length - 1 }])
          }, [
            l("div", fp, [
              v.value ? (e(), t("div", bp, [
                f.icon ? (e(), t("i", {
                  key: 0,
                  class: r(U(V)(f.icon))
                }, null, 2)) : (e(), t("span", gp))
              ])) : (e(), t("div", mp, [
                f.icon ? (e(), t("i", {
                  key: 0,
                  class: r(U(V)(f.icon))
                }, null, 2)) : (e(), t("span", hp, p(h + 1), 1))
              ])),
              c.value && h !== b.value.length - 1 ? (e(), t("span", yp)) : u("", !0)
            ]),
            l("div", vp, [
              l("h3", kp, p(f.title), 1),
              f.description ? (e(), t("p", wp, p(f.description), 1)) : u("", !0)
            ])
          ], 2))), 128))
        ]))
      ])
    ], 2));
  }
}), Cp = /* @__PURE__ */ E(xp, [["__scopeId", "data-v-c022bd41"]]), $p = { class: "container" }, _p = {
  key: 0,
  class: "h2 fw-bold text-body-emphasis mb-4"
}, Tp = { class: "location-map location-map--full rounded-4 overflow-hidden shadow-lg border border mb-4 mb-md-5" }, zp = ["src"], qp = ["src"], jp = {
  key: 2,
  class: "location-map__placeholder bg-body-tertiary text-body-secondary"
}, Sp = { class: "text-body-emphasis fw-medium" }, Ap = { class: "row g-4" }, Ip = { class: "col-md-4" }, Mp = { class: "d-flex align-items-start gap-2 text-body-emphasis mb-0" }, Lp = { class: "text-prewrap" }, Bp = {
  key: 0,
  class: "col-md-4"
}, Hp = {
  key: 0,
  class: "d-flex align-items-center gap-2 mb-2"
}, Pp = ["href"], Np = {
  key: 1,
  class: "d-flex align-items-center gap-2 mb-0"
}, Ep = ["href"], Up = {
  key: 1,
  class: "col-md-4"
}, Vp = { class: "location-hours mb-0" }, Op = { class: "text-body-secondary fw-normal mb-0" }, Wp = { class: "text-body-emphasis fw-medium mb-0 text-end" }, Dp = {
  key: 1,
  class: "row g-4 g-lg-5 align-items-stretch"
}, Gp = { class: "location-map rounded-4 overflow-hidden shadow-lg border border h-100" }, Rp = ["src"], Fp = ["src"], Yp = {
  key: 2,
  class: "location-map__placeholder bg-body-tertiary text-body-secondary"
}, Kp = { class: "text-body-emphasis fw-medium" }, Jp = { class: "location-info h-100 d-flex flex-column justify-content-center" }, Qp = {
  key: 0,
  class: "h2 fw-bold text-body-emphasis mb-4"
}, Xp = { class: "d-flex align-items-start gap-2 text-body-emphasis fs-5 mb-3" }, Zp = { class: "text-prewrap" }, ef = {
  key: 1,
  class: "d-flex align-items-center gap-2 mb-2"
}, tf = ["href"], sf = {
  key: 2,
  class: "d-flex align-items-center gap-2 mb-0"
}, lf = ["href"], af = {
  key: 3,
  class: "mt-4 pt-4 border-top border"
}, of = { class: "location-hours mb-0" }, nf = { class: "text-body-secondary fw-normal mb-0" }, rf = { class: "text-body-emphasis fw-medium mb-0 text-end" }, cf = /* @__PURE__ */ H({
  __name: "LocationBlock",
  props: {
    __component: {},
    id: {},
    title: {},
    address: {},
    mapEmbedUrl: {},
    staticMapUrl: {},
    phone: {},
    email: {},
    hours: {},
    layout: { default: "map-right" },
    spacing: { default: "normal" }
  },
  setup(w) {
    const s = w, a = {
      compact: "py-2 py-md-3",
      normal: "py-4 py-md-5",
      airy: "py-8 py-md-10",
      spacious: "py-12 py-md-16"
    }, n = i(() => a[s.spacing || "normal"]), b = i(() => s.layout || "map-right"), v = i(() => b.value === "map-full"), c = i(() => b.value === "map-left");
    i(() => !!(s.mapEmbedUrl || s.staticMapUrl));
    const m = i(() => Array.isArray(s.hours) && s.hours.length > 0), d = i(
      () => s.mapEmbedUrl || (s.address ? `https://maps.google.com/maps?q=${encodeURIComponent(s.address)}&z=15&output=embed` : "")
    );
    return (o, f) => (e(), t("section", {
      class: r(n.value)
    }, [
      l("div", $p, [
        v.value ? (e(), t(j, { key: 0 }, [
          o.title ? (e(), t("h2", _p, p(o.title), 1)) : u("", !0),
          l("div", Tp, [
            d.value ? (e(), t("iframe", {
              key: 0,
              src: d.value,
              loading: "lazy",
              title: "Location map",
              style: { border: "0", width: "100%", height: "100%", "min-height": "420px" },
              allowfullscreen: "",
              referrerpolicy: "no-referrer-when-downgrade"
            }, null, 8, zp)) : o.staticMapUrl ? (e(), t("img", {
              key: 1,
              src: o.staticMapUrl,
              alt: "Map showing the location",
              class: "location-map__img"
            }, null, 8, qp)) : (e(), t("div", jp, [
              l("i", {
                class: r([U(V)("geo-alt"), "location-map__placeholder-icon text-primary"]),
                "aria-hidden": "true"
              }, null, 2),
              l("span", Sp, p(o.address), 1)
            ]))
          ]),
          l("div", Ap, [
            l("div", Ip, [
              f[0] || (f[0] = l("h3", { class: "h6 text-uppercase text-body-secondary fw-semibold mb-3" }, "Address", -1)),
              l("p", Mp, [
                l("i", {
                  class: r([U(V)("geo-alt"), "text-primary fs-5 lh-1 mt-1"]),
                  "aria-hidden": "true"
                }, null, 2),
                l("span", Lp, p(o.address), 1)
              ])
            ]),
            o.phone || o.email ? (e(), t("div", Bp, [
              f[1] || (f[1] = l("h3", { class: "h6 text-uppercase text-body-secondary fw-semibold mb-3" }, "Contact", -1)),
              o.phone ? (e(), t("p", Hp, [
                l("i", {
                  class: r([U(V)("telephone"), "text-primary fs-5 lh-1"]),
                  "aria-hidden": "true"
                }, null, 2),
                l("a", {
                  href: "tel:" + o.phone,
                  class: "location-link text-body-emphasis"
                }, p(o.phone), 9, Pp)
              ])) : u("", !0),
              o.email ? (e(), t("p", Np, [
                l("i", {
                  class: r([U(V)("envelope"), "text-primary fs-5 lh-1"]),
                  "aria-hidden": "true"
                }, null, 2),
                l("a", {
                  href: "mailto:" + o.email,
                  class: "location-link text-body-emphasis text-break"
                }, p(o.email), 9, Ep)
              ])) : u("", !0)
            ])) : u("", !0),
            m.value ? (e(), t("div", Up, [
              f[2] || (f[2] = l("h3", { class: "h6 text-uppercase text-body-secondary fw-semibold mb-3" }, "Opening hours", -1)),
              l("dl", Vp, [
                (e(!0), t(j, null, I(o.hours, (h, $) => (e(), t("div", {
                  key: $,
                  class: "d-flex justify-content-between gap-3 py-1 border-bottom border"
                }, [
                  l("dt", Op, p(h.day), 1),
                  l("dd", Wp, p(h.hours), 1)
                ]))), 128))
              ])
            ])) : u("", !0)
          ])
        ], 64)) : (e(), t("div", Dp, [
          l("div", {
            class: r(["col-lg-6", c.value ? "order-lg-1" : "order-lg-2"])
          }, [
            l("div", Gp, [
              o.mapEmbedUrl ? (e(), t("iframe", {
                key: 0,
                src: o.mapEmbedUrl,
                loading: "lazy",
                title: "Location map",
                style: { border: "0", width: "100%", height: "100%", "min-height": "360px" },
                allowfullscreen: "",
                referrerpolicy: "no-referrer-when-downgrade"
              }, null, 8, Rp)) : o.staticMapUrl ? (e(), t("img", {
                key: 1,
                src: o.staticMapUrl,
                alt: "Map showing the location",
                class: "location-map__img"
              }, null, 8, Fp)) : (e(), t("div", Yp, [
                l("i", {
                  class: r([U(V)("geo-alt"), "location-map__placeholder-icon text-primary"]),
                  "aria-hidden": "true"
                }, null, 2),
                l("span", Kp, p(o.address), 1)
              ]))
            ])
          ], 2),
          l("div", {
            class: r(["col-lg-6", c.value ? "order-lg-2" : "order-lg-1"])
          }, [
            l("div", Jp, [
              o.title ? (e(), t("h2", Qp, p(o.title), 1)) : u("", !0),
              l("p", Xp, [
                l("i", {
                  class: r([U(V)("geo-alt"), "text-primary lh-1 mt-1"]),
                  "aria-hidden": "true"
                }, null, 2),
                l("span", Zp, p(o.address), 1)
              ]),
              o.phone ? (e(), t("p", ef, [
                l("i", {
                  class: r([U(V)("telephone"), "text-primary fs-5 lh-1"]),
                  "aria-hidden": "true"
                }, null, 2),
                l("a", {
                  href: "tel:" + o.phone,
                  class: "location-link text-body-emphasis"
                }, p(o.phone), 9, tf)
              ])) : u("", !0),
              o.email ? (e(), t("p", sf, [
                l("i", {
                  class: r([U(V)("envelope"), "text-primary fs-5 lh-1"]),
                  "aria-hidden": "true"
                }, null, 2),
                l("a", {
                  href: "mailto:" + o.email,
                  class: "location-link text-body-emphasis text-break"
                }, p(o.email), 9, lf)
              ])) : u("", !0),
              m.value ? (e(), t("div", af, [
                f[3] || (f[3] = l("h3", { class: "h6 text-uppercase text-body-secondary fw-semibold mb-3" }, "Opening hours", -1)),
                l("dl", of, [
                  (e(!0), t(j, null, I(o.hours, (h, $) => (e(), t("div", {
                    key: $,
                    class: "d-flex justify-content-between gap-3 py-1 border-bottom border"
                  }, [
                    l("dt", nf, p(h.day), 1),
                    l("dd", rf, p(h.hours), 1)
                  ]))), 128))
                ])
              ])) : u("", !0)
            ])
          ], 2)
        ]))
      ])
    ], 2));
  }
}), df = /* @__PURE__ */ E(cf, [["__scopeId", "data-v-8f3bc13a"]]), uf = { class: "container" }, pf = {
  key: 0,
  class: "quote-narrow mx-auto text-center"
}, ff = { class: "blockquote mb-0" }, mf = { class: "quote-text fs-2 fw-medium text-body-emphasis mb-0" }, hf = {
  key: 0,
  class: "d-flex align-items-center justify-content-center gap-3 mt-4"
}, bf = ["src", "alt"], gf = { class: "text-start" }, yf = {
  key: 0,
  class: "d-block fw-semibold text-body-emphasis"
}, vf = {
  key: 1,
  class: "d-block text-body-secondary small"
}, kf = {
  key: 1,
  class: "row align-items-center g-4 g-md-5"
}, wf = {
  key: 0,
  class: "col-md-5"
}, xf = ["src", "alt"], Cf = { class: "blockquote mb-0" }, $f = { class: "quote-text fs-3 fw-medium text-body-emphasis mb-0" }, _f = {
  key: 0,
  class: "mt-4"
}, Tf = {
  key: 0,
  class: "d-block fw-semibold text-body-emphasis"
}, zf = {
  key: 1,
  class: "d-block text-body-secondary small"
}, qf = {
  key: 2,
  class: "quote-panel bg-body-tertiary rounded-4 shadow-lg p-4 p-md-5"
}, jf = { class: "blockquote mb-0" }, Sf = { class: "quote-text display-6 fw-medium text-body-emphasis mb-0" }, Af = {
  key: 0,
  class: "d-flex align-items-center gap-3 mt-4 pt-2"
}, If = ["src", "alt"], Mf = {
  key: 0,
  class: "d-block fw-semibold text-body-emphasis"
}, Lf = {
  key: 1,
  class: "d-block text-body-secondary small"
}, Bf = /* @__PURE__ */ H({
  __name: "QuoteSection",
  props: {
    __component: {},
    id: {},
    quote: {},
    author: {},
    role: {},
    company: {},
    image: {},
    variant: { default: "centered" },
    spacing: { default: "normal" }
  },
  setup(w) {
    const s = w, a = (m) => m || "", n = {
      compact: "py-2 py-md-3",
      normal: "py-4 py-md-5",
      airy: "py-8 py-md-10",
      spacious: "py-12 py-md-16"
    }, b = i(() => n[s.spacing || "normal"]), v = i(
      () => !!(s.author || s.role || s.company)
    ), c = i(() => [s.role, s.company].filter(Boolean).join(", "));
    return (m, d) => {
      var o, f, h, $, x, _;
      return e(), t("section", {
        class: r(b.value)
      }, [
        l("div", uf, [
          s.variant === "centered" ? (e(), t("div", pf, [
            d[0] || (d[0] = l("span", {
              class: "quote-mark d-block text-primary",
              "aria-hidden": "true"
            }, "“", -1)),
            l("blockquote", ff, [
              l("p", mf, p(s.quote), 1)
            ]),
            v.value ? (e(), t("figcaption", hf, [
              s.image ? (e(), t("img", {
                key: 0,
                class: "quote-avatar rounded-circle flex-shrink-0",
                src: a((o = s.image) == null ? void 0 : o.url),
                alt: ((f = s.image) == null ? void 0 : f.alternativeText) || s.author || ""
              }, null, 8, bf)) : u("", !0),
              l("span", gf, [
                s.author ? (e(), t("span", yf, p(s.author), 1)) : u("", !0),
                c.value ? (e(), t("span", vf, p(c.value), 1)) : u("", !0)
              ])
            ])) : u("", !0)
          ])) : s.variant === "side-image" ? (e(), t("div", kf, [
            s.image ? (e(), t("div", wf, [
              l("img", {
                class: "quote-side-img w-100 rounded-4 shadow-lg",
                src: a((h = s.image) == null ? void 0 : h.url),
                alt: (($ = s.image) == null ? void 0 : $.alternativeText) || s.author || ""
              }, null, 8, xf)
            ])) : u("", !0),
            l("div", {
              class: r(s.image ? "col-md-7" : "col-12")
            }, [
              d[1] || (d[1] = l("span", {
                class: "quote-mark d-block text-primary lh-1 mb-2",
                "aria-hidden": "true"
              }, "“", -1)),
              l("blockquote", Cf, [
                l("p", $f, p(s.quote), 1)
              ]),
              v.value ? (e(), t("figcaption", _f, [
                s.author ? (e(), t("span", Tf, p(s.author), 1)) : u("", !0),
                c.value ? (e(), t("span", zf, p(c.value), 1)) : u("", !0)
              ])) : u("", !0)
            ], 2)
          ])) : (e(), t("div", qf, [
            d[2] || (d[2] = l("span", {
              class: "quote-mark quote-mark-lg d-block text-primary lh-1 mb-2",
              "aria-hidden": "true"
            }, "“", -1)),
            l("blockquote", jf, [
              l("p", Sf, p(s.quote), 1)
            ]),
            v.value ? (e(), t("figcaption", Af, [
              s.image ? (e(), t("img", {
                key: 0,
                class: "quote-avatar rounded-circle flex-shrink-0",
                src: a((x = s.image) == null ? void 0 : x.url),
                alt: ((_ = s.image) == null ? void 0 : _.alternativeText) || s.author || ""
              }, null, 8, If)) : u("", !0),
              l("span", null, [
                s.author ? (e(), t("span", Mf, p(s.author), 1)) : u("", !0),
                c.value ? (e(), t("span", Lf, p(c.value), 1)) : u("", !0)
              ])
            ])) : u("", !0)
          ]))
        ])
      ], 2);
    };
  }
}), Hf = /* @__PURE__ */ E(Bf, [["__scopeId", "data-v-8a201f0a"]]), Pf = { class: "container" }, Nf = {
  key: 0,
  class: "text-center text-body-secondary text-uppercase logo-strip-title mb-4 mb-md-5"
}, Ef = {
  key: 1,
  class: "d-flex flex-wrap justify-content-center align-items-center gap-4 gap-md-5"
}, Uf = ["src", "alt"], Vf = {
  key: 2,
  class: "marquee-wrapper"
}, Of = { class: "marquee-track align-items-center" }, Wf = ["src", "alt"], Df = /* @__PURE__ */ H({
  __name: "LogoStrip",
  props: {
    __component: {},
    id: {},
    title: {},
    logos: {},
    variant: { default: "static" },
    grayscale: { type: Boolean, default: !0 },
    spacing: { default: "normal" }
  },
  setup(w) {
    const s = (m) => m || "", a = w, n = {
      compact: "py-2 py-md-3",
      normal: "py-4 py-md-5",
      airy: "py-8 py-md-10",
      spacious: "py-12 py-md-16"
    }, b = i(() => n[a.spacing || "normal"]), v = i(() => a.grayscale ? "logo-img logo-grayscale" : "logo-img"), c = i(() => [...a.logos || [], ...a.logos || []]);
    return (m, d) => (e(), t("section", {
      class: r([b.value, "bg-body-tertiary"])
    }, [
      l("div", Pf, [
        m.title ? (e(), t("p", Nf, p(m.title), 1)) : u("", !0),
        m.variant === "static" ? (e(), t("div", Ef, [
          (e(!0), t(j, null, I(m.logos, (o, f) => (e(), t("img", {
            key: f,
            src: s(o.url),
            alt: o.alternativeText,
            class: r(v.value)
          }, null, 10, Uf))), 128))
        ])) : (e(), t("div", Vf, [
          l("div", Of, [
            (e(!0), t(j, null, I(c.value, (o, f) => (e(), t("img", {
              key: f,
              src: s(o.url),
              alt: o.alternativeText,
              class: r(v.value),
              "aria-hidden": "false"
            }, null, 10, Wf))), 128))
          ])
        ]))
      ])
    ], 2));
  }
}), Gf = /* @__PURE__ */ E(Df, [["__scopeId", "data-v-5a48d170"]]), Rf = { class: "container" }, Ff = {
  key: 0,
  class: "text-center mb-5"
}, Yf = {
  key: 0,
  class: "fw-bold text-body-emphasis mb-2"
}, Kf = {
  key: 1,
  class: "lead text-body-secondary mb-2"
}, Jf = {
  key: 2,
  class: "text-body-secondary d-block"
}, Qf = { class: "row justify-content-center align-items-stretch g-4" }, Xf = {
  key: 0,
  class: "pricing-badge badge bg-primary text-white rounded-pill px-3 py-2"
}, Zf = { class: "h4 fw-bold text-body-emphasis mb-2" }, em = { class: "d-flex align-items-baseline mb-3" }, tm = { class: "display-6 fw-bold text-body-emphasis" }, sm = {
  key: 0,
  class: "ms-1 text-body-secondary small"
}, lm = {
  key: 1,
  class: "text-body-secondary mb-4"
}, am = { class: "list-unstyled mb-4 d-flex flex-column gap-2" }, om = { class: "text-body-emphasis" }, im = { class: "mt-auto" }, nm = /* @__PURE__ */ H({
  __name: "PricingTable",
  props: {
    __component: {},
    id: {},
    title: {},
    subtitle: {},
    billingNote: {},
    layout: { default: "3-col" },
    Items: {},
    spacing: { default: "normal" }
  },
  setup(w) {
    const s = w, a = Z(), n = (m) => {
      m && (/^(https?:|mailto:|tel:)/.test(m) ? window.open(m, "_blank") : a.push(m));
    }, b = {
      compact: "py-2 py-md-3",
      normal: "py-4 py-md-5",
      airy: "py-8 py-md-10",
      spacious: "py-12 py-md-16"
    }, v = i(() => b[s.spacing || "normal"]), c = i(
      () => s.layout === "2-col" ? "col-12 col-md-6" : "col-12 col-md-6 col-lg-4"
    );
    return (m, d) => (e(), t("section", {
      class: r(v.value)
    }, [
      l("div", Rf, [
        m.title || m.subtitle || m.billingNote ? (e(), t("div", Ff, [
          m.title ? (e(), t("h2", Yf, p(m.title), 1)) : u("", !0),
          m.subtitle ? (e(), t("p", Kf, p(m.subtitle), 1)) : u("", !0),
          m.billingNote ? (e(), t("small", Jf, p(m.billingNote), 1)) : u("", !0)
        ])) : u("", !0),
        l("div", Qf, [
          (e(!0), t(j, null, I(m.Items, (o) => (e(), t("div", {
            key: o.id,
            class: r(c.value)
          }, [
            l("div", {
              class: r(["pricing-card bg-white border rounded-4 p-4 d-flex flex-column h-100 position-relative", o.highlighted ? "border-2 border-primary shadow-lg pricing-featured" : "border"])
            }, [
              o.badge ? (e(), t("span", Xf, p(o.badge), 1)) : u("", !0),
              l("h3", Zf, p(o.name), 1),
              l("div", em, [
                l("span", tm, p(o.price), 1),
                o.period ? (e(), t("span", sm, p(o.period), 1)) : u("", !0)
              ]),
              o.description ? (e(), t("p", lm, p(o.description), 1)) : u("", !0),
              l("ul", am, [
                (e(!0), t(j, null, I(o.features, (f, h) => (e(), t("li", {
                  key: h,
                  class: "d-flex align-items-start"
                }, [
                  d[0] || (d[0] = l("i", { class: "bi bi-check-lg text-primary me-2 flex-shrink-0" }, null, -1)),
                  l("span", om, p(f), 1)
                ]))), 128))
              ]),
              l("div", im, [
                R(O, {
                  class: "w-100",
                  label: o.ctaText || "Choose plan",
                  severity: o.highlighted ? "primary" : "secondary",
                  onClick: () => n(o.ctaLink)
                }, null, 8, ["label", "severity", "onClick"])
              ])
            ], 2)
          ], 2))), 128))
        ])
      ])
    ], 2));
  }
}), rm = /* @__PURE__ */ E(nm, [["__scopeId", "data-v-e91ebbd2"]]), cm = { class: "container" }, dm = {
  key: 0,
  class: "text-center mb-5"
}, um = {
  key: 0,
  class: "fw-bold text-body-emphasis mb-2"
}, pm = {
  key: 1,
  class: "lead text-body-secondary mb-0"
}, fm = {
  key: 1,
  class: "row g-4 g-md-5"
}, mm = { class: "menu-category" }, hm = { class: "menu-category-title text-body-emphasis border" }, bm = { class: "menu-items list-unstyled mb-0" }, gm = { class: "d-flex justify-content-between align-items-baseline gap-2" }, ym = { class: "menu-item-name fw-semibold text-body-emphasis" }, vm = {
  key: 0,
  class: "menu-item-price fw-semibold text-nowrap text-body-emphasis"
}, km = {
  key: 0,
  class: "menu-item-desc small text-body-secondary mb-0 mt-1"
}, wm = {
  key: 1,
  class: "mt-1"
}, xm = {
  key: 2,
  class: "menu-narrow mx-auto"
}, Cm = { class: "menu-category-title text-body-emphasis border" }, $m = { class: "menu-items list-unstyled mb-0" }, _m = { class: "d-flex justify-content-between align-items-baseline gap-2" }, Tm = { class: "menu-item-name fw-semibold text-body-emphasis" }, zm = {
  key: 0,
  class: "menu-item-price fw-semibold text-nowrap text-body-emphasis"
}, qm = {
  key: 0,
  class: "menu-item-desc small text-body-secondary mb-0 mt-1"
}, jm = {
  key: 1,
  class: "mt-1"
}, Sm = /* @__PURE__ */ H({
  __name: "MenuList",
  props: {
    __component: {},
    id: {},
    title: {},
    subtitle: {},
    layout: { default: "single" },
    categories: {},
    spacing: { default: "normal" }
  },
  setup(w) {
    const s = w, a = {
      compact: "py-2 py-md-3",
      normal: "py-4 py-md-5",
      airy: "py-8 py-md-10",
      spacious: "py-12 py-md-16"
    }, n = i(() => a[s.spacing || "normal"]), b = i(() => s.layout === "two-col");
    return (v, c) => (e(), t("section", {
      class: r(n.value)
    }, [
      l("div", cm, [
        v.title || v.subtitle ? (e(), t("header", dm, [
          v.title ? (e(), t("h2", um, p(v.title), 1)) : u("", !0),
          v.subtitle ? (e(), t("p", pm, p(v.subtitle), 1)) : u("", !0)
        ])) : u("", !0),
        b.value ? (e(), t("div", fm, [
          (e(!0), t(j, null, I(v.categories, (m) => (e(), t("div", {
            key: m.id,
            class: "col-12 col-md-6"
          }, [
            l("div", mm, [
              l("h3", hm, p(m.name), 1),
              l("ul", bm, [
                (e(!0), t(j, null, I(m.items, (d) => (e(), t("li", {
                  key: d.id,
                  class: "menu-item"
                }, [
                  l("div", gm, [
                    l("span", ym, p(d.name), 1),
                    c[0] || (c[0] = l("span", {
                      class: "menu-leader",
                      "aria-hidden": "true"
                    }, null, -1)),
                    d.price ? (e(), t("span", vm, p(d.price), 1)) : u("", !0)
                  ]),
                  d.description ? (e(), t("p", km, p(d.description), 1)) : u("", !0),
                  d.tags && d.tags.length ? (e(), t("div", wm, [
                    (e(!0), t(j, null, I(d.tags, (o, f) => (e(), t("span", {
                      key: f,
                      class: "badge rounded-pill text-bg-light me-1"
                    }, p(o), 1))), 128))
                  ])) : u("", !0)
                ]))), 128))
              ])
            ])
          ]))), 128))
        ])) : (e(), t("div", xm, [
          (e(!0), t(j, null, I(v.categories, (m) => (e(), t("div", {
            key: m.id,
            class: "menu-category"
          }, [
            l("h3", Cm, p(m.name), 1),
            l("ul", $m, [
              (e(!0), t(j, null, I(m.items, (d) => (e(), t("li", {
                key: d.id,
                class: "menu-item"
              }, [
                l("div", _m, [
                  l("span", Tm, p(d.name), 1),
                  c[1] || (c[1] = l("span", {
                    class: "menu-leader",
                    "aria-hidden": "true"
                  }, null, -1)),
                  d.price ? (e(), t("span", zm, p(d.price), 1)) : u("", !0)
                ]),
                d.description ? (e(), t("p", qm, p(d.description), 1)) : u("", !0),
                d.tags && d.tags.length ? (e(), t("div", jm, [
                  (e(!0), t(j, null, I(d.tags, (o, f) => (e(), t("span", {
                    key: f,
                    class: "badge rounded-pill text-bg-light me-1"
                  }, p(o), 1))), 128))
                ])) : u("", !0)
              ]))), 128))
            ])
          ]))), 128))
        ]))
      ])
    ], 2));
  }
}), Am = /* @__PURE__ */ E(Sm, [["__scopeId", "data-v-a1297ac2"]]), Im = { class: "container" }, Mm = {
  key: 0,
  class: "text-center mb-5 mb-lg-6"
}, Lm = {
  key: 0,
  class: "fw-bold text-body-emphasis mb-3"
}, Bm = {
  key: 1,
  class: "lead text-body-secondary mb-0 mx-auto feature-rows-subtitle"
}, Hm = ["src", "alt"], Pm = {
  key: 1,
  class: "feature-rows-icon-box rounded-4 d-flex align-items-center justify-content-center w-100"
}, Nm = { class: "feature-rows-text px-lg-3" }, Em = { class: "fw-bold text-body-emphasis mb-3" }, Um = {
  key: 1,
  class: "lead text-body-secondary mb-4"
}, Vm = /* @__PURE__ */ H({
  __name: "FeatureRows",
  props: {
    __component: {},
    id: {},
    title: {},
    subtitle: {},
    Items: {},
    spacing: { default: "normal" }
  },
  setup(w) {
    const s = w, a = Z(), n = (f) => {
      f && (/^(https?:|mailto:|tel:)/.test(f) ? window.open(f, "_blank") : a.push(f));
    }, b = (f) => f || "", v = {
      compact: "py-2 py-md-3",
      normal: "py-4 py-md-5",
      airy: "py-8 py-md-10",
      spacious: "py-12 py-md-16"
    }, c = i(() => v[s.spacing || "normal"]), m = (f, h) => f.imageSide === "left" ? !0 : f.imageSide === "right" ? !1 : h % 2 === 0, d = (f, h) => m(f, h) ? "order-lg-1" : "order-lg-2", o = (f, h) => m(f, h) ? "order-lg-2" : "order-lg-1";
    return (f, h) => (e(), t("section", {
      class: r(c.value)
    }, [
      l("div", Im, [
        f.title || f.subtitle ? (e(), t("div", Mm, [
          f.title ? (e(), t("h2", Lm, p(f.title), 1)) : u("", !0),
          f.subtitle ? (e(), t("p", Bm, p(f.subtitle), 1)) : u("", !0)
        ])) : u("", !0),
        (e(!0), t(j, null, I(f.Items, ($, x) => (e(), t("div", {
          key: $.id,
          class: r(["row align-items-center", { "mb-5 mb-lg-6": x < f.Items.length - 1 }])
        }, [
          l("div", {
            class: r(["col-12 col-lg-6 mb-4 mb-lg-0", d($, x)])
          }, [
            $.image && $.image.url ? (e(), t("img", {
              key: 0,
              src: b($.image.url),
              alt: $.image.seoAlt || $.image.alternativeText || $.title || "",
              class: "w-100 rounded-4 shadow-lg feature-rows-img",
              loading: "lazy"
            }, null, 8, Hm)) : $.icon ? (e(), t("div", Pm, [
              l("i", {
                class: r([U(V)($.icon), "feature-rows-icon-lg text-primary"]),
                "aria-hidden": "true"
              }, null, 2)
            ])) : u("", !0)
          ], 2),
          l("div", {
            class: r(["col-12 col-lg-6", o($, x)])
          }, [
            l("div", Nm, [
              $.icon ? (e(), t("i", {
                key: 0,
                class: r([U(V)($.icon), "feature-rows-text-icon text-primary mb-3 d-inline-block"]),
                "aria-hidden": "true"
              }, null, 2)) : u("", !0),
              l("h3", Em, p($.title), 1),
              $.description ? (e(), t("p", Um, p($.description), 1)) : u("", !0),
              $.ctaText ? (e(), W(O, {
                key: 2,
                label: $.ctaText,
                severity: "primary",
                text: !0,
                onClick: () => n($.ctaLink)
              }, null, 8, ["label", "onClick"])) : u("", !0)
            ])
          ], 2)
        ], 2))), 128))
      ])
    ], 2));
  }
}), Om = /* @__PURE__ */ E(Vm, [["__scopeId", "data-v-0007a05e"]]), X = {
  // Content sections with cms. prefix
  "cms.banner-section": Oe,
  // v1.0.0 (legacy)
  "cms.banner-section@2.0.0": v6,
  // v2.0.0 (consolidated) - version-based mapping
  "cms.announcement-banner": n6,
  // v1 (new)
  "cms.flex-section": ge,
  // Consolidated: FlexSection → LayoutGrid
  "cms.card-section": hd,
  "cms.text-section": ct,
  "cms.accordion-section": Cd,
  "cms.accordion-section-v2": Ad,
  "cms.accordion-v3": Ed,
  "cms.thank-you-section": l6,
  // Utility components with cms. prefix (aligned with backend)
  "cms.contact-form": au,
  "cms.gallery-nav": Wu,
  "cms.image-gallery": Nu,
  // Bootstrap-based components (v4+)
  "cms.banner-v4": E6,
  "cms.layout-grid": ge,
  // Diversity-roadmap components (Lever A)
  "cms.process-steps": Cp,
  "cms.location-block": df,
  "cms.quote": Hf,
  "cms.logo-strip": Gf,
  "cms.pricing": rm,
  "cms.menu-list": Am,
  "cms.feature-rows": Om
}, re = /* @__PURE__ */ H({
  __name: "SectionBuilder",
  props: {
    sections: {},
    gap: {}
  },
  setup(w) {
    const s = w, a = i(() => ({
      compact: "gap-6 gap-md-8 gap-lg-10",
      normal: "gap-12 gap-md-16 gap-lg-20",
      airy: "gap-16 gap-md-20 gap-lg-24",
      spacious: "gap-20 gap-md-24 gap-lg-24"
    })[s.gap || "normal"]), {
      transformComponentProps: n,
      isVersionSupported: b,
      getVersionWarnings: v
    } = Te(), c = i(() => s.sections.filter((o) => o && o.__component).map((o) => (b(o) || console.warn(`Unsupported component version for ${o.__component}`), process.env.NODE_ENV === "development" && v(o).forEach((h) => console.warn(h)), n(o)))), m = (o) => {
      const f = o.__component, h = o.schemaVersion || "1.0.0", $ = `${f}@${h}`;
      return X[$] ? X[$] : X[f] || Z6;
    }, d = (o) => o;
    return (o, f) => c.value.length === 1 ? (e(), W(te(m(c.value[0])), oe({
      key: `${c.value[0].__component}-${c.value[0].id || 0}`
    }, d(c.value[0])), null, 16)) : (e(), t("div", {
      key: 1,
      class: r(["sections d-flex flex-column", a.value])
    }, [
      (e(!0), t(j, null, I(c.value, (h, $) => (e(), W(te(m(h)), oe({
        key: `${h.__component}-${h.id || $}`
      }, { ref_for: !0 }, d(h)), null, 16))), 128))
    ], 2));
  }
});
function Jm() {
  return Object.keys(X);
}
function Qm(w) {
  return X[w];
}
function Xm(w) {
  return w in X;
}
const Zm = {
  version: "1.0.0",
  generatedAt: (/* @__PURE__ */ new Date()).toISOString(),
  componentCount: Object.keys(X).length,
  description: "Central component registry for AannemerPlus monorepo"
}, Wm = Symbol("theme-config");
function e2() {
  const w = ue(Wm);
  return {
    currentTheme: i(() => (w == null ? void 0 : w.value) || "default"),
    availableThemes: ["default"]
  };
}
export {
  Rm as AssetImage,
  O as BootstrapButton,
  Fm as ComponentVersions,
  Ym as CurrentSchemaVersions,
  we as SITE_CONFIG_KEY,
  re as SectionBuilder,
  Wm as THEME_CONFIG_KEY,
  X as componentMap,
  Qm as getComponent,
  Jm as getRegisteredComponentTypes,
  V as iconBootstrapClass,
  Xm as isComponentRegistered,
  Zm as registryMetadata,
  Te as useComponentVersion,
  De as useHtmlParser,
  Km as useSiteColors,
  e2 as useTheme
};
